import React, { useState, useEffect, useCallback, useLayoutEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import Popover from '@mui/material/Popover';
import { IoStarSharp } from "react-icons/io5";
// import { styled } from '@mui/material/styles';
// import Iconify from '../../../components/iconify';
import { Helmet } from 'react-helmet-async';
import CircularProgress from '@mui/material/CircularProgress';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl, { useFormControl } from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//   import image from '../../public/assets/visaversa.png'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { PDFDocument } from "pdf-lib";
import { Icon } from '@iconify/react';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';

import moment from 'moment';
import {
  Input,
  Slide,
  IconButton,
  ClickAwayListener,
  InputBase,
  Typography,
  Table,
  Button,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stack,
  Modal,
  Box,
  TextField,
  Divider,
  Grid,
  MenuItem,
  InputLabel,
  Select,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  InputAdornment,
  useTheme,
  Switch, Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  Avatar,
  Badge,
  Skeleton,Chip
} from '@mui/material';

import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';

import { FaStar } from "react-icons/fa6";

import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';
import { Document, Page, pdfjs } from 'react-pdf';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CustomComplete from '../components/customComplete/CustomComplete';
import CustomCompleteWorksheet from '../components/customComplete/CustomCompleteWorksheet';
import Iconify from '../components/iconify';
// import Upload from '../components/upload';   
import Scrollbar from '../components/scrollbar/Scrollbar';
import countries from './countryJson/countryJson.json';
import MyCustomUploadAdapterPlugin from './customEditor/customEditor';
import { Api, UploadFile } from '../webservices';

pdfjs.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.7.570/pdf_viewer.js.map';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
  };
}
const tablebg = 'rgba(82, 130, 190, 0.08)';
const filter = createFilterOptions();
function Worksheet(props) {

  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  function MyFormHelperText() {
    const { onFilled } = useFormControl() || {};
    const helperText = React.useMemo(() => {
      if (onFilled) {
        return 'This field is being onFilled';
      }

      return 'Helper text11';
    }, [onFilled]);

    return <FormHelperText>{helperText}</FormHelperText>;
  }

  const [open1, setOpen1] = useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const [pages, setPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [askill, setAskill] = React.useState(null);
  const [finallst, setFinallst] = React.useState([]);
  const [tableData, setTableData] = useState([]);
  const [row, setRow] = useState([]);
  // console.log("!!!!!!!!!!!!!!!!!!!!========", row)
  const [resumee, setResumee] = useState([])
  const [autocompleteValues, setAutocompleteValues] = useState([]);
  const [evalid, setEvalid] = useState(true);
  const [dupemail, setDupemail] = useState(false);
  const [tempskill, setTempskill] = useState([]);
  const [cityerr, setCityerr] = useState(false);
  const [joblst, setJoblst] = useState([]);
  // console.log("joblst", joblst)
  const [cityAndZip, setCityAndZip] = useState([]);
  const [cityandstate, setCityandstate] = useState({});

  const [parse, setParse] = useState(false);
  const parseOpen = () => setParse(true);
  const parseClose = () => setParse(false);

  const [tempList, setTempList] = useState([])
  const [searchResult, setSearchResult] = React.useState();
  const [emails, getEmails] = useState([]);
  // console.log("=============emails", emails)
  // console.log("resumee===>>>", resumee)
  const [value, setValue] = useState({
    email: '',
    name: '',
    jobtitle: '',
    currCompany: '',
    phone: '',
    visa: '',
    tax: '',
    linkedinUrl: '',
    comType: '',
    expectedCom: '',
    jobid: '',
    city: '',
    zip: '',
    reloc: '',
    notes: '',
    fcity: '',
    scode: '',
    country: localStorage.getItem("country"),
    userStatus: '',
    secondaryEmail:'',
     secondaryPhone:''
  });

  // console.log("value.country", value.country)
  const [newcv, setNewcv] = useState('no')
  const [cityy, setCityy] = useState('');
  const [statee, setStatee] = useState('');
  const [skill, setSkill] = useState([{ title: 'zashi' }]);
  const [pdffile, setPdffile] = useState(null);
  const [docfile, setDocfile] = useState('');
  const [docval, setDocval] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [choosefile, setChoosefile] = useState(false);
  const [mainTab, setMainTab] = useState('recruiter');




  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);





  const visalist = [
    { label: 'USC' },
    { label: 'GC' },
    { label: 'GCEAD' },
    { label: 'TN' },
    { label: 'H1B' },
    { label: 'H1b I 140 ' },
    { label: 'H4 EAD' },
    { label: 'OPT EAD' },
    { label: 'CPT EAD' },
    { label: 'E2 Visa' },
    { label: 'B 1 Visa' },
    { label: 'Canadian citizen' },
    { label: 'Open work permit' },
    { label: 'Permanent Resident' },
  ];

  const [emailerr, setEmailerr] = useState(false);
  const [nameerr, setNameerr] = useState(false);
  const [jobterr, setJobterr] = useState(false);

  // const handlePage = (event, value) => {
  //   // console.log(value)

  //   setPageNumber(value);
  //   if (valuee === 'worksheet') {
  //     getResume(value)
  //   } else if (valuee === 'favourites') {
  //     getFav(value) 
  //   } else {
  //     handleChange(valuee, value)
  //   }
  // };

  const [valuee, setValuee] = React.useState('worksheet');

  // useLayoutEffect(() => {
     
  //   console.log("usepayouthookreturn====>>>", location.state);

  //   if (location.state) {
  //     setValuee(location.state);
  //     handleChange(location.state, '');
  //   } else {

  //          setValuee('worksheet');
  //          getResume();
           
  // }
  
  // }, [location.state]);
      const savedSearch11 = localStorage.getItem('worksheetSearchState');

useLayoutEffect(() => {
  console.log('usepayouthookreturn====>>>', location.state);

  // agar state aa rahi hai
  if (location.state) {
    setValuee(location.state);
    handleChange(location.state, '');
      // localStorage.removeItem('worksheetSearchState');


  } else {
    // localStorage ka data check karo
    const savedSearch = localStorage.getItem('worksheetSearchState');

    if (savedSearch) {
      const parsed = JSON.parse(savedSearch);

      setTableData(parsed.data || []);
      setSearchResult(parsed.count || 0);
      setPages(parsed.totalPage || 0);
      setPinned(true);
      // localStorage.removeItem('worksheetSearchState');
    } else {
      // default api call
      setValuee('worksheet');
      getResume();
    }
  }
}, [location.state]);






  const getTemplList = () => {
    const token = localStorage.getItem('token');

    Api('email/getEmailTemplateList', 'GET', '', token)
      .then((response) => {

        if (response.status === 200) {
          if (response.data.code === 200) {
            console.log("");

          } else {
            console.log("");
          }
        }
        setTempList(response.data.result);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };











  useEffect(() => {

    // setValuee('worksheet')
    // setValuee('worksheet');
    // getResume();
    getTemplList()
    getSkills();
    GetJobId();
  }, []);

  const [tableCount, setTableCount] = useState([])

  // console.log("tableCount", tableCount) 

  const [dataLoading, setDataLoading] = useState(false)

  const openLoadingData = () => {
    setDataLoading(true)
  }

  const closeLoadingData = () => {
    setDataLoading(false)
  }

  const [loadingTab, setLoadingTab] = useState(false)

  const handleChange = (newValue, value) => {
    console.log("handleChange called =>", newValue);
    setLoadingTab(true)
    // openLoadingData()
    setValuee(newValue);
    setTableData([]);
    setLoading("Loading...")
    setToggleButton(false)
    setTableCount([])
    const body = {
      "status": newValue,
      "page": value || 1,
      "limit": "35"
    }
    const token = localStorage.getItem('token');
    Api(`resume/resume_by_status`, 'POST', body, token)
      .then((response) => {
        // console.log('=========getCompany======>>>>>>>', response.data.message)
        if (response.status === 200) {
          if (response.data.code === 200) {
            setLoading("")
            setTableCount(response.data.count)
            if (response.data.data.length !== 0) {
              // setRow(response.data.data[0]);
              setTableData(response.data.data || 0);

              const totalPage = Math.ceil(response.data?.count / 35)
              setPages(totalPage)
              closeLoadingData()
              // console.log('======resume_by_status======>>>>>>>', response.data.data);
              setLoadingTab(false)
            } else {
              setLoading("No Data Found")
              closeLoadingData()
              setTableData([]);
              setLoadingTab(false)
            }
          } else {
            setLoading("No Data Found")
            closeLoadingData()
            setTableData([]);
            setLoadingTab(false)
          }
        } else {
          toast.warn(response.data.message, +'!');
          closeLoadingData()
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const adminrole = useSelector((state) => state?.userData?.data?.role);
  const cities = [];

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '95%', sm: '70%' },
    // width: { xs: '85%', sm: '60%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const styleLoading = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: { xs: '95%', sm: '70%' },
    // width: { xs: '85%', sm: '60%' },
    bgcolor: 'background.paper',
    // border: '3px solid #3C6BA5',
    // boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#3366FF',
    // backgroundColor: 'secondary',
    ...theme.typography.button,
    padding: theme.spacing(0.5),
    // textAlign: 'center',
    color: 'white',
  }));

  const delfile = () => {
    // console.log('doc file', docfile);
    setDocfile('');
    // setDocfile('')
    setPdffile('');
    // console.log('doc file------', docfile);
    // console.log('doc value------', docval);
  };

  const GetJobId = () => {
    const id = localStorage.getItem('userid');
    const token = localStorage.getItem('token');
    Api(`company/active_jobs`, 'GET', '', token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === 200) {
            setJoblst(response.data.data);
          }
        }
      })
      .catch((err) => { });
  };

  //  const [candiadteId, setCandidateId] = useState()
  const getResume = async (value) => {
    setLoadingTab(true)
    setValuee('worksheet');
    // openLoadingData()
    setTableData([])
    setToggleButton(false)
    setTableCount([])
    setLoading("Loading...")
    const token = localStorage.getItem('token');
    const body = {
      "page": value || 1,
      "limit": "35"
    }
    Api(`resume/get_all_resumes`, 'POST', body, token)
      .then((response) => {
        // console.log('=========get all resume======>>>>>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setLoading('')
            setTableCount(response.data.count)
            if (response.data.result.length !== 0) {
              // toast.success(response.data.message, +'!');
              setTableData(response.data.result || 0);
              // setRow(response.data.result[0]);
              // const Dataa = response.data.result;
              // const allAdditionalResumes = Dataa.map((item) => {
              //   return (
              //     {item.additionalResumes}
              //   )                                         
              // })   
              // setResumee(allAdditionalResumes);
              const totalPage = Math.ceil(response.data.count / 35)
              setPages(totalPage)
              closeLoadingData()
              // setValuee('worksheet')
              // console.log('============>>>>>>>', Math.ceil(response.data.count / 30));
              setLoadingTab(false)
            } else {
              setLoading('No Data Found')
              setTableData([]);
              closeLoadingData()
              // toast.warn('Data Not Found');
              setLoadingTab(false)
            }
          } else {
            setTableData([]);
            closeLoadingData()
            toast.warn(response.data.message);
            setLoadingTab(false)
          }
        } else {
          toast.warn(response.data.message, +'!');
          closeLoadingData()
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };


   const getHotlist = async (value,hotlistName = '') => {
    console.log("getHotlist called =>", hotlistName);
    setLoadingTab(true)
    setValuee('Hotlist');
    // openLoadingData()
    setTableData([])
    setToggleButton(false)
    setTableCount([])
    setLoading("Loading...")
    const token = localStorage.getItem('token');
    const body = {
      "page": value || 1,
      "limit": "35",
      search: hotlistName
    }
    Api(`resume/getHotlistsWithResumes`, 'POST', body, token)
      .then((response) => {
         console.log('Data Value is good ===>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setLoading('')
            setTableCount(response.data.count)
            if (response.data.result.length !== 0) {
              setTableData(response.data?.result[0]?.resumes);
              const totalPage = Math.ceil(response.data.count / 35)
              setPages(totalPage)
              closeLoadingData()
              setLoadingTab(false)
            } else {
              setLoading('No Data Found')
              setTableData([]);
              closeLoadingData()
              // toast.warn('Data Not Found');
              setLoadingTab(false)
            }
          } else {
            setTableData([]);
            closeLoadingData()
            toast.warn(response.data.message);
            setLoadingTab(false)
          }
        } else {
          toast.warn(response.data.message, +'!');
          closeLoadingData()
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const getFav = async () => {
    setLoadingTab(true)
    // openLoadingData()
    setToggleButton(false)
    setTableCount([])
    setTableData([])
    setLoading("Loading...")
    const token = localStorage.getItem('token');
    const body = {
      "page": pageNumber,
      "limit": "35"
    }
    Api(`resume/get_favourites`, 'POST', body, token)
      .then((response) => {
        // console.log('=========get all resume======>>>>>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setLoading("")
            setTableCount(response.data.count)
            if (response.data.result.length !== 0) {
              // toast.success(response.data.message, +'!');
              setTableData(response.data.result || 0);
              // setRow(response.data.result[0]);
              const totalPage = Math.ceil(response.data.count / 35)
              setPages(totalPage)
              // setValuee('worksheet')
              // console.log('============>>>>>>>', response);
              closeLoadingData()
              setLoadingTab(false)
            } else {
              setLoading("No Data Found")
              setLoadingTab(false)
              setTableData([]);
              // toast.warn('Data Not Found');
              closeLoadingData()
            }
          } else {
            setTableData([]);
            toast.warn(response.data.message);
            closeLoadingData()
            setLoadingTab(false)
          }
        } else {
          toast.warn(response.data.message, +'!');
          closeLoadingData()
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const pdfUpload = async (pdf) => {
    // console.log('=====pdf====>>>', docfile);
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', pdf);
    formData.append('directoryName', 'resume');
    UploadFile(`resume/upload_resume`, formData, token).then((Response) => {
      // console.log('=====upload Response========>', Response.data);

      if (Response.status === 200) {
        if (Response.data.code === 200) {
          setNewcv('yes')
          setChoosefile(true);
          setDocfile('');
          toast.success(Response.data.status, +'!');
          //  console.log('=====404=gst===', Response.data.message);
          setPdffile(Response.data.filePath);
        } else {
          // console.log('=====404=gst===', Response.data.message);
          toast.warn(Response.data.status, +'!');
        }
      } else {
        toast.warn('Error !');
      }
    });
  };

  const [loadingAdd, setLoadingAdd] = useState(false)








  const addcv = async (e) => {


      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Email optional hai
  if (
    value.secondaryEmail &&
    !emailRegex.test(value.secondaryEmail)
  ) {
    toast.error("Please enter a valid secondary email");
    return;
  }


    const skillLst = [];
    finallst.map((item) => {
      return skillLst?.push(item?.title?.toLowerCase());
    });
    // console.log('lst', skillLst);

    const uniqueSkillLst = [...new Set(skillLst)];

      if (value.name.trim() === "") {
    toast.error("Full Name is required");
    return;
  }

  if (value.email.trim() === "") {
    toast.error("Email is required");
    return;
  }

  
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(value.email)) {
    toast.error("Please enter valid email");
    return;
  }

  if (value.jobtitle.trim() === "") {
    toast.error("Job Title is required");
    return;
  }



    if (value.email !== '') {
      if (value.name !== '') {
        if (value.jobtitle !== '') {
          setLoadingAdd(true)
          const token = localStorage.getItem('token');
          const body = {
            "newCV": newcv,
            email: value.email,
            fullName: value.name,
            jobTitle: value?.jobtitle?.trim(),
            phone: value.phone,
            currentCompany: value.currCompany,
            skill: uniqueSkillLst,
            visaType: value.visa,
            taxTerm: value.tax,
            chargeType: value.comType,
            expectedCompensation: value.expectedCom,
            cityOrZipcode: cityandstate.city,
            state: cityandstate.state,
            linkedinUrl: value.linkedinUrl,
            reallocate: value.reloc,
            zipcode: value.zip,
            // stateCode: value.scode,
            stateCode: cityandstate.stateCode,
            resumeUrl: pdffile,
            jobId: value.jobid,
            note: value.notes,
            status: 'prospect',
            userStatus: value.userStatus,
            country: value.country,
            secondryPhoneNumber:value.secondryPhoneNumber,
            secondaryEmail:value.secondaryEmail 
          };
          // console.log('=====create_resume==========>>>>>>>', finallst);
          Api(`resume/create_resume`, 'POST', body, token)
            .then((response) => {
              // console.log('=====create_resume==========>>>>>>>', response);
              setLoadingAdd(false)
              if (response.status === 200) {
                if (response.data.code === 200) {
                  setChoosefile(false);
                  handleClose1();
                  toast.success(response.data.message, +'!');
                  setValuee('worksheet');
                  getResume();
                  setValue({
                    email: '',
                    name: '',
                    jobtitle: '',
                    currCompany: '',
                    phone: '',
                    visa: '',
                    tax: '',
                    comType: '',
                    expectedCom: '',
                    jobid: '',
                    city: '',
                    reloc: '',
                    notes: '',
                    zip: '',
                    secondryPhoneNumber:'',
                    secondaryEmail :''
                  });
                  getEmails([]);
                  setFinallst([]);
                  setCityandstate('');
                  setCityAndZip([]);
                  setDocfile();

                  setPdffile('');
                  getResume();
                  // setcityData([]);
                  setCityy('');
                  // getCompanyDetail()
                  // setTableData(response.data.data)
                } else if (response.data.code === 400) {
                  setChoosefile(false);
                  toast.warn(response.data.error, +'!');
                  setValuee('worksheet');
                  // toast.success(response.data.message, +'!');
                  handleClose1();
                  getResume();
                  setValue({
                    email: '',
                    name: '',
                    jobtitle: '',
                    currCompany: '',
                    phone: '',
                    visa: '',
                    tax: '',
                    comType: '',
                    expectedCom: '',
                    jobid: '',
                    city: '',
                    reloc: '',
                    notes: '',
                    zip: '',
                  });
                  getEmails([]);
                  setFinallst([]);
                  setCityandstate('');
                  setCityAndZip([]);
                  setDocfile();

                  setPdffile('');
                }
              } else {
                toast.warn(response.data.message, +'!');
              }
            })
            .catch((err) => {
              // console.log('===========', err);
            });
        } else {
          setJobterr('true');
        }
      } else {
        setNameerr('true');
      }
    } else {
      setEmailerr('true');
    }
  };




















  const funclick = () => {
    getResume();
  };

  const funclick2 = () => {
    setValuee('submitted');
    // setValuee('placement');
    handleChange('submitted');
    // handleChange('placement');
  };

  const fun3 = () => {
    // setValuee('favourites');
    if (valuee === 'worksheet') {
      getResume();
    } else {
      getFav();
    }
  };

  const handleEmail = (e) => {
    // console.log('======================true=====1=============>>>>>>>>>', evalid);
    emails.forEach((item) => {
      if (item === e) {
        getDataByEmail(item);
      }
    });
    setValue({ ...value, email: e });
    const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEvalid(reg.test(e));
    // setTimeout(() => {
    if (evalid === true) {
      setEmailerr(false);
      // console.log('=======email valid', evalid);
    } else {
      // console.log('=======email unvalid', evalid);
    }
    // }, 1000);
    // console.log('======================true==================>>>>>>>>>', evalid);
  };

  const [addedSkill, setAddedSkill] = useState([])
  const getSkills = async () => {
    const token = localStorage.getItem('token');
    Api(`resume/get_skills/${"other"}`, 'GET', '', token)
      .then((response) => {
        // console.log('=========getSkills======>>>>>>>', response.data);
        if (response.data.code === 200) {
          if (response.data.result.length !== 0) {
            response.data.result.map((item) => {
              return tempskill.push({ title: item.skillName });
            });
            setSkill(tempskill);
            setAddedSkill(tempskill)
            // console.log('===value skilll========', JSON.stringify(skill));
          } else {
            setSkill([{ title: '' }]);
          }
        } else {
          toast.warn(response.data.message, +'!');
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const [cityErr, setCityErr] = useState(false)
  const [err, setErr] = useState(false);
  const [helperText, setHelperText] = useState('');

  const getCity = async (val) => {
    setHelperText('')
    setErr(false)
    // console.log("value.country===>>", value.country)
    setCityAndZip([])
    const token = localStorage.getItem('token');
    const body = {
      country: value.country,
      query: val,
    };
    Api(`resume/get_city_states`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          // console.log('=========status 200======>>>>>>>', response);
          if (response.data.code === 200) {
            setCityAndZip(response.data.data);
            // setCityandstate(response.data.data[0]);

            // if (response.data.data[0].zip) {
            //   setValue({ ...value, zip: response.data.data[0].zip, scode: response.data.data[0].stateCode });
            // } else {
            //   setValue({ ...value, zip: '' });
            // }
            // console.log('=======city and State', response.data.data[0].zip);
          } else {
            // toast.error(response.data.message)
            setCityErr(true)
            setErr(true)
            setHelperText("No cities found for the given city name.")
            // setCityAndZip(response.data.data);
            // toast.error(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };

  const getDataByEmail = async (val) => {
    const token = localStorage.getItem('token');
    Api(`resume/resume_by_email/${val}`, 'GET', '', token)
      .then((response) => {
        if (response.status === 200) {
          // console.log('=========status 200======>>>>>>>', response);
          if (response.data.code === 200) {
            // console.log('getDataByemail========', response.data);
            // const abc = response.data.result.city
            // getCity(abc)
            setValue({
              ...value,
              city: response.data.result.city,
              notes: '',
              jobid: response.data.result.jobId,
              reloc: response.data.result.reallocate,
              expectedCom: response.data.result.expectedCompensation,
              tax: response.data.result.taxTerm,
              visa: response.data.result.visaType,
              currCompany: response.data.result.currentCompany,
              phone: response.data.result.phone,
              jobtitle: response.data.result.jobTitle,
              email: response.data.result.email,
              name: response.data.result.fullName,
              zip: response.data.result.zipcode,
              linkedinUrl: response.data.result.linkedinUrl,
              country: response.data.result.country,
              userStatus: response.data.result.userStatus,
            });
            setCityy(response.data.result.city);
            setPdffile(response.data.result.resumeUrl);
            setCityandstate({ ...cityandstate, city: response.data.result.city, state: response.data.result.state });
            const arr = [];
            response.data.result.skill.forEach((item) => {
              arr.push({ title: item });
            });
            setFinallst(arr);
            if (response.data.result.resumeUrl) {
              setChoosefile(true);
            }
          } else {
            // console.log('getDataByemail========', response.data);
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };

  const getEmail = async (val) => {
    const token = localStorage.getItem('token');
    Api(`resume/check_existing_mail/${val}`, 'GET', '', token)
      .then((response) => {
        if (response.status === 200) {
          // console.log('=========status 200======>>>>>>>', response);
          if (response.data.code === 200) {
            // console.log('city========', JSON.stringify(response.data));
            getEmails(response.data.data);
          } else {
            getEmails(response.data.data);
            // toast.error(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };


  const childFuc = (e) => {
    // setCityy(e);
    setCityandstate({ ...cityandstate, city: e });

    if (e.length >= 3) {
      getCity(e);
    } else if (e.length === 0) {
      setCityy('');
      setCityAndZip([]);
      setCityandstate({});
    }
  };
  // const[postal, setPostal] = useState('')
  const fullVal = (val) => {
    // setPostal(val.postal)
    // console.log("################===========", val.postal);
    setCityandstate(val);
    setCityy(val.city);
    setValue({ ...value, zip: val.zip || val.postal });
    // setValue({ ...value, city: val.city });
    // setCityy(val.city);
  };

  const childFucEmail = (e) => {
    handleEmail(e);
    if (e.length >= 3) getEmail(e);
  };

  const fullEmail = (val) => {
    // console.log(val);
    handleEmail(val);

    // setCityy(val.city);
  };

  const setContact = (e) => {
    const reg = /^[a-zA-Z]*$/;
    if (e.length) {
      const lst = e[e.length - 1];
      if (!lst.match(reg)) {
        setValue({
          ...value,
          phone: e,
        });
      }
    } else {
      setValue({
        ...value,
        phone: e,
      });
    }
  };

  const secondryPhoneNumber = (e) => {
  const reg = /^[a-zA-Z]*$/;
    if (e.length) {
      const lst = e[e.length - 1];
      if (!lst.match(reg)) {
        setValue({
          ...value,
          secondaryPhone: e,
        });
      }
    } else {
      setValue({
        ...value,
        secondaryPhone: e,
      });
    }
};

  const [rotate, setRotate] = useState()
  const [inputExcel, setInputExcel] = useState([]);
  const [fileInputFiles, setFileInputFiles] = useState([]);
  const [dragDropFiles, setDragDropFiles] = useState([]);
  // const Rotate = () =>{
  //   return (
  //     // alert("hhhh")
  //     <IconButton>
  //      <Iconify icon="eos-icons:arrow-rotate" width="3rem" color="red"/>
  //      </IconButton>
  //   )
  // } 
  const [circle, setCircle] = useState(false)

  const circleFn = () => {
    setCircle(true)
  }

  const circleFn1 = () => {
    setCircle(false)
  }



  // const handleFileSelect = async (e) => {
  //   const files = e.target.files;
  //   const fileList = Array.from(files);
   

  //   parseClose()
  //   circleFn()
   
  //   setFileInputFiles(fileList);
  

  //   try {
  //     await Promise.all(fileList?.map(async (file) => { await uploadMulti(file) }));

  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Some uploads failed!");
  //   }

  // };


  const handleFileSelect = async (e) => {  
  const fileList = Array.from(e.target.files);
  parseClose();
  circleFn();
  setFileInputFiles(fileList); 
  try {
    await Promise.all(
           fileList.map(file => uploadMulti(file)) // clean
    );
  } catch (err) {
    console.error(err);
    toast.error("Some uploads failed!");
  }
};






  const handleDrop = async (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    const fileList = Array.from(files);
    // console.log('files drop', fileList)

    setFileInputFiles(fileList);
    // fileList.map((item) => uploadMulti(item))

    try {
      await Promise.all(fileList?.map(async (file) => { await uploadMulti(file) }));
      // console.log("All resumes uploaded & parsed.");
    } catch (err) {
      console.error(err);
      toast.error("Some uploads failed!");
    }

  };

  const [pinned, setPinned] = useState(false)

    // old code 


  // const searchDataFun = (data, count, totalPage) => {
  //   setTableCount(count)
  //   setTableData([''])
  //   if (valuee !== 'worksheet') {
  //     setValuee('worksheet')
  //   }
  //   setTableData(data || 0)
  //   setSearchResult(count)
  //   setPages(totalPage)
  //   setPinned(true)
  // }

   const searchDataFun = (data, count, totalPage) => {
    setTableCount(count)
    setTableData([''])
    if (valuee !== 'worksheet') {
      setValuee('worksheet')
    }
    setTableData(data || 0)
    setSearchResult(count)
    setPages(totalPage)
    setPinned(true)
       const searchState = {
    data,
    count,
    totalPage,
  };

  localStorage.setItem(
    "worksheetSearchState",
    JSON.stringify(searchState)
  );


  }




  const [parseres, setParseRes] = useState('')


const compressFile = async (file) => {
  if (file.type !== "application/pdf") {
    return file; // DOC/DOCX same jayega
  }

  try {
    const buffer = await file.arrayBuffer();
    const pdfDoc = await PDFDocument.load(buffer);

    const compressedBytes = await pdfDoc.save({
      useObjectStreams: true,
    });

    return new File([compressedBytes], file.name, {
      type: "application/pdf",
    });
  } catch (err) {
    console.error("Compression error:", err);
    return file;
  }
};
  // const uploadMulti = async (pdf) => {
  //   return new Promise(async(resolve, reject) => {
  //     const token = localStorage.getItem('token');

 

        
  //     const formData = new FormData();
  //     formData.append('document', pdf);
  //     formData.append('directoryName', 'resume');

  //     UploadFile(`resume/upload_resume`, formData, token)
  //       .then((Response) => {
  //         if (Response.status === 200 && Response.data.code === 200) {
  //           ParseRes(Response.data.filePath);
  //           parseClose()
  //           circleFn();
  //           resolve(Response.data.filePath);       
  //         } else {
  //           reject(Response.data.message || "Upload failed");
  //         }
  //       })
  //       .catch((err) => reject(err));
  //   });
  // };
 
 
  const uploadMulti = async (pdf) => {
  const token = localStorage.getItem('token');

  //  compression laga
  const compressedFile = await compressFile(pdf);

  const formData = new FormData();

  //  IMPORTANT CHANGE (pdf → compressedFile)
  formData.append('document', compressedFile);

  formData.append('directoryName', 'resume');

  const Response = await UploadFile(`resume/upload_resume`, formData, token);

  if (Response.status === 200 && Response.data.code === 200) {
    ParseRes(Response.data.filePath);
    parseClose();
    circleFn();
    return Response.data.filePath;
  }

      throw new Error(Response.data.message || "Upload failed");
};



  const [cityStateStyling, setCityStateStyling] = useState(true)

  // const [cityStateStyling, setCityStateStyling] = useState(true)

  const ParseRes = (parseres) => {

    const body = {
      "resumeUrl": parseres
    }
    const token = localStorage.getItem("token")
    Api('common/cv/data', 'POST', body, token).then((Response) => {
      // console.log("Response", Response)
      if (Response.status === 200) {

        if (Response.data.code === 403) {
          // setCityStateStyling(true)
          setRow(Response.data.result);
          getResume();
          circleFn1();
          navigate('/resumeDetail', {
            state: {
              addedSkill,
              cityStateStyling,
              row: Response.data.result,
              kTab: "Hide",
              mtab: 'Detail',
              fTab: "submitted",
            },
          });
        } else if (Response.data.code === 200) {
          setRow(Response.data.result);
          getResume();
          circleFn1();
          navigate('/resumeDetail', {
            state: {
              addedSkill,
              row: Response.data.result,
              kTab: "Hide",
              mtab: 'Detail',
              fTab: "submitted",
            },
          });
        } else {
          circleFn1();
          // toast.warn("A resume with the same email already exists");
          setFileInputFiles([])
          toast.warn(Response.data.error);
          getResume();
        }
      } else {
        toast.warn('Error!');
        circleFn1();
      }
    })

  }





  // const handleFileSelectExcel = (e) => {
  //   const files = e.target.files;
  //   const fileList = Array.from(files);
  //   // console.log('files browse', fileList)

  //   setInputExcel(fileList);
  //   fileList.map((item) => uploadCSV(item))
  // };

  // const uploadCSV = async (csvFile) => {
  //   // alert("jjj")
  //   const token = localStorage.getItem('token');
  //   const formData = new FormData();
  //   formData.append('file', csvFile);
  //   formData.append('directoryName', 'csv');

  //   try {
  //     const response = await UploadFile('resume/add_resumes/byfile', formData, token);
  //     // alert("uuu")
  //     getResume();
  //     if (response.code === 200 && response.data.code === 200) {
  //       // alert("gf")
  //       setCityStateStyling(true)
  //       getResume();
  //       parseClose();
  //       // circleFn()
  //       setRow(response.data.result)
  //       toast.success(response.data.message);

  //       navigate('/resumeDetail', {
  //         state: {
  //           addedSkill,
  //           cityStateStyling,
  //           row: response.data.result,
  //           mtab: 'Detail',
  //           kTab: "Hide",
  //           fTab: "submitted",

  //         },
  //       })

  //     } else {
  //       toast.warn(response.data.error);
  //       parseClose();
  //     }
  //   } catch (error) {
  //     console.error('Upload failed:', error);
  //     // toast.warn('Upload failed!');
  //   }
  // };

  //   const handleFileSelectExcel = async (e) => {
  //   const files = Array.from(e.target.files);
  //   setInputExcel(files);

  //   try {
  //   await Promise.all(files.map(file => uploadCSV(file)));

  //   // console.log("All CSV uploads done:", uploadResults);

  //   } catch (error) {
  //     // console.error("Some CSV uploads failed:", error);
  //     toast.error("Some uploads failed!");
  //   }
  // };  

  const handleFileSelectExcel = async (e) => {
    const files = Array.from(e.target.files);
    setInputExcel(files);

    try {
      await Promise.all(files.map(async file => { await uploadCSV(file) }));
      // toast.success("All CSV files uploaded successfully!");
    } catch (error) {
      toast.error("Some uploads failed!");
    }
  };

  const uploadCSV = (csvFile) => {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('file', csvFile);
      formData.append('directoryName', 'csv');

      UploadFile('resume/add_resumes/byfile', formData, token)
        .then((response) => {
          if (response?.status === 200 && response?.data?.code === 200) {
            getResume();
            setCityStateStyling(true);
            parseClose();
            setRow(response.data.result);
            toast.success(response.data.message);

            resolve(response.data.result);
            navigate('/resumeDetail', {
              state: {
                   fromWorksheet: true,
                addedSkill,
                cityStateStyling,
                row: response.data.result,
                mtab: 'Detail',
                kTab: "Hide",
                fTab: "submitted",

              },
            })
          } else {
            const msg = response?.data?.error || "Upload failed";
            toast.warn(msg);
            reject(msg);
          }
        })
        .catch((error) => {
          console.error("Upload failed:", error);
          reject(error);
        });
    });
  };

  const resetDataFun = () => {
     localStorage.removeItem('worksheetSearchState');
    
    getResume();
    setPinned(false)
    // setTableCount('')
    // setToggleButton(false)
  }

  const [toggleButton, setToggleButton] = useState(false)

  const resetDataFun1 = () => { 

     localStorage.removeItem('worksheetSearchState');
    setSearchResult('')
    setTableShow(true)
    setCheckBtnDis(false)
    setHidePagin(false)

    if (valuee === "worksheet") {
      resetDataFun()
    }

    setInputValue({
      ...inputValue,
      commonSearch: "",
      jobTitle: []

    })
    setResour('')
    // setPageNumber(1)
    // setLoading(true)
    // getResume();
    // setPinned(false)
    // if(valuee === "worksheet"){
    //   getResume()
    // }
    // if(valuee === "favourites"){
    //   getFav();
    // }
    if (valuee === "placement") {
      handleChange("placement")
    }
    else if (valuee === "interview") {
      handleChange("interview")
    }
    else if (valuee === "submitted") {
      handleChange("submitted")
    }
    else if (valuee === "backout") {
      handleChange("backout")
    }
    
    // showtable()
    // setDataaa(true)
    setToggleButton(false)
    // setTableCount(['']) 
    if (valuee === "favourites") {
      getFav();
    }
    
  }

  // console.log("fileInputFiles", fileInputFiles)
  // console.log("inputExcel", inputExcel)

  const [tableShow, setTableShow] = useState(true)
  const [searchCall, setSearchCall] = useState(false)
  const hidePage = () => {
    // alert('hello')
    setTableShow(false)
    setSearchCall(true)
  }

  const showtable = () => {
    setTableShow(true)
  }

  const [loading, setLoading] = useState("")

  // useEffect(() => {
  //   allUsers()

  // }, []);

  const [pepShow, setPepShow] = useState(false)

  const hidePep = () => {
    // alert('hello')
    setPepShow(false)
  }

  const showPep = () => {
    setPepShow(true)
  }

  const [resour, setResour] = useState('')
  const [resourData, setResourData] = useState([])

  const allUsers = () => {
    const token = localStorage.getItem('token');

    const endpoint = localStorage.getItem("resource") === "resource" ? "IDP" : "RCO";

    Api(`common/users/${endpoint}`, 'GET', '', token)
      // Api('common/users/RCO', 'GET', '', token)
      .then((response) => {

        // console.log('Response:---------', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setResourData(response.data.data);
          } else {
            // console.log('Error:', response.data.message);
          }
        }
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
  };

  const handleChangeRes = (e) => {
    // allUsers()
    const resourceId = e.target.value;
    setResour(resourceId);
    setToggleButton(true)
    setDataaa(false)
  };

  const [inputValue, setInputValue] = useState({
    commonSearch: "",
    jobTitle: []
  })

  const [hidepagin, setHidePagin] = useState(true)
  const [loadingRes, setLoadingRes] = useState(false)

  const getResFav = async () => {
    setLoadingRes(true)
    setTableData([])
    setDataaa(false)
    setLoading('Loading...')
    setHidePagin(false)
    setToggleButton(true)
    setTableShow(false)
    const body = {
      // "status": valuee,
      "resource": resour || '',
      "limit": "50",
      "page": pageNumber || 1,
    }
    const token = localStorage.getItem('token');
    Api(`resume/get_favourites`, 'POST', body, token)
      .then((response) => {
        // console.log('=========get all resume======>>>>>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {

            if (response.data.result.length !== 0) {
              setSearchResult(response.data.result?.length)
              setTableData(response.data.result || 0)
              setLoadingRes(false)
              setCheckBtnDis(true)
              hidePep()
              setResour('')
              setLoading("")
              setTableCount(response.data.count)
            } else {
              setLoading("No Data Found")
              setLoadingRes(false)
              setTableData([]);
              hidePep()
              setResour('')
              // toast.warn('Data Not Found');
            }

          } else {
            setTableData([]);
            toast.warn(response.data.message);
          }
        } else {
          toast.warn(response.data.message, +'!');

        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  const searchReso = () => {
    if (valuee === "favourites") {
      getResFav()
      return
    }
    setLoadingRes(true)
    setTableData([])
    setDataaa(false)
    setLoading('Loading...')
    setHidePagin(false)
    setToggleButton(true)
    setTableShow(false)
    const body = {
      "status": valuee,
      "resource": resour || '',
      "commonSearch": inputValue.commonSearch || '',
      "jobTitle": inputValue.jobTitle || [],
      // "limit":"50"
    }

    const token = localStorage.getItem('token');
    Api('common/search/submissions', 'POST', body, token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setLoading('')
            setTableData(response.data.data || 0)
            // setRow(response.data.data[0])
            setSearchResult(response.data.data?.length)
            setLoadingRes(false)
            setCheckBtnDis(true)
            hidePep()
            setResour('')
            setInputValue({
              ...inputValue,
              commonSearch: "",
              jobTitle: []
            })
            // setResourData(response.data.data);
          } else {
            // console.log('Error:', response.data.message);
            // setLoading("No data found")
            // alert("lll")
          }
        } else {

          setLoading("No data found")
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  // useEffect(() => {
  //   if (resour !== '') {
  //     searchReso(resour);
  //   }
  // }, [resour]);


  const [data, setData] = useState(null);
  const [dataaa, setDataaa] = useState(true);
  const [checkBtnDis, setCheckBtnDis] = useState(false)

  // console.log("-----------data", data)
  const handleDataFromChild = (childData) => {
    setData(() => childData);
    if (data) {
      setDataaa(false)
    }
  };

  const searchFnRef = useRef(() => { });
  const [loadingData1, setLoadingData1] = useState('')

  const handleDataFromChild1 = (fn, loadingData) => {
    setPageNumber(1)
    setLoadingData1(loadingData)
    // console.log("Received fn:", fn);
    if (typeof fn === 'function') {
      searchFnRef.current = fn;
    } else {
      // console.error("Received fn is not a function!");
    }
  };

  const handlePage = (event, value) => {
    // console.log("Current searchFn:", searchFnRef.current);
    if (searchCall) {
      setLoading(loadingData1)
      // setPageNumber(1)
      if (typeof searchFnRef.current === 'function') {
        searchFnRef.current(value);
        setPageNumber(value);
      } else {
        // console.error("searchFn is undefined or not a function");
      }
    } else {
      setPageNumber(value);
      if (valuee === 'worksheet') {
        getResume(value)
      } else if (valuee === 'favourites') {
        getFav(value)
      } else if(valuee==='Hotlist'){
        getHotlist(value,selectedHotlist.hotlistName);
      }
      else {
        handleChange(valuee, value)
      }
    }
  };

  // const [pageNumber1, setPageNumber1] = useState()

  const handleDataFromChild2 = (number) => {
    // setPageNumber1(number)
    setPageNumber(number)
  };

  // console.log("pageNumber", pageNumber)

  const [endClientName, setEndClientName] = useState('')
  const [checkedItems, setCheckedItems] = useState({});

  // const handleCheck = (itemId, email) => {
  //   // alert("checked")
  //   // alert(email)
  //   const isChecked = !checkedItems[itemId];

  //     if (isChecked) {
  //   setBccEmail((prev) => {
  //     const alreadyExists = prev.some((item) => item.email === email);
  //     if (!alreadyExists) {
  //       return [...prev, { title:email }];
  //     }
  //     return prev;
  //   });
  // } else {

  //   setBccEmail((prev) => prev.filter((item) => item.email !== email));
  // }
  //   setCheckedItems((prev) => ({
  //     ...prev, 
  //     [itemId]: !prev[itemId],
  //   })); 
  // };

  // const handleCheck = (itemId, email) => {
  //   const isChecked = !checkedItems[itemId];
  //   // console.log("checked")
  //   if (isChecked) {
  //     setBccEmail((prev) => {
  //       const alreadyExists = prev.some((item) => item.title === email);
  //       if (!alreadyExists) {
  //         return [...prev, { title: email }];
  //       }
  //       return prev;
  //     });
  //   } else {
  //     setBccEmail((prev) => prev.filter((item) => item.title !== email));
  //   }

  //   setCheckedItems((prev) => ({
  //     ...prev,
  //     [itemId]: isChecked,
  //   }));
  // };

  // const handleCheck = (itemId, email, name) => {
  //   const isChecked = !checkedItems[itemId];

  //   if (isChecked) {
  //     setBccEmail((prev) => {
  //       const alreadyExists = prev.some((item) => item.email === email);
  //       if (!alreadyExists) {
  //         return [...prev, { name, email }];
  //       }
  //       return prev;
  //     });
  //   } else {
  //     setBccEmail((prev) => prev.filter((item) => item.email !== email));
  //   }

  //   setCheckedItems((prev) => ({
  //     ...prev,
  //     [itemId]: isChecked,
  //   }));
  // };

  // const handleCheck = (itemId, email, name) => {
  //   const isChecked = !checkedItems[itemId];

  //   const formattedName = (name || "")
  //     .split(" ")
  //     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  //     .join(" ");

  //   if (isChecked) {
  //     setBccEmail((prev) => {
  //       const alreadyExists = prev.some((item) => item.email === email);
  //       if (!alreadyExists) {
  //         return [...prev, { name: formattedName, email }];
  //       }
  //       return prev;
  //     });
  //   } else {
  //     setBccEmail((prev) => prev.filter((item) => item.email !== email));
  //   }

  //   setCheckedItems((prev) => ({
  //     ...prev,
  //     [itemId]: isChecked,
  //   }));
  // };

  const handleCheck = (itemId, email, name) => {
    const isChecked = !checkedItems[itemId];

    const formattedName = (name || "")
      .split(" ")
      .map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())
      .join(" ");

    setBccEmail((prev) => {
      let updated;

      if (isChecked) {
        const alreadyExists = prev?.some((item) => item.email === email);
        if (!alreadyExists) {
          updated = [...prev, { name: formattedName, email }];
        } else {
          updated = prev;
        }
      } else {
        updated = prev.filter((item) => item.email !== email);
      }

      if (updated?.length > 0) {
        setRecipientEmail(updated[0]?.email);
      } else {
        setRecipientEmail("");
      }

      return updated;
    });

    setCheckedItems((prev) => ({
      ...prev,
      [itemId]: isChecked,
    }));
  };

  const [bccEmail, setBccEmail] = useState([]);
  console.log("sumitkumar sharma ji ===>>>", bccEmail)
  const allChecked = tableData?.length > 0 && tableData?.every(item => checkedItems[item._id]);

  // const [allObjects, setAllObjects] = useState([]);

  // const handleSelectAll = () => {
  //   setBccEmail([])
  //   if (allChecked) {
  //     setBccEmail([])
  //   } else {
  //     setBccEmail(tableData?.map((item) => ({ title: item?.email })) || []);
  //   }
  //   const newCheckedItems = tableData?.reduce((acc, item) => {
  //     acc[item._id] = !allChecked;
  //     return acc;
  //   }, {});
  //   setCheckedItems(newCheckedItems);
  // };

  // const handleSelectAll = () => {
  //   if (allChecked) {
  //     setBccEmail([]);
  //   } else {
  //     setBccEmail(
  //       tableData?.map((item) => ({

  //         name: (item?.fullName || "")
  //           .split(" ")
  //           .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  //           .join(" "),

  //         email: item?.email || ""
  //       })) || []
  //     );
  //   }

  //   const newCheckedItems = tableData?.reduce((acc, item) => {
  //     acc[item._id] = !allChecked;
  //     return acc;
  //   }, {});
  //   setCheckedItems(newCheckedItems);
  // };

  const handleSelectAll = () => {
    if (allChecked) {
      setBccEmail([]);
      setRecipientEmail("");
    } else {
      const formattedEmails =
        tableData?.map((item) => ({
          name: (item?.fullName || "")
            .split(" ")
            .map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())
            .join(" "),
          email: item?.email || "",
        })) || [];

      setBccEmail(formattedEmails);

      if (formattedEmails?.length > 0) {
        setRecipientEmail(formattedEmails[0]?.email);
      }
    }

    const newCheckedItems = tableData?.reduce((acc, item) => {
      acc[item._id] = !allChecked;
      return acc;
    }, {});

    setCheckedItems(newCheckedItems);
  };

  console.log("checkedItems", checkedItems)

  const [loadingMov, setLoadingMov] = useState(false);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleOpenDeleteModal = () => {
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  const multipleDelete = () => {

    const selectedIds = tableData
      ?.filter(item => checkedItems[item._id])
      .map(item => item._id);

    const body = {
      "_id": selectedIds,
      "trashStatus": true,
      "type": "resume"
    }
    const token = localStorage.getItem('token');
    Api(`resume/BulkMoveTrash`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message, +'!');
          resetDataFun1()
          if (response.data.status === 200) {
            handleCloseDeleteModal()
            setLoadingMov(false)
          } else {
            handleCloseDeleteModal()
            // toast.error(response.data.message, +'!');
            setLoadingMov(false)
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };

  const isButtonDisabled = Object?.values(checkedItems)?.every(checked => !checked);

  const [modalOpen, setModalOpen] = useState(false);

  // console.log("bccEmail===>>>>", bccEmail)
  // console.log("tableData===>>>>", tableData)
  // console.log("allObjects===>>>>", allObjects)
  // console.log("tableData===>>>>", tableData[0]?.email)

  const handleOpenModal = (email) => {
    // setRecipientEmail(email)
    // setAllObjects([...tableData]);
    // setSelectedCandidateId(id);
    setModalOpen(true);
    // alert(`Selected Candidate ID: ${id}`);
    // alert(email);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  // console.log("allObjects===>>>>", allObjects)

  const [greeting, setGreeting] = useState('')
  const [recipientEmail, setRecipientEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [ccEmail, setCcEmail] = useState([]);

  const [base64, setBase64] = useState([])
  const [fileName, setFileName] = useState('')
  const [fileType, setFileType] = useState('')
  const [attachment, setAttachment] = useState('')

  const FileChange = (event) => {
    const file = event.target.files[0];
    console.log("file---", event.target.files)
    if (file) {
      setFileName(file.name)
      setFileType(file.type)
      convertFileToBase64(file);
      uploadAttach(file)
    } else {
      toast.warn('No file selected!');
    }
  };

  const uploadAttach = async (file) => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', file);
    formData.append('directoryName', 'resume');
    // formData.append('directoryName', 'profile');
    try {
      const response = await UploadFile('resume/upload_resume', formData, token);
      if (response.status === 200 && response.data.code === 200) {
        setAttachment(response.data.filePath)
      } else {
        //   toast.warn(response.data.status + '!');
      }
    } catch (error) {
      // toast.warn('Error uploading the image!');
    }
  };

  const convertFileToBase64 = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64(reader.result);
      // console.log("base64",reader.result)
    };
    reader.readAsDataURL(file);
  };

  // console.log("bccEmail", bccEmail)

  const sign = localStorage.getItem("sign");

  // console.log("sign ---", sign?.replace(/src="data:image\/[^"]+"/g, 'src=""'))
  // console.log("sign +++", sign?.replace(/src="data:image\/[^"]+"/g, 'src=""'))
  // console.log("sign ***", sign)

  const [loadingSend, setLoadingSend] = useState(false)

  const sendBulkEmail = async () => {
    setLoadingSend(true)
    const body = {
      "subject": subject,
      "attachment": attachment,
      "fileName": fileName,
      "mailFrom": "recruiterworksheet",
      "others":
        // [ 
        // {
        //   "name": "",
        //   "email": ""
        // }
        bccEmail,
      // ],
      "mailBody": emailBody
      //       "mailBody":`${emailBody}<br/>${sign?.replace(
      //     /<figure[^>]*>(.*?)<\/figure>/gi,
      //     (_, innerContent) => `<p>${innerContent}</p>`
      //   )
      // }`

      // "mailBody": "<p>Thanks &amp; Regards</p><p>CRM Department</p><p><strong>GALAXY GROUP</strong></p><p><strong>Corporate office</strong>: Galaxy Blue Sapphire Plaza, 19th Floor, Plot No. C-<a href='https://www.google.com/maps/search/03,+Sec-4?entry=gmail&amp;source=g'>03, Sec-4</a>, Greater Noida (West) U.P.</p><p><strong>Contact No. : </strong>0120-4805000.<br>&nbsp;</p><p><strong>Save Paper-Save Trees. Please don't print this e-mail unless you really need to.</strong></p><p><img src='https://foxstoragefoxearch.s3.ap-south-1.amazonaws.com/profile/fwCobzFgbnLGYcuakRWBtyFog.png' alt='Galaxy Logo' style='width:150px; height:auto; display:block;'></p>"
      //    "mailBody": 
      //   `<p>Thanks &amp; Regards</p>
      // <p>CRM Department</p>
      // <p><strong>GALAXY GROUP</strong></p>
      // <p><strong>Corporate office</strong>:&nbsp;Galaxy Blue Sapphire Plaza, 19th Floor, Plot No. C-<a href="https://www.google.com/maps/search/03,+Sec-4?entry=gmail&amp;source=g">03, Sec-4</a>, Greater Noida (West) U.P.</p>
      // <p><strong>Contact No. : </strong>0120-4805000.<br>&nbsp;</p>
      // <p><strong>Save Paper-Save Trees. Please don't print this e-mail unless you really need to.</strong></p>
      // <figure class="image">
      //   <img src="https://foxstoragefoxearch.s3.ap-south-1.amazonaws.com/profile/fwCobzFgbnLGYcuakRWBtyFog.png" alt="Logo">
      // </figure>`
    }

    const token = localStorage.getItem('token');
    Api(`email/send_bulk_mail`, 'POST', body, token)
      .then((response) => {
        console.log('====rec ====', response);
        if (response.status === 200) {
          handleCloseModal()
          toast.success(response.data.message);
          setLoadingSend(false)
        }
        else{
          console.log("hello")
            setLoadingSend(false)
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
      });
  };
















  const handleTemplateSelect = (item) => {
    if (item && item.template && item.template.length > 0) {
      setGreeting(item.template[0].greeting)
      setSubject(item.template[0].subject)
      setEmailBody(item.template[0].emailBody)
    }
  };

const [hotlists, setHotlists] = useState([]);
const [selectedHotlist, setSelectedHotlist] = useState(null);
const [openHotlistModal, setOpenHotlistModal] = useState(false);



const getHotlistList = async () => {
  const token = localStorage.getItem("token");

  Api("resume/getHotlists", "POST", {}, token)
    .then((response) => {
      if (response.status === 200 && response.data.code === 200) {
        const list = response.data.result || [];

        setHotlists(list);

        if (list.length > 0) {
          setSelectedHotlist(list[0]);

          // first hotlist ka data load
          getHotlist(1, list[0].hotlistName);
        }
      }
    });
};









const worksheetState = JSON.parse(
  localStorage.getItem('worksheetSearchState') || 'null'
);
  return (
    <>
      <Helmet>
        <title> Recruiter Worksheet | Foxearch </title>
      </Helmet>
      <Modal open={dataLoading}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '80%', sm: '50%', md: '20%' },
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Stack spacing={2} alignItems="center">
            <CircularProgress />
            <Typography variant="h6" sx={{ color: 'text.secondary', wordWrap: 'break-word' }}>
              Loading...
            </Typography>
          </Stack>
        </Box>
      </Modal>

      <Search searchData={searchDataFun} func={resetDataFun} funcc={hidePage} funnc={showtable}
        onData={handleDataFromChild} onData1={handleDataFromChild1}
        onData2={handleDataFromChild2} resetSearch={() => setSearchResult('')}
        setCheckBtnDis={setCheckBtnDis} />
 {toggleButton && (
        <Button color="custom" variant="contained" size="small"
          style={{ marginLeft: '275px', marginTop: "8px", position: "absolute" }}
          onClick={resetDataFun1}
        >
          Close
        </Button>

      )}



      <Modal
  open={openHotlistModal}
  onClose={() => setOpenHotlistModal(false)}
>
  <Box
    sx={{
      width: 400,
      bgcolor: "#fff",
      p: 2,
      borderRadius: 2,
      mx: "auto",
      mt: "10%"
    }}
  >
      <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
                Select Hotlist
          </Typography>

    {hotlists.map((item) => (
      <Box
        key={item._id}
        sx={{
          p: 1.5,
          cursor: "pointer",
          borderBottom: "1px solid #eee",
          fontWeight: 600,
          fontSize: "0.9rem",
        }}
        onClick={() => {
          setSelectedHotlist(item);

          setOpenHotlistModal(false);

          getHotlist(
            1,
            item.hotlistName
          );
        }}
      >
       {  item?.hotlistName
      ? item.hotlistName.charAt(0).toUpperCase() +
        item.hotlistName.slice(1)
      : '' }
      </Box>
    ))}
  </Box>
       </Modal>

      <Modal
        open={circle}
        // onClose={circleFn1}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          padding: '20px',
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          {/* <h6 id="simple-modal-title">Parsing resume, Please wait...</h6> */}
          <Typography variant="h6" sx={{ color: 'text.secondary', wordWrap: 'break-word' }}>
            Parsing resume, Please wait...
          </Typography>
          {/* <p id="simple-modal-description">Modal content goes here.</p> */}
          <Iconify icon="eos-icons:arrow-rotate" width="4rem" color="green" />
          {/* <CircularProgress style={{ display: open ? 'block' : 'none', marginTop: '20px' }} /> */}
        </div>
      </Modal>


      <Modal
        open={pepShow}
        onClose={hidePep}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <>
          {valuee !== 'favourites' ? (
            <div style={{
              position: 'absolute',
              top: '40%',
              left: '35%',
              width: "35%",
              transform: 'translate(-50%, -50%)',
              backgroundColor: 'white',
              padding: '20px',
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
              borderRadius: '8px',
              border: " 2.5px solid #1E74B3",
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
            }}>

              <div style={{ display: 'flex', gap: '10px' }}>

                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel>Resource</InputLabel>
                  <Select
                    label="Resource"
                    value={resour}
                    onChange={handleChangeRes}
                    onOpen={allUsers}
                  >
                    {resourData?.map((item, index) => (
                      <MenuItem key={index} value={item._id} style={{ color: item.status !== "active" ? "red" : "" }}>
                        {item.contactPersonName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField sx={{ mt: -0.1 }}
                  label="Name | Email | Phone Number"
                  variant="outlined"
                  fullWidth
                  margin="dense"
                  size="small"
                  value={inputValue.commonSearch}
                  onChange={(e) => setInputValue({ ...inputValue, commonSearch: e.target.value })}
                />
              </div>

              <TextField
                label="Job Title"
                variant="outlined"
                fullWidth
                margin="dense"
                size="small"
                value={inputValue.jobTitle}
                onChange={(e) => setInputValue({
                  ...inputValue,
                  jobTitle: [e.target.value]
                })}
              />

              <Stack
                direction="row"
                spacing={4}
                justifyContent="center"
                alignItems="center"
                sx={{ width: '100%', mt: 1 }}
              >
                <Button color="custom" variant="contained" sx={{ width: "10%" }}
                  disabled={loadingRes}
                  onClick={() => searchReso()}
                >
                  {loadingRes ? <CircularProgress size={23} /> : 'Search'}

                </Button>
              </Stack>
            </div>
          ) : (
            <div style={{
              position: 'absolute',
              top: '40%',
              left: '35%',
              width: "25%",
              transform: 'translate(-50%, -50%)',
              backgroundColor: 'white',
              padding: '20px',
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
              borderRadius: '8px',
              border: " 2.5px solid #1E74B3",
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
            }}>

              <div style={{ display: 'flex', gap: '10px' }}>

                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel>Resource</InputLabel>
                  <Select
                    label="Resource"
                    value={resour}
                    onChange={handleChangeRes}
                    onOpen={allUsers}
                  >
                    {resourData?.map((item, index) => (
                      <MenuItem key={index} value={item._id} style={{ color: item.status !== "active" ? "red" : "" }}>
                        {item.contactPersonName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

              </div>

              <Stack
                direction="row"
                spacing={4}
                justifyContent="center"
                alignItems="center"
                sx={{ width: '100%', mt: 1 }}
              >
                <Button color="custom" variant="contained" sx={{ width: "10%" }}
                  disabled={loadingRes}
                  onClick={() => searchReso()}
                >
                  {loadingRes ? <CircularProgress size={23} /> : 'Search'}

                </Button>
              </Stack>
            </div>
          )}

        </>
      </Modal>


      <ToastContainer />
      <Stack direction="row" alignItems="flex-end" justifyContent="space-between">
        <Typography variant="h5" color="textSecondary">
          Recruiter Worksheet
          {/* {valuee !== "worksheet" && valuee !== "favourites" && ( */}

          {/* {valuee !== "worksheet" ? (
            <IconButton sx={{ marginLeft: "5px", marginTop: "-1px" }} onClick={showPep}>
             
              <Iconify
                icon="mdi:filter-outline"
                color="#1E74B3" 
                width="1.5rem"
              />
            </IconButton>
          ):(
            (valuee === "favourites" && localStorage.getItem("role") === "admin" && (
            <IconButton sx={{ marginLeft: "5px", marginTop: "-1px" }} onClick={showPep}>
             
              <Iconify
                icon="mdi:filter-outline" 
                color="#1E74B3" 
                width="1.5rem"
              />
            </IconButton>
            )
          )
          )} */}

          {/* {(valuee !== "worksheet" && (valuee === "favourites" && localStorage.getItem("role") === "admin")) && (
  <IconButton sx={{ marginLeft: "5px", marginTop: "-1px" }} onClick={showPep}>
    <Iconify
      icon="mdi:filter-outline"
      color="#1E74B3"  
      width="1.5rem"
    />
  </IconButton>
)} */}

          {(
            (["submitted", "interview", "placement", "backout"].includes(valuee)) ||
            (valuee === "favourites" && localStorage.getItem("role") === "admin")
          ) && (
              <IconButton sx={{ marginLeft: "5px", marginTop: "-1px" }} onClick={showPep}>
                <Iconify
                  icon="mdi:filter-outline"
                  color="#1E74B3"
                  width="1.5rem"
                />
              </IconButton>
            )}
                              
                                
                                
                                {/* <span
  onClick={() => setOpenHotlistModal(true)}
 
>
  {selectedHotlist?.hotlistName}
</span> */}

{/* { valuee === 'Hotlist'  && (<Chip
  label={
    selectedHotlist?.hotlistName
      ? selectedHotlist.hotlistName.charAt(0).toUpperCase() +
        selectedHotlist.hotlistName.slice(1)
      : ''
  }
  size="small"
  clickable
  onClick={() => setOpenHotlistModal(true)}
  sx={{
    ml: 1,
    fontSize: '12px',
    height: '24px',
    cursor: 'pointer',
  }}
/>)} */}
{valuee === 'Hotlist' && (
  <Button
    variant="contained"
    color="custom"
    size="small"
    onClick={() => setOpenHotlistModal(true)}
    sx={{
      ml: 1,
      textTransform: 'none',
    }}
  >
    {selectedHotlist?.hotlistName
      ? selectedHotlist.hotlistName.charAt(0).toUpperCase() +
        selectedHotlist.hotlistName.slice(1)
      : ''}
  </Button>
)}

        </Typography>

  

        <Stack
          direction="row"
          spacing={1}
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'nowrap',
            gap: 1,
          }}
        >

          {(checkBtnDis  ||  valuee === 'Hotlist') ? (
            <>
              <Button color="custom" variant="contained" size="small"
                // disabled={!checkBtnDis}
                onClick={() => handleSelectAll()}
              >
                {allChecked ? "Deselect All" : "Select All"}

              </Button>

              <Button color="custom" variant="contained" size="small"
                // disabled={!checkBtnDis} 
                onClick={() => handleOpenModal(tableData[0]?.email)}>
                Email
              </Button>

              <Button color="custom" variant="contained" size="small"
                // sx={{color:"red"}}
                onClick={() => handleOpenDeleteModal()}
              >
                Delete
              </Button>
            </>
          ) : (
            <>
              <Button
                // disabled={checkBtnDis}
                color="custom"
                variant="contained"
                size="small"
                onClick={parseOpen}
                sx={{ minWidth: 100, fontSize: 12, padding: '4px 8px' }}
              >
                Parse Resume
              </Button>
              <Button
                // disabled={checkBtnDis}
                color="custom"
                variant="contained"
                size="small"
                onClick={handleOpen1}
                sx={{ minWidth: 100, fontSize: 12, padding: '4px 8px' }}
              >
                Add Prospect
              </Button>
            </>
          )}

        </Stack>
      </Stack>
      {/* {!tableShow  && (

        <Typography sx={{ float: "right", mt: 0.5 }} fontSize={"0.85rem"} color={'text.secondary'}>
          Total: {searchResult || "0"}
        </Typography>
      )} */}

     {(!tableShow || savedSearch11) && (
  <Typography
    sx={{ float: "right", mt: 0.5 }}
    fontSize={"0.85rem"}
    color="text.secondary"
  >
    Total: {searchResult || "0"}
  </Typography>
)}

      {/* <Stack sx={{ flexDirection: 'row', gap: 2, mb: 0.5, cursor: 'pointer', alignItems: 'center' }}>
      <Stack
  sx={[
    {
      flexDirection: 'row',
      alignItems: 'center',
    },
    valuee === 'worksheet'
      ? { borderBottom: 3, color: 'text.secondary' }
      : { color: 'text.textG' },
  ]}
  disabled={loadingTab}
  onClick={() => {
    navigate('/worksheet');
    setPageNumber(1);
    getResume();
    setValuee('worksheet');
    
  }}
>
  <Iconify icon="mingcute:list-check-line" fontSize={18} />
  <Typography variant="tabs" sx={{ ml: 1, display: 'flex', alignItems: 'center', gap: 0.8 }}>
    Prospects
  </Typography>
</Stack>

        <Stack
          sx={[
            { flexDirection: 'row', alignItems: 'center',
              cursor: loadingTab ? 'not-allowed' : 'pointer',
      pointerEvents: loadingTab ? 'none' : 'auto',
             },
            valuee === 'favourites' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            setPageNumber(1);
            getFav();
            setValuee('favourites');
          }}
          disabled={loadingTab}
        >
          
          <Iconify
            icon="ph:heart"
            fontSize={17}
            color={valuee === 'favourites' ? { color: '#CB4335' } : { color: 'text.textG' }}
          />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Favourites
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            valuee === 'submitted' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          disabled={loadingTab}
          onClick={() => { navigate('/worksheet', { state: 'submitted' }); setPageNumber(1) }}
        >
          <Iconify
            icon="iconamoon:star-light"
            fontSize={17}
            color={valuee === 'submitted' ? '#B7950B' : 'text.textG'}
          />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Submissions
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            valuee === 'interview' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          disabled={loadingTab}
          onClick={() => { navigate('/worksheet', { state: 'interview' }); setPageNumber(1) }}
        >
          <Iconify icon="ps:check-box" fontSize={17} color={valuee === 'interview' ? '#F4D03F' : 'text.textG'} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Interviews
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            valuee === 'placement' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          disabled={loadingTab}
          onClick={() => { navigate('/worksheet', { state: 'placement' }); setPageNumber(1) }}
        >
          <Iconify
            icon="mingcute:target-line"
            sx={{ transform: 'rotate(270deg)' }}
            fontSize={17}
            color={valuee === 'placement' ? '#2ECC71' : 'text.textG'}
          />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Placements
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            valuee === 'backout' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          disabled={loadingTab}
          onClick={() => { navigate('/worksheet', { state: 'backout' }); setPageNumber(1) }}
        >
          <Iconify icon="bx:error" fontSize={17} color={valuee === 'backout' ? '#CB4335' : 'text.textG'} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Backouts
          </Typography>
        </Stack>
      </Stack> */}


      <Box sx={{ overflowX: 'auto', whiteSpace: 'nowrap', pb: 1 }}>
        <Stack
          direction="row"
          sx={{
            minWidth: 'max-content',
            gap: 2,
            alignItems: 'center',
          }}
        >
          <Stack
            sx={[
              {
                flexDirection: 'row',
                alignItems: 'center',
                flexShrink: 0,
                cursor: 'pointer',
              },
              valuee === 'worksheet'
                ? { borderBottom: 3, color: 'text.secondary' }
                : { color: 'text.textG' },
            ]}
            disabled={loadingTab}
            onClick={() => {
              navigate('/worksheet');
              setSelectedHotlist(null)
              setPageNumber(1);
              getResume();
              setValuee('worksheet');
              setBccEmail([]);
              setCheckedItems({})
            }}
          >
            <Iconify icon="mingcute:list-check-line" fontSize={18} />
            <Typography variant="tabs" sx={{ ml: 1, display: 'flex', alignItems: 'center', gap: 0.8 }}>
              Prospects
            </Typography>
          </Stack>

          <Stack
            sx={[
              {
                flexDirection: 'row',
                alignItems: 'center',
                flexShrink: 0,
                cursor: loadingTab ? 'not-allowed' : 'pointer',
                pointerEvents: loadingTab ? 'none' : 'auto',
              },
              valuee === 'favourites'
                ? { borderBottom: 3, color: 'text.secondary' }
                : { color: 'text.textG' },
            ]}
            onClick={() => {
              setPageNumber(1);
              setSelectedHotlist(null)
              getFav();
              setValuee('favourites');
              setBccEmail([]);
              setCheckedItems({})
            }}
            disabled={loadingTab}
          >
            <Iconify
              icon="ph:heart"
              fontSize={17}
              color={valuee === 'favourites' ? '#CB4335' : 'text.textG'}
            />
            <Typography variant="tabs" sx={{ ml: 1 }}>
              Favourites
            </Typography>
          </Stack>


            
             <Stack
            sx={[
              {
                flexDirection: 'row',
                alignItems: 'center',
                flexShrink: 0,
                cursor: 'pointer',
              },
              valuee === 'Hotlist'
                ? { borderBottom: 3, color: 'text.secondary' }
                : { color: 'text.textG' },
            ]}
            disabled={loadingTab}
            onClick={() => {
              // navigate('/worksheet');
              setPageNumber(1);
                // getHotlist()
                getHotlistList();
              // getHotlist();
              setValuee('Hotlist');
              setBccEmail([]);
              setCheckedItems({})
            }}
          >
            {/* <Iconify icon="mingcute:list-check-line" fontSize={18} /> */}
                 <Iconify
              icon="iconamoon:star-light"
              fontSize={17}
              color={valuee === 'submitted' ? '#B7950B' : 'text.textG'}
            />
            <Typography variant="tabs" sx={{ ml: 1, display: 'flex', alignItems: 'center', gap: 0.8 }}>
                 Hotlist
            </Typography>
          </Stack>

          <Stack
            sx={[
              {
                flexDirection: 'row',
                ml: 1,
                alignItems: 'center',
                flexShrink: 0,
              },
              valuee === 'submitted'
                ? { borderBottom: 3, color: 'text.secondary' }
                : { color: 'text.textG' },
            ]}
            disabled={loadingTab}
            onClick={() => {
              navigate('/worksheet', { state: 'submitted' });
              setPageNumber(1);
              setBccEmail([]);
              setCheckedItems({})
               setSelectedHotlist(null)
            }}
          >
        <Iconify icon="lucide:heart-handshake" width="1.2rem" />
            <Typography variant="tabs" sx={{ ml: 1 }}>
              Submissions
            </Typography>
          </Stack>

          <Stack
            sx={[
              {
                flexDirection: 'row',
                ml: 1,
                alignItems: 'center',
                flexShrink: 0,
              },
              valuee === 'interview'
                ? { borderBottom: 3, color: 'text.secondary' }
                : { color: 'text.textG' },
            ]}
            disabled={loadingTab}
            onClick={() => {
              navigate('/worksheet', { state: 'interview' });
              setPageNumber(1);
              setBccEmail([]);
              setCheckedItems({})
               setSelectedHotlist(null)
            }}
          >
            <Iconify
              icon="ps:check-box"
              fontSize={17}
              color={valuee === 'interview' ? '#F4D03F' : 'text.textG'}
            />
            <Typography variant="tabs" sx={{ ml: 1 }}>
              Interviews
            </Typography>
          </Stack>

          <Stack  
            sx={[
              {
                flexDirection: 'row',
                ml: 1,
                alignItems: 'center',
                flexShrink: 0,
              },
              valuee === 'placement'
                ? { borderBottom: 3, color: 'text.secondary' }
                : { color: 'text.textG' },
            ]}
            disabled={loadingTab}
            onClick={() => {
              navigate('/worksheet', { state: 'placement' });
              setPageNumber(1);
               setSelectedHotlist(null)
            }}
          >
            <Iconify
              icon="mingcute:target-line"
              sx={{ transform: 'rotate(270deg)' }}
              fontSize={17}
              color={valuee === 'placement' ? '#2ECC71' : 'text.textG'}
            />
            <Typography variant="tabs" sx={{ ml: 1 }}>
              Placements
            </Typography>
          </Stack>

          <Stack
            sx={[
              {
                flexDirection: 'row',
                ml: 1,
                alignItems: 'center',
                flexShrink: 0,
              },
              valuee === 'backout'
                ? { borderBottom: 3, color: 'text.secondary' }
                : { color: 'text.textG' },
            ]}
            disabled={loadingTab}
            onClick={() => {
              navigate('/worksheet', { state: 'backout' });
              setPageNumber(1);
               setSelectedHotlist(null)
            }}
          >
            <Iconify
              icon="bx:error"
              fontSize={17}
              color={valuee === 'backout' ? '#CB4335' : 'text.textG'}
            />
            <Typography variant="tabs" sx={{ ml: 1 }}>
              Backouts
            </Typography>
          </Stack>
        </Stack>
      </Box>








      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
              <TableCell sx={{
                p: 1, py: 0.5, color: 'white',
                width: valuee === "placement" || "interview" || "submitted" ? '11%' : "14.5%"
              }}>Date</TableCell>

              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '17%' }}>Detail</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '17%' }}>Contact Details</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '17%' }}>Skills</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '11%' }}>Visa & Terms</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '11%' }}>Status</TableCell>
              <TableCell sx={{
                p: 1, py: 0.5, color: 'white',
                width: valuee === "placement" || "interview" || "submitted" ? '10%' : "8%"
              }}>Job Info</TableCell>
              <TableCell sx={{
                p: 1, py: 0.5, color: 'white',
                width: "5%"
              }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* {tableData?.map((item, index) => ( */}
            {Array.isArray(tableData) && tableData?.map((item, index) => (
              <ResumeRow
                key={item._id}
                index={index}
                row={item}
                fun={funclick}
                fun2={funclick2}
                skillsett={skill}
                joblst1={joblst}
                filterTab={valuee}
                setEndClientName={setEndClientName}
                endClientName={endClientName}
                fun3={fun3}
                pinned={pinned}
                selectedHotlist={selectedHotlist}
                tempList={tempList}
                getHotlistList={getHotlistList}
                addedSkills={addedSkill}
                // Edit={Edit}
                favFun={getFav}
                handleCheck1={() => handleCheck(item._id, item?.email, item?.fullName)}
                checked1={checkedItems[item._id]}
                tableShow={tableShow}
                savedSearch11={savedSearch11}
              />

            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* {loading && (
        <Stack sx={{ mt: 2, p: 2 }}>
          <Typography sx={{ alignSelf: 'center', color: 'blue' }}>Loading...</Typography>
        </Stack>
      )} */}
      {/* {loading !== "" && ( */}
      {loading === "Loading..." ? (
        <Stack>
          {Array.from({ length: 15 })?.map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              sx={{
                height: 80,
                width: '100%',
                backgroundColor: index % 2 === 0 ? 'text.background' : tablebg,
              }}
            />
          ))}
        </Stack>

      ) :
        <Stack sx={{ mt: 2, p: 2 }}>
          <Typography sx={{ alignSelf: 'center', color: 'red' }}>
            {loading}

          </Typography>
        </Stack>
      }
      {/* <Stack sx={{ mt: 2, p: 2 }}>
           <Typography sx={{ alignSelf: 'center', color: 'red' }}>
             {loading}
            
             </Typography>
         </Stack> */}

      {/* {tableData.length < 1 && (
        <Stack sx={{ mt: 2, p: 2 }}>
          <Typography sx={{ alignSelf: 'center', color: 'red' }}>no data found</Typography>
        </Stack>
      )} */}

      {/* {tableData.length ? (
        <Stack spacing={2} sx={{ alignItems: 'flex-end', width: '100%', mt: 2 }}>
          <Pagination variant="outlined" shape="rounded" color="secondary" count={pages} page={pageNumber} onChange={handlePage} />
        </Stack>
      ) : null} */}
      {/* {tableShow && dataaa && ( */}
      {/* {dataaa && (
        <> */}
      {tableCount > 35 ? (
        <Stack
          spacing={2}
          sx={{
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mt: 2
          }}
        >
          {/* {pageNumber !== 1 && ( */}
          <Button
            variant="outlined"
            sx={{
              minWidth: 16, height: 32, borderRadius: '5px',
              mt: 2,
              ml: 0.5, cursor: 'pointer'
            }}
            onClick={() => setPageNumber(prev => Math.max(prev - 1, 1))}
          >
            {"<"}
          </Button>
          {/* )} */}

          <Pagination
            variant="outlined"
            shape="rounded"
            color="secondary"
            hideNextButton
            hidePrevButton
            count={pages}
            page={pageNumber}
            onChange={handlePage}
            sx={{ cursor: 'pointer', mb: (pageNumber !== 1) ? -4 : -2 }}
          />
          {/* {pageNumber !== pages && ( */}
          <Button
            variant="outlined"
            sx={{
              minWidth: 16, height: 32, borderRadius: '5px', mr: 1,
              mt: -2,
              cursor: 'pointer'
            }}
            onClick={() => setPageNumber(prev => Math.min(prev + 1, pages))}
          >
            {">"}
          </Button>
          {/* )} */}
        </Stack>

      ) : null}








      <Modal open={modalOpen} onClose={handleCloseModal} style={{ borderRadius: 10 }}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: '70%' },
          // width: { xs: '85%', sm: '60%' },
          bgcolor: 'background.paper',
          border: '3px solid #3C6BA5',
          boxShadow: 24,
          p: 3,
          borderRadius: 3,
        }}
        >
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Send Email
          </Typography>
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            {/* <Divider sx={{ mb: 2 }} /> */}
            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <TextField
                  fullWidth
                  required
                  label="To"
                  variant="outlined"
                  size="small"
                  // value={to}
                  value={recipientEmail}
                  // onChange={(e) => setTo(e.target.value)}
                  onChange={(e) => setRecipientEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={5.9}>
                <Autocomplete
                  size='small'
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setCcEmail([...newValue]);
                  }}
                  options={[{ title: '' }]}
                  getOptionLabel={(option) => option.title}
                  value={ccEmail.map((item) => item)}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({
                        inputValue,
                        title: `${inputValue}`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => <TextField {...params} label="Cc" placeholder="Cc"

                    size="small"
                  />}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1} mt={0.1}>
              {/* <Grid item xs={11.8}> */}
              <Grid item xs={5.9}>
                <Autocomplete
                  multiple
                  size="small"
                  id="tags-outlined"
                  value={bccEmail}
                  onChange={(event, newValue) => {
                    setBccEmail(newValue);
                  }}
                  options={[]}
                  getOptionLabel={(option) => option.email || option.title || ''}
                  isOptionEqualToValue={(option, value) => option.email === value.email}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const { inputValue } = params;

                    const isExisting = bccEmail.some((item) => item.email === inputValue);
                    if (inputValue !== '' && !isExisting) {
                      return [
                        ...options,
                        {
                          name: '',
                          email: inputValue,
                        },
                      ];
                    }

                    return options;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Others"
                      placeholder="Others"
                      multiline
                      rows={3}
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        sx: {
                          alignItems: 'flex-start',
                          '& textarea': {
                            textAlign: 'left',
                            paddingTop: '1px !important',
                          },
                        },
                      }}
                    />
                  )}
                />

              </Grid>

              <Grid item xs={5} sx={{}}>
                <FormControl variant="outlined" fullWidth size="small" >
                  <InputLabel >Select Template</InputLabel>
                  <Select
                    label="Select Template"

                    onChange={(e) => handleTemplateSelect(e.target.value)}
                  >
                    {tempList?.map((item) => (
                      <MenuItem key={item?.id} value={item}>
                        {item?.templateName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Typography
                onClick={() => navigate('/Email', { state: { undid: "undid", bodyDis: "bodyDis" } })}
                sx={{
                  color: '#23A6F0',
                  fontWeight: 'bold',
                  fontSize: '17px',
                  marginLeft: '30px',
                  marginTop: '12px',
                  cursor: 'pointer',
                }}
              >
                Edit
              </Typography>

            </Grid>
            {/* <Grid container alignItems="center" style={{ flexDirection: 'row' }}>
              <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ ml: 1, color: '#1E74B3' }}>Attachment:</Typography>
                <input type="file" onChange={FileChange} style={{ marginLeft: '9px' }} />

              </Grid>
            </Grid> */}

            <Grid container alignItems="center" style={{ flexDirection: 'row' }}>
              <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ ml: 1, color: '#1E74B3', whiteSpace: 'nowrap' }}>
                  Attachment:
                </Typography>
                <input
                  type="file"
                  onChange={FileChange}
                  style={{
                    marginLeft: '9px',
                    flex: 1,
                    minWidth: 0,
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={11.8}>
                <TextField
                  label='Sub'
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                />
              </Grid>
              <Grid item xs={11.8}>
                <Stack sx={{ flexDirection: 'row', gap: 1, alignItems: 'center' }}>

                  <Typography>Hello {'{Name}'},</Typography>

                  {/* <Typography> {greeting} {row.fullName}</Typography> */}
                </Stack>
              </Grid>
              <Grid item xs={11.8}>
                <CKEditor
                  data={emailBody}
                  config={{
                    // licenseKey: process.env.REACT_APP_TLK,
                    // toolbar: [
                    //   'heading', '|',
                    //   'bold', 'italic', 'link', '|',
                    //   'insertImage', 'undo', 'redo'
                    // ],
                    extraPlugins: [MyCustomUploadAdapterPlugin]
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    // console.log("body", data)
                    setEmailBody(data);
                  }}
                  editor={ClassicEditor}
                />
              </Grid>
            </Grid>
            <Stack sx={{ mt: 1 }}>

              <div dangerouslySetInnerHTML={{ __html: localStorage.getItem('sign') }} />
            </Stack>







            <Stack flexDirection={'row'} gap={1} mt={1} sx={{ justifyContent: 'center' }}>
              <Button
                color="custom"
                variant="contained"

                disabled={recipientEmail === '' || subject === '' || loadingSend}
                onClick={() => sendBulkEmail()}>
                {/* Send */}
                {loadingSend ? "Sending" : 'Send'}
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>
















      <Modal open={open1} onClose={handleClose1} style={{ borderRadius: 10 }}>
        <Box sx={style}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            New Candidate
          </Typography>
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Divider sx={{ mb: 2 }} />
            <Grid display={'grid'} gridTemplateColumns={{ md: 'repeat(2, 1fr)', sm: 'repeat(1, 1fr)' }} py={2} gap={4}>
              <Stack gap={2}>
                <CustomComplete
                  err={emailerr}
                  req={'true'}
                  placeholder={'Email'}
                  option={emails}

                  propVal={value.email}
                  childFuc={childFucEmail}
                  fullVal={fullEmail}
                  fetch={'email'}
                />
                <FormControl fullWidth>
                  {/* <TextField
                    required
                    type="email"
                    id="outlined-basic"
                    label="Email"
                    placeholder="Email"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    value={value.email}
                    onChange={(e) => handleEmail(e)}
                    onFocus={(e) => setEvalid(false)}
                    onBlur={(e) => (evalid === true ? chkmail() : null)}
                    // onChange={(e) => setValue({...value, email:e.target.value})  }
                  /> */}
                  {evalid === false ? (
                    <Stack sx={{ ml: 1 }}>
                      <Typography color={'red'} variant="body">
                        This is not vaild mail
                      </Typography>
                    </Stack>
                  ) : null}
                  {dupemail === true ? (
                    <Stack sx={{ ml: 1, mt: 1, flexDirection: 'row' }}>
                      <Typography color={'red'} variant="body">
                        Duplicate Record Found
                      </Typography>
                      <Typography color={'red'} variant="body" sx={{ ml: 2 }}>
                        -
                      </Typography>
                      <Typography
                        color={'text.secondary'}
                        variant="body"
                        sx={{ ml: 2, cursor: 'pointer', textDecoration: 'underline' }}
                      >
                        Click here to view
                      </Typography>
                    </Stack>
                  ) : null}
                </FormControl>

                 <TextField
                 label="Secondary Email" 
      placeholder="Secondary Email"
       variant="outlined"
  value={value.secondaryEmail}
    InputLabelProps={{ shrink: true }}
  onChange={(e) =>
    setValue({
      ...value,
      secondaryEmail: e.target.value,
    })
  }
  fullWidth
                 />


                <TextField
                  id="outlined-basic"
                  required
                  // size='small'
                  label="Full Name"
                  placeholder="Full Name"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.name}
                  onChange={(e) => {
                    setValue({ ...value, name: e.target.value });
                    if (e.target.value.length) {
                      setNameerr(false);
                    } else {
                      setNameerr('true');
                    }
                  }}
                />
                <TextField
                  required
                  id="outlined-basic"
                  label="Job title"
                  placeholder="Job title"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.jobtitle}
                  InputProps={{
                    style: {
                      padding: '0',
                      margin: '0',
                    },
                  }}
                  onChange={(e) => {
                    setValue({ ...value, jobtitle: e.target.value });
                    if (e.target.value.length) {
                      setNameerr(false);
                    } else {
                      setNameerr('true');
                    }
                  }}
                />
                <TextField
                  id="outlined-basic"
                  label="Current Company"
                  placeholder="Current Company"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.currCompany}
                  onChange={(e) => setValue({ ...value, currCompany: e.target.value })}
                />

                <TextField
                  id="outlined-basic"
                  label="Phone"
                  placeholder="Phone"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.phone}
                  onChange={(e) => setContact(e.target.value)}
                // type="text"
                // inputProps={{
                //   maxLength: 20,
                // }}
                // type="number"
                // onChange={(e) => setValue({ ...value, phone: e.target.value })}
                />



                       <TextField
                  id="outlined-basic"
                  label="Secondary Phone"
                  placeholder="Secondary Phone"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.phone}
                  onChange={(e) => secondryPhoneNumber(e.target.value)}
                // type="text"
                // inputProps={{
                //   maxLength: 20,
                // }}
                // type="number"
                // onChange={(e) => setValue({ ...value, phone: e.target.value })}
                />

                <Autocomplete
                  disablePortal
                  disabled={localStorage.getItem("country") === "INDIA"}
                  // id="combo-box-demo"
                  options={visalist}
                  value={value.visa}
                  sx={{ width: '100%' }}
                  onChange={(e) => {
                    setValue({ ...value, visa: e.target.innerText });
                    // console.log(e.target.innerText);
                  }}
                  renderInput={(params) => <TextField {...params} label="Visa" />}
                /> 


                <FormControl disabled={localStorage.getItem("country") === "INDIA"}>
                  <FormLabel id="demo-radio-buttons-group-label">Contract (Tax Term) / Fulltime</FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="c2c"
                    name="radio-buttons-group"
                    value={value.tax}
                    onChange={(e) => setValue({ ...value, tax: e.target.value })}
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      ml: 1,
                    }}
                  >
                    <FormControlLabel value="c2c" control={<Radio />} label="C2C" />
                    <FormControlLabel value="w2" control={<Radio />} label="W2" />
                    <FormControlLabel value="1099" control={<Radio />} label="1099" />
                    <FormControlLabel value="T4" control={<Radio />} label="T4" />
                    <FormControlLabel value="INC" control={<Radio />} label="INC" />
                    <FormControlLabel value="fulltime" control={<Radio />} label="Full-Time" />
                  </RadioGroup>
                </FormControl>




                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Compensation Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value.comType}
                    label="Compensation Type"
                    onChange={(e) => setValue({ ...value, comType: e.target.value })}
                  >
                    <MenuItem value={'hourly'}>Per hour Rate </MenuItem>
                    <MenuItem value={'Annually'}>Annual Compensation</MenuItem>;
                  </Select>
                </FormControl>








                <TextField
                  id="outlined-basic"

                  label={`Expected Compensation( In ${localStorage.getItem("country") === "INDIA"
                      ? "₹"
                      : localStorage.getItem("country") === "UK"
                        ? "£"
                        : "$"
                    } )`}

                  // label={`Expected Compensation( In ${value.country === "INDIA" ? "INR" : "Dollars"} )*`}
                  // {localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"}
                  placeholder="Expected Compensation"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.expectedCom}
                  type="text"
                  InputProps={{
                      // startAdornment: <InputAdornment position="start">{value.country === "INDIA" ? "₹" : value.country === "UK" ? "£" : "$"}</InputAdornment>
                    startAdornment: <InputAdornment position="start">{localStorage.getItem("country")==="INDIA"? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"}</InputAdornment>,
                    // endAdornment: value.comType && (
                    //   <InputAdornment position="end">{value.comType === 'hourly' ? 'per/hour' : value.country === 'INDIA' ? 'Lac' : 'K'}</InputAdornment>
                    // ),
                    // endAdornment: value.comType && (
                    //   <InputAdornment position="end">{localStorage.getItem("country")==="INDIA"? "₹" : localStorage.getItem("country") === "UK"}</InputAdornment>
                    // ),
                     endAdornment: value.comType && (
                      <InputAdornment position="end">{value.comType === 'hourly' ? 'per/hour' : localStorage.getItem("country")==="INDIA" ? 'Lac' : 'K'}</InputAdornment>
                    ),


                  }}
                  // onChange={(e) => setValue({ ...value, expectedCom: e.target.value })}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(newValue)) {
                      setValue({ ...value, expectedCom: newValue });
                    }
                  }}
                />

                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Change Status</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value.userStatus}
                    label="Change Status"
                    onChange={(e) => setValue({ ...value, userStatus: e.target.value })}
                  >
                    <MenuItem value={'fake'}>Fake</MenuItem>
                    <MenuItem value={'blacklisted'}>Blacklisted</MenuItem>
                    <MenuItem value={'active'}>Active</MenuItem>;
                  </Select>
                </FormControl>
              </Stack>
              <Stack gap={2}>
                <FormControl fullWidth sx={{}}>
                  <TextField
                    id="outlined-basic"
                    label="Linkedin URL"
                    placeholder="Linkedin URL"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    value={value.linkedinUrl}
                    onChange={(e) => {
                      let updatedUrl = e.target.value.trim();
                      updatedUrl = updatedUrl.replace(/^(https?:\/\/)?(www\.)?/i, '');

                      if (updatedUrl.startsWith('www')) {
                        updatedUrl = `https://${updatedUrl}`;
                      } else if (updatedUrl !== '') {
                        updatedUrl = `https://www.${updatedUrl}`;
                      }

                      setValue({ ...value, linkedinUrl: updatedUrl });
                    }}
                  />
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Job Id</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value.jobid}
                    label="Job Id"
                    // onChange={(e) => setValue({ ...value, jobid: e.target.value })}
                    // onOpen={GetJobId}
                    onChange={(e) => {
                      const selectedJob = joblst?.find(item => item?.jobId === e.target.value);
                      setEndClientName(selectedJob?.endClientOrImpPartner);
                      // console.log("selectedJob", selectedJob?.endClientOrImpPartner)
                      setValue(prev => ({
                        ...prev,
                        jobid: e.target.value
                      }));
                    }}
                  >
                    <MenuItem value={'NA'}>NA</MenuItem>
                    {joblst?.map((item, index) => {
                      return <MenuItem key={index} value={item.jobId}>{item.jobId}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Select Country</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value.country}
                    label="Select Country"
                    onChange={(e) => setValue({ ...value, country: e.target.value })}
                  >
                    {/* <MenuItem value="USA">USA</MenuItem>;
                    <MenuItem value="CANADA">CANADA</MenuItem>;
                     <MenuItem value={'INDIA'}>INDIA</MenuItem>; */}
                    {countries?.map((item) => (
                      <MenuItem key={item.id} value={item.country}>
                        {item.country}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <CustomComplete
                  placeholder={'City'}
                  option={cityAndZip}
                  propVal={cityy}
                  childFuc={childFuc}
                  fullVal={fullVal}
                  fetch={'state'}
                  err={err}
                  helperText={helperText}
                />
                <FormControl fullWidth>
                  {cityandstate ? (
                    <Stack sx={{ ml: 1, mb: 2, mt: -1, flexDirection: 'row' }}>
                      <Typography color={'text.textG'} variant="body">
                        {cityandstate.city},{" "}{cityandstate.stateCode}
                      </Typography>
                      {/* <Typography color={'text.textG'} variant="body" sx={{ ml: 1 }}>
                        {cityandstate.state}
                      </Typography> */}
                    </Stack>

                  ) : null}
                  <FormControl fullWidth>
                    <TextField
                      id="outlined-basic"
                      // label="Zip code"
                      label={localStorage.getItem("country") === "INDIA" ? "Pin Code" : "Zip Code"}

                      // placeholder="Zip code"
                      placeholder={localStorage.getItem("country") === "INDIA" ? "Pin code" : "Zip Code"}
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={value.zip}
                      // type="number"
                      onChange={(e) => setValue({ ...value, zip: e.target.value })}
                    />
                  </FormControl>
                </FormControl>
                <FormControl fullWidth>
                  <FormLabel id="demo-radio-buttons-group-label">Can Relocate </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="yes "
                    name="radio-buttons-group"
                    value={value.reloc}
                    onChange={(e) => setValue({ ...value, reloc: e.target.value })}
                    sx={{ display: 'flex', flexDirection: 'row', ml: 1 }}
                  >
                    <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                    <FormControlLabel value="no" control={<Radio />} label="No" />
                  </RadioGroup>
                </FormControl>
                <Autocomplete
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setFinallst([...newValue]);
                  }}
                  options={skill}
                  getOptionLabel={(option) => option.title}
                  value={finallst.map((item) => item)}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({
                        inputValue,
                        title: `${inputValue}`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => <TextField {...params} label="Skills" placeholder="Skills" />}
                />
                {/* <Stack sx={{ position: 'relative', width: '100%' }}>
                  <Autocomplete
                    value={askill}
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        // setAskill({title: newValue });
                        addskill(newValue);
                        // console.log('first----- ', newValue);
                        setAskill('');
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        // setAskill({title: newValue.inputValue});
                        // console.log('second------ ', newValue.inputValue);
                        addskill(newValue.inputValue);
                        setAskill('');
                      } else {
                        // console.log('third----- ', newValue.title);
                        setAskill('');
                        addskill(newValue.title);
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      const { inputValue } = params;
                      // Suggest the creation of a new value
                      const isExisting = options.some((option) => inputValue === option.title);
                      if (inputValue !== '' && !isExisting) {
                        filtered.push({
                          inputValue,
                          title: `Add "${inputValue}"`,
                        });
                      }

                      return filtered;
                    }}
                    id="free-solo-with-text-demo"
                    options={skill}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === 'string') {
                        // console.log('re 1-----', option);
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        // console.log('re 2-----', option.inputValue);
                        return option.inputValue;
                      }
                      // Regular option

                      // console.log('re 3-----', option.title);
                      return option.title;
                    }}
                    renderOption={(props, option) => <li {...props}>{option.title}</li>}
                    sx={{}}
                    freeSolo
                    renderInput={(params) => <TextField {...params} label="Skill" />}
                  />

                  <Stack sx={{ marginTop: 1 }}>
                    <Grid container spacing={2}>
                      {finallst.map((item) => {
                        return (
                          <Grid item>
                            <Item>
                              {item}
                              <Iconify
                                icon="basil:cross-outline"
                                sx={{ color: 'white', width: 20, height: 20 }}
                                style={{ cursor: 'pointer' }}
                                onClick={() => del(item)}
                              />
                            </Item>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Stack>
                </Stack>*} */}
                <Stack sx={{ flexDirection: 'row' }}>
                  <Stack
                    sx={{
                      flexDirection: 'row',
                      // justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Typography variant="subtitle1">Upload Resume*</Typography>

                    <Stack sx={{ flexDirection: 'row' }}>
                      <Stack sx={{ position: 'relative' }}>
                        <Stack
                          sx={{
                            cursor: 'pointer',
                            m: 1,
                            border: 1,
                            p: 0.5,
                            borderRadius: 2,
                            width: 100,
                            borderColor: 'text.secondary',
                          }}
                        >
                          <Typography sx={{ alignSelf: 'center' }} color={'text.secondary'}>
                            choose file
                          </Typography>
                        </Stack>
                        <input
                          style={{ opacity: 0, position: 'absolute', margin: 5, width: 100 }}
                          type="file"
                          accept=".doc,.docx, application/pdf"
                          onChange={(e) => {
                            setDocfile(e.target.files[0]);
                            setChoosefile(false);
                            pdfUpload(e.target.files[0]);
                          }}
                        />
                      </Stack>
                    </Stack>
                  </Stack>
                  {docfile ? (
                    <Stack>
                      <Iconify
                        icon="basil:cross-outline"
                        sx={{ color: 'text.secondary', width: 30, height: 30 }}
                        style={{ cursor: 'pointer' }}
                        onClick={() => delfile()}
                      />
                    </Stack>
                  ) : null}

                  {/* {docfile && (
                    <Stack sx={{ mt: 0.5, flexDirection: 'row' }}>
                      <Button color="custom" variant="outlined" size="small" onClick={() => pdfUpload()}>
                        Upload File
                      </Button>
                    </Stack>
                  )} */}
                  {pdffile && (
                    <Stack sx={{ mt: 0.5, flexDirection: 'row', alignItems: 'center' }}>
                      <a href={pdffile} target="_foxearch">
                        <Button color="custom" variant="outlined">
                          View File
                        </Button>
                      </a>
                    </Stack>
                  )}
                  {choosefile === true ? (
                    <Stack sx={{ justifyContent: 'center', alignItems: 'center', ml: 2 }}>
                      <Typography color={'green'} onClick={(e) => window.open(pdffile, '_blank')}>
                        Success
                      </Typography>
                    </Stack>
                  ) : null}
                </Stack>
                {docfile ? (
                  <Stack sx={{ justifyContent: 'center' }}>
                    <Typography variant="body2" sx={{ width: 200 }}>
                      {docfile.name}
                    </Typography>
                  </Stack>
                ) : null}
                <TextField
                  id="outlined-multiline-static"
                  label="Note... (Max 2000 char)"
                  placeholder="Note..."
                  multiline
                  rows={5}
                  value={value.notes}
                  onChange={(e) => setValue({ ...value, notes: e.target.value })}
                />
                {/* <Stack sx={{ width: 500 }}>
                  <CKEditor
                    editor={ClassicEditor}
                    // data="<p>Typing&nbsp;5!<br><br></p>"
                    // onReady={ editor => {
                    //     // You can store the "editor" and use when it is needed.
                    //     console.log( 'Editor is ready to use!', editor );
                    // } }
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setValue({ ...value, notes: data });
                      console.log('ckeditor------data', data);
                    }}
                    // onBlur={ ( event, editor ) => {
                    //     console.log( 'Blur.', editor );
                    // } }
                    // onFocus={ ( event, editor ) => {
                    //     console.log( 'Focus.', editor );
                    // } }
                  />
                </Stack> */}
              </Stack>
            </Grid>
            <Stack flexDirection={'row'} gap={1} mt={1} sx={{ justifyContent: 'center' }}>
              <Button color="custom" variant="contained"
                disabled={loadingAdd}
                onClick={(e) => addcv(e)}
              >
                {/* Add CV */}
                {loadingAdd ? <CircularProgress size={21} /> : 'Add CV'}
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

      {/* <Modal open={parse} onClose={parseClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '30%',
            backgroundColor: 'white',
            border: '4px solid #1E74B3',
            borderRadius: '13px',
            padding: '1rem',
            outline: 'none',
            height: 'auto'
          }}

        >
          <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
            <div
              style={{
                border: '3px dashed #1E74B3',
                padding: '10px',
                borderRadius: '15px',
                margin: '1rem',
                textAlign: 'center',
                color: '#1E74B3',
               
                alignContent: 'center',
                marginLeft: '20px'
              }}
            >
              <Typography variant="body1" fontWeight="bold" mb={1}>
                Browse File
              </Typography>
              <input
                id="file-upload"
                type="file"
                accept=".doc,.docx, application/pdf"
                onChange={handleFileSelect}
                style={{ display: 'none' }}
                multiple
              />
            </div>
          </label>
          
          <div>
            <Typography
              variant="body1"
              fontWeight="bold"
              mb={1}
              style={{
                textAlign: 'center',
                color: '#1E74B3',
              }}
            >
              OR
            </Typography>

            <div
              style={{
                border: '3px solid #1E74B3',
                padding: '10px',
                borderRadius: '15px',
                margin: '1rem',
                textAlign: 'center',
                height: '200px',
                color: '#1E74B3',
                alignContent: 'center',

              }}
              onDrop={handleDrop}
              onDragOver={(e) => e.preventDefault()}
            >
              Drag & Drop to Upload File
            </div>
          </div>


          {fileInputFiles.length > 0 && (
            <div>
              {fileInputFiles.map((file, index) => (
                <Typography key={index} variant="body1" sx={{ marginLeft: '20px' }}>{file.name}</Typography>
              ))}
            </div>
          )}

          <label htmlFor="file-upload-excel" style={{ cursor: 'pointer' }}>
            <div
              style={{
                border: '3px dashed #1E74B3',
                padding: '10px',
                borderRadius: '15px',
                margin: '1rem',
                // justifyContent: 'center',
                // alignItems: 'center',
                textAlign: 'center',
                color: '#1E74B3',
                // width: '330px',
                marginLeft: '25',
                alignContent: 'center',
              }}
            >
              <Typography variant="body1" fontWeight="bold" mb={1}>
                Browse Excel File
              </Typography>
              <input
                id="file-upload-excel"
                type="file"
                accept=".csv, .xlsx"
                onChange={handleFileSelectExcel}
                style={{ display: 'none' }}
                multiple
              />

            </div>   
          </label>
          {inputExcel.length > 0 && (
            <div>
              {inputExcel.map((file, index) => (
                <Typography key={index} variant="body1" sx={{ marginLeft: '20px' }}>{file.name}</Typography>
              ))}
            </div>      
          )}
          <Typography color="custom" variant="body1" sx={{ marginLeft: "30%" }}>
            <a href="/assets/Parsing-Candidate.xlsx" download style={{ textDecoration: 'underline', color: '#1E74B3' }}>
              Download Excel Format
            </a>
          </Typography>
                                        
        </Box>   
      </Modal>   */}



      <Modal open={parse} onClose={parseClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: {
              xs: '90%',
              sm: '70%',
              md: '50%',
              lg: '30%',
            },
            backgroundColor: 'white',
            border: '4px solid #1E74B3',
            borderRadius: '13px',
            p: 2,
            outline: 'none',
            maxHeight: '90vh',
            overflowY: 'auto',
          }}
        >

          <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
            <Box
              sx={{
                border: '3px dashed #1E74B3',
                p: 2,
                borderRadius: '15px',
                my: 2,
                textAlign: 'center',
                color: '#1E74B3',
              }}
            >
              <Typography variant="body1" fontWeight="bold" mb={1}>
                Browse File
              </Typography>
              <input
                id="file-upload"
                type="file"
                accept=".doc,.docx,application/pdf"
                onChange={handleFileSelect}
                style={{ display: 'none' }}
                multiple
              />
            </Box>
          </label>

          <Typography
            variant="body1"
            fontWeight="bold"
            mb={1}
            sx={{
              textAlign: 'center',
              color: '#1E74B3',
            }}
          >
            OR
          </Typography>

          <Box
            sx={{
              border: '3px solid #1E74B3',
              p: 2,
              borderRadius: '15px',
              my: 2,
              textAlign: 'center',
              height: '200px',
              color: '#1E74B3',
            }}
            onDrop={handleDrop}
            onDragOver={(e) => e.preventDefault()}
          >
            Drag & Drop to Upload File
          </Box>

          {fileInputFiles?.length > 0 && (
            <Box sx={{ px: 2 }}>
              {fileInputFiles?.map((file, index) => (
                <Typography key={index} variant="body2">
                  {file.name}
                </Typography>
              ))}
            </Box>
          )}

          <label htmlFor="file-upload-excel" style={{ cursor: 'pointer' }}>
            <Box
              sx={{
                border: '3px dashed #1E74B3',
                p: 2,
                borderRadius: '15px',
                my: 2,
                textAlign: 'center',
                color: '#1E74B3',
              }}
            >
              <Typography variant="body1" fontWeight="bold" mb={1}>
                Browse Excel File
              </Typography>
              <input
                id="file-upload-excel"
                type="file"
                accept=".csv,.xlsx"
                onChange={handleFileSelectExcel}
                style={{ display: 'none' }}
                multiple
              />
            </Box>
          </label>

          {inputExcel?.length > 0 && (
            <Box sx={{ px: 2 }}>
              {inputExcel?.map((file, index) => (
                <Typography key={index} variant="body2">
                  {file.name}
                </Typography>
              ))}
            </Box>
          )}

          <Typography
            color="custom"
            variant="body2"
            sx={{ textAlign: 'center', mt: 2 }}
          >
            <a
              href="/assets/Parsing-Candidate.xlsx"
              download
              style={{
                textDecoration: 'underline',
                color: '#1E74B3',
              }}
            >
              Download Excel Format
            </a>
          </Typography>
        </Box>
      </Modal>




















      <Modal open={deleteModalOpen} onClose={handleCloseDeleteModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '50%', md: '40%' },
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
            bgcolor: 'background.paper',
          }}
        >
          <Typography variant="h6" color="red" textAlign="center">
            Are you sure you want to delete selected data(s)?
          </Typography>

          <Stack
            flexDirection={{ xs: 'column', md: 'row' }}
            gap={2}
            mt={2}
            alignItems="center"
            justifyContent="center"
          >
            <Button
              color="custom"
              variant="contained"
              // fullWidth={{ xs: true, md: false }} 

              onClick={() => multipleDelete()}
              disabled={loadingMov || isButtonDisabled}

            >
              {loadingMov ? <CircularProgress size={24} /> : 'Yes'}
            </Button>
            <Button
              color="custom"
              variant="contained"
              // fullWidth={{ xs: true, md: false }} 
              onClick={handleCloseDeleteModal}
            >
              No
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
}

export default Worksheet;





































function ResumeRow({ row, fun, fun2, fun3, skillsett, joblst1, filterTab,
  index, pinned, tempList, addedSkills, favFun, setEndClientName, handleCheck1,
  checked1, endClientName, tableShow,getHotlistList,selectedHotlist,savedSearch11 }) {

  //  ==============>>>>>>>> email popup

  const [emailModalOpen2, setEmailModalOpen2] = useState(false);
  const handleEmailModalOpen2 = () => setEmailModalOpen2(true);
  const handleEmailModalClose2 = () => setEmailModalOpen2(false);

  // EMAIL LIST STATE
  const [emails2, setEmails2] = useState([]);



  console.log("idddd===>>", emails2)

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [candidateId2, setCandidateId2] = useState("");








  const [emailDeleteAllOpen, setEmailDeleteAllOpen] = useState(false);

  // Open modal
  const emailDeleteAllOpenModal = () => {
    setEmailDeleteAllOpen(true);
  };

  // Close modal
  const emailDeleteAllCloseModal = () => {
    setEmailDeleteAllOpen(false);
  };


















  const [temp, setTemp] = useState('Template');
  // const [subject, setSubject] = useState('');
  const [editor, setEditor] = useState('');

  const [date, setDate] = useState('')
  const [openModal, setOpenModal] = useState(false)

  const [date1, setDate1] = useState('')
  const [date2, setDate2] = useState('')
  const [openModal1, setOpenModal1] = useState(false)
  const [openModal2, setOpenModal2] = useState(false)

  const [candidateId, setCandidateId] = useState('')
  const [selectedCandidateId, setSelectedCandidateId] = useState('');
  const [base64, setBase64] = useState([])
  const [fileName, setFileName] = useState('')
  const [fileType, setFileType] = useState('')
  const [attachment, setAttachment] = useState('')

  // console.log("candidateId ====>>>>",candidateId )
  // console.log("selectedCandidateId ====>>>>", selectedCandidateId)

  const [selectedFile, setSelectedFile] = useState(null);

  const FileChange = (event) => {
    const file = event.target.files[0];
    // console.log("file---", event.target.files)
    if (file) {
      setFileName(file.name)
      setFileType(file.type)
      convertFileToBase64(file);
      uploadAttach(file)
    } else {
      toast.warn('No file selected!');
    }
  };

  const uploadAttach = async (file) => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', file);
    formData.append('directoryName', 'resume');
    try {
      const response = await UploadFile('resume/upload_resume', formData, token);
      if (response.status === 200 && response.data.code === 200) {
        setAttachment(response.data.filePath)
      } else {
        //   toast.warn(response.data.status + '!');
      }
    } catch (error) {
      // toast.warn('Error uploading the image!');
    }
  };

  const convertFileToBase64 = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64(reader.result);
      // console.log("base64",reader.result)
    };
    reader.readAsDataURL(file);
  };

  const [greeting, setGreeting] = useState('')
  const [greet1, setGreet1] = useState('')
  const [greet2, setGreet2] = useState('')
  const [greet3, setGreet3] = useState('')

  const [recipientEmail, setRecipientEmail] = useState(row.email);
  const [subject, setSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [bccEmail, setBccEmail] = useState([]);
  const [ccEmail, setCcEmail] = useState([]);

  console.log("lethofarray====>>>", ccEmail )
  const [uploadfilee, setUploadFile] = useState('')
  const [selectedTemplate, setSelectedTemplate] = useState()
  const [sub1, setSub1] = useState('')
  const [sub2, setSub2] = useState('')
  const [sub3, setSub3] = useState('')
  const [body1, setBody1] = useState('')
  const [body2, setBody2] = useState('')
  const [body3, setBody3] = useState('')
  const [emailDate, setEmailDate] = useState('')
  const [hideEmail, setHideEmail] = useState(false)
  const [time1, setTime1] = useState(dayjs())
  const [time2, setTime2] = useState(dayjs())
  const [time3, setTime3] = useState(dayjs())
  const [date3, setDate3] = useState('')
  const [checked, setChecked] = useState(false);
  const [checkedEmail1, setCheckedEmail1] = useState(false);
  const [checkedEmail2, setCheckedEmail2] = useState(false);
  const [checkedEmail3, setCheckedEmail3] = useState(false);
  const [editBody, setEditBody] = useState('')

  const [emailData, setEmailData] = useState({
    sub: "",
    greet: "",
    body: "",
    emailRep: "",
    followUp1Rep: "",
    followUp2Rep: "",
    edit: "",
    editClick: ""
  });

  const sign = localStorage.getItem('sign')

  const [emailModalOpen, setEmailModalOpen] = useState(false);

  const handleOpenEmailModal = (sub, greet, body, emailRep, followUp1Rep, followUp2Rep, edit, editClick) => {
    // console.log("item", sub, greet, body)
    setEditBody(edit)
    setEmailData({ sub, greet, body, emailRep, followUp1Rep, followUp2Rep, edit, editClick });
    setEmailModalOpen(true);
  };


  // console.log("krishnapal", emails2);
  const handleCloseEmailModal = () => {
    setEmailModalOpen(false);
  };

  //  console.log("edit", editBody)

  // {
  //       "recipientEmail": recipientEmail,
  //       "bccEmail": bcc,
  //       "ccEmail": cc,

  //     }
  // console.log("bccEmail", bccEmail.inputValue)
  // console.log("ccEmail", ccEmail.inputValue)


  const bcc = bccEmail.map((item) => ({
    name: item.name || "",
    email: item.title || ""
  }));

  const cc = ccEmail.map((item) => ({
    name: item.name || "",
    email: item.title || ""
  }));

  const recipient = {
    name: row?.fullName || "",
    email: recipientEmail || ""
  };

  const finalArray = [
    recipient,
    ...bcc,
    ...cc
  ];

  // console.log("Final:", finalArray);

  // console.log("bccEmail", bcc);
  // console.log("ccEmail", cc);

  const SendEmailNotInUse = async () => {
    const body = {
      "subject": subject,
      "attachment": attachment,
      "fileName": fileName,
      "others":
        //   [
        //   {
        //     "name": row?.fullName,
        //     "email": recipientEmail
        //   }
        //   // bccEmail,
        // ],  
        finalArray,
      "mailBody": emailBody

    };
    const token = localStorage.getItem('token');
    Api(`email/send_bulk_mail`, 'POST', body, token)
      .then((response) => {
        // console.log('====rec ====', response);
        if (response.status === 200) {
          handleCloseModal()
          toast.success(response.data.message)
          // alert('Email sent successfully!');
          if (checked && (checkedEmail1 || checkedEmail2 || checkedEmail3)) {
            scheduleEmail();
          } else if (checked === true) {
            scheduleEmail()
            // alert("all checked")
          }
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
      });
  };

  const [loadingSend, setLoadingSend] = useState(false)

  const SendEmail = () => {
    setLoadingSend(true)
    // const ebody = `<p>${greeting}${' '}${row.fullName}</p>${emailBody}`
    const token = localStorage.getItem('token')
    const bcc = [];
    const cc = [];
    bccEmail.map((item) => {
      return bcc.push(item.title);
    });
    ccEmail.map((item) => {
      return cc.push(item.title);
    });
    const body =
    {
      "subject": subject,
      // 'emailBody': `<p>${greeting}${' '}${row.fullName}</p>${emailBody}${sign}`,
      'emailBody': emailBody,
      "recipientEmail": recipientEmail,
      "bccEmail": bcc,
      "ccEmail": cc,
      // "base64File": base64,
      "base64File": attachment,
      "fileType": fileType,
      "fileName": fileName,
      // "name":row.fullName,
      "name": row.fullName
        ? row.fullName.trim().split(" ")[0].charAt(0).toUpperCase() +
        row.fullName.trim().split(" ")[0].slice(1).toLowerCase()
        : "",
      "autoMailer": checked,
      "candidateId": selectedCandidateId,
      "date": dayjs().valueOf(),
      "hours": dayjs().hour(),
      "minute": dayjs().minute(),
      // "time": dayjs().format("HH:mm")
      "mailFrom": "recruiterworksheet",
    }
    Api('email/mail/instant', 'POST', body, token)
      .then(response => {

         console.log("emailData ====>>>>>>>>>", response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            handleCloseModal()
            toast.success(response.data.message)
            // alert('Email sent successfully!');
            // if (checked && (checkedEmail1 || checkedEmail2 || checkedEmail3)) {
            //   scheduleEmail();
            // } else if (checked === true) {
            //   scheduleEmail()
            //   // alert("all checked")
            // }
            if (checked) {
              scheduleEmail(response.data.scheduleId);
            }
            setLoadingSend(false)
          } else {
            toast.error(response.data.message)
            // alert('Failed to send email.');
          }
        }
        else{
          

                  setLoadingSend(false)
                    handleCloseModal()
                 toast.warn(response.data.message)

        }
      })
      .catch(error => {
        console.error('Error sending email:', error);
        // alert('Error sending email. Please try again.');
      });
  };

  // const scheduleEmail = () => {
  //   // alert("===>>>>scheduled")
  //   const token = localStorage.getItem('token')
  //   const bcc = [];
  //   const cc = [];
  //   bccEmail.map((item) => {
  //     return bcc.push(item.title);
  //   });
  //   ccEmail.map((item) => {
  //     return cc.push(item.title);
  //   });

  //   const date1Time = dayjs(date1).hour(dayjs(time1).hour()).minute(dayjs(time1).minute())
  //   const date2Time = dayjs(date2).hour(dayjs(time2).hour()).minute(dayjs(time2).minute())
  //   const date3Time = dayjs(date3).hour(dayjs(time3).hour()).minute(dayjs(time3).minute())
  //   const body = {
  //     "candidateId": selectedCandidateId,
  //     "templates": [
  //       {
  //         "emailOrder": "followup one",
  //         // "date": dayjs(date1).get('date'),
  //         "date": new Date(date1Time).getTime(),
  //         // "year":dayjs(date1).get('year'),
  //         // "month": dayjs(date1).get('month'),
  //         // "time": dayjs(time1).format('LT'),
  //         // "time": dayjs(time1).format('HH:mm'),
  //         "subject": sub1,
  //         // "emailBody": `<p>${greeting}${' '}${row.fullName}</p>${body1}${sign}`,
  //         "emailBody": body1,
  //         // "fileUrl": "base64_encoded_file_content", // replace this with actual base64 content if any
  //         "recipientEmail": recipientEmail,
  //         "bccEmail": bcc,
  //         "ccEmail": cc,
  //         // "name":row.fullName,
  //         "name": row.fullName
  //           ? row.fullName.trim().split(" ")[0].charAt(0).toUpperCase() +
  //           row.fullName.trim().split(" ")[0].slice(1).toLowerCase()
  //           : "",
  //         // "hours": dayjs(time1).hour(),
  //         // "minute": dayjs(time1).minute()
  //       },
  //       { 
  //         "emailOrder": "followup two",
  //         // "date": dayjs(date2).get('date'), 
  //         "date": new Date(date2Time).getTime(),
  //         // "year":dayjs(date2).get('year'),
  //         // "month": dayjs(date2).get('month'),
  //         // "time": dayjs(time2).format('LT'),
  //         // "time": dayjs(time2).format('HH:mm'),
  //         "subject": sub2,
  //         // "emailBody": `<p>${greeting}${' '}${row.fullName}</p>${body2}${sign}`,
  //         "emailBody": body2,
  //         // "fileUrl": "base64_encoded_file_content", // replace this with actual base64 content if any
  //         "recipientEmail": recipientEmail,
  //         "bccEmail": bcc,
  //         "ccEmail": cc,
  //         // "name":row.fullName,
  //         "name": row.fullName
  //           ? row.fullName.trim().split(" ")[0].charAt(0).toUpperCase() +
  //           row.fullName.trim().split(" ")[0].slice(1).toLowerCase()
  //           : "",
  //         // "hours": dayjs(time2).hour(),
  //         // "minute": dayjs(time2).minute()
  //       },
  //       {
  //         "emailOrder": "followup three",
  //         // "date": dayjs(date3).get('date'),
  //         "date": new Date(date3Time).getTime(),
  //         // "year":dayjs(date3).get('year'),
  //         // "month": dayjs(date3).get('month'),
  //         // "time": dayjs(time3).format('LT'),
  //         // "time": dayjs(time3).format('HH:mm'),
  //         "subject": sub3,
  //         "emailBody": body3,
  //         // "emailBody": `<p>${greeting}${' '}${row.fullName}</p>${body3}${sign}`,
  //         // "fileUrl": "base64_encoded_file_content", // replace this with actual base64 content if any
  //         "recipientEmail": recipientEmail,
  //         "bccEmail": bcc,
  //         "ccEmail": cc,
  //         // "name":row.fullName,
  //         "name": row.fullName
  //           ? row.fullName.trim().split(" ")[0].charAt(0).toUpperCase() +
  //           row.fullName.trim().split(" ")[0].slice(1).toLowerCase()
  //           : "",
  //         // "hours": dayjs(time3).hour(),
  //         // "minute": dayjs(time3).minute()
  //       }
  //     ] 
  //   }
  //   Api('email/mail/schedule', 'POST', body, token)
  //     .then(response => {
  //       try {
  //         // console.log("emailData ====>>>>>>>>>", response.data);
  //         if (response.status === 200) {
  //           if (response.data.code === 200) {
  //             toast.success(response.data.message);
  //           } else if (response.data.code === 400 && response.data.message === "Emails already scheduled") {
  //             toast.warn(response.data.message);
  //           } else {
  //             toast.error(response.data.message);
  //           }
  //         } else {
  //           toast.error('Emails already scheduled.');
  //         }
  //       } catch (error) {
  //         console.error('Error handling response:', error);
  //         toast.error('Error handling response. Please try again.');
  //       }
  //     })
  //     .catch(error => {
  //       console.error('Error sending email:', error);
  //       toast.error('Error sending email. Please try again.');
  //     });

  // };

  const scheduleEmail = (scheduleId) => {


    const token = localStorage.getItem('token');
    const bcc = bccEmail.map(item => item.title);
    const cc = ccEmail.map(item => item.title);

    const templates = [];

    // FOLLOWUP 1
    if (checkedEmail1) {
      const date1Time = dayjs(date1).hour(dayjs(time1).hour()).minute(dayjs(time1).minute());
      templates.push({
        emailOrder: "followup one",
        date: new Date(date1Time).getTime(),
        subject: sub1,
        mailFrom: "recruiterworksheet",
        emailBody: body1,
        recipientEmail,
        bccEmail: bcc,
        ccEmail: cc,
        name: row.fullName
          ? row.fullName.trim().split(" ")[0].charAt(0).toUpperCase() +
          row.fullName.trim().split(" ")[0].slice(1).toLowerCase()
          : "",
      });
    }

    // FOLLOWUP 2
    if (checkedEmail2) {
      const date2Time = dayjs(date2).hour(dayjs(time2).hour()).minute(dayjs(time2).minute());
      templates.push({
        emailOrder: "followup two",
        date: new Date(date2Time).getTime(),
        subject: sub2,
        emailBody: body2,
        recipientEmail,
        mailFrom: "recruiterworksheet",
        bccEmail: bcc,
        ccEmail: cc,
        name: row.fullName
          ? row.fullName.trim().split(" ")[0].charAt(0).toUpperCase() +
          row.fullName.trim().split(" ")[0].slice(1).toLowerCase()
          : "",
      });
    }

    // FOLLOWUP 3
    if (checkedEmail3) {
      const date3Time = dayjs(date3).hour(dayjs(time3).hour()).minute(dayjs(time3).minute());
      templates.push({
        emailOrder: "followup three",
        date: new Date(date3Time).getTime(),
        subject: sub3,
        emailBody: body3,
        recipientEmail,
        mailFrom: "recruiterworksheet",
        bccEmail: bcc,
        ccEmail: cc,
        name: row.fullName
          ? row.fullName.trim().split(" ")[0].charAt(0).toUpperCase() +
          row.fullName.trim().split(" ")[0].slice(1).toLowerCase()
          : "",
      });
    }

    if (templates.length === 0) {
      toast.warn("Please select at least one follow-up email to schedule.");
      return;
    }

    const body = {
      candidateId: selectedCandidateId,
      templates,
      scheduleId
    };
    console.log("shya,lal",);
    Api('email/mail/schedule', 'POST', body, token)
      .then(response => {
        try {
          if (response.status === 200) {
            if (response.data.code === 200) {
              toast.success(response.data.message);
            } else if (response.data.code === 400 && response.data.message === "Emails already scheduled") {
              toast.warn(response.data.message);
            } else {
              toast.error(response.data.message);
            }
          } else {
            toast.error('Emails already scheduled.');
          }
        } catch (error) {
          // console.error('Error handling response:', error);
          // toast.error('Error handling response. Please try again.');
        }
      })
      .catch(error => {
        // console.error('Error sending email:', error);
        // toast.error('Error sending email. Please try again.');
      });
  };

  // const uploadFile = async (pdf) => {
  //   const token = localStorage.getItem('token');
  //   const formData = new FormData();
  //   formData.append('document', pdf);
  //   formData.append('directoryName', 'resume');
  //   UploadFile(`resume/upload_resume`, formData, token).then((Response) => {
  //     if (Response.status === 200) {
  //       if (Response.data.code === 200) {
  //         setUploadFile(Response.data.filePath)
  //         console.log('=====404=gst===', Response.data.filePath);
  //       } else {
  //         console.log('=====404=gst===', Response.data.message);
  //         toast.warn(Response.data.status, +'!');
  //       }
  //     } else {
  //       toast.warn('Error !');
  //     }
  //   });
  // };

  const [commonBody, setCommonBody] = useState('')

  const handleTemplateSelect = (item) => {
    // const selectedTemplate = tempList.find((item) => item.templateName === templateName);
    setSelectedTemplate(item.template);
    // console.log("item====", item)
    if (item && item.template && item.template.length > 0) {

      setGreeting(item.template[0].greeting)
      // console.log("selectedTemplate ====>>>>>>>", item.template[0].greeting);
      setSubject(item.template[0].subject)
      setEmailBody(item.template[0].emailBody)

      setSub1(item.template[1].subject)
      setBody1(item.template[1].emailBody)
      setGreet1(item.template[1].greeting)

      setSub2(item.template[2].subject)
      setBody2(item.template[2].emailBody)
      setGreet2(item.template[2].greeting)

      setSub3(item.template[3].subject)
      setBody3(item.template[3].emailBody)
      setGreet3(item.template[3].greeting)

      setEmailDate(item.createdAt)
      setHideEmail(true)
    }
  };

  // console.log("time1", time1)
  // console.log("date1", date1)

  const saveLocallyBody = () => {

    // console.log("edit", emailData.editClick)
    if (emailData.editClick === "editClickEmail1") {
      setBody1('');
      setBody1(commonBody);
    } else if (emailData.editClick === "editClickEmail2") {
      setBody2('');
      setBody2(commonBody);
    } else if (emailData.editClick === "editClickEmail3") {
      setBody3('');
      setBody3(commonBody);
    }
    handleCloseEmailModal()
  };

  // const body1Ref = useRef("");
  // const body2Ref = useRef(""); 
  // const body3Ref = useRef("");

  // const saveLocallyBody = (bodyy) => {
  //   if (emailData.editClick === "editClickEmail1") {
  //     body1Ref.current = bodyy;
  //     setBody1(commonBody);
  //     console.log("body1:", body1Ref.current);
  //   } else if (emailData.editClick === "editClickEmail2") {
  //     body2Ref.current = bodyy;
  //     setBody2(commonBody);
  //     console.log("body2:", body2Ref.current);
  //   } else if (emailData.editClick === "editClickEmail3") {
  //     body3Ref.current = bodyy;
  //     setBody3(commonBody);
  //     console.log("body3:", body3Ref.current);
  //   }
  // };

  // console.log("body1", body1)
  // console.log("body2", body2)
  // console.log("body3", body3)

  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split('T')[0];
  }
  const [email, setEmail] = useState("")
  // const [email, setEmail] = useState(getTomorrowDate())

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleDateSelect = (selectedDate) => {
    const formattedDate = selectedDate.toISOString().split('T')[0];
    setDate1(formattedDate);
    setOpenModal(false);
  };

  const getDateFromThreeDaysLater = () => {
    const threeDaysLater = new Date();
    threeDaysLater.setDate(threeDaysLater.getDate() + 4);
    return threeDaysLater.toISOString().split('T')[0];
  }
  const [email1, setEmail1] = useState('')
  // const [email1, setEmail1] = useState(getDateFromThreeDaysLater())
  const handleModalOpen1 = () => {
    setOpenModal1(true);
  };

  const handleModalClose1 = () => {
    setOpenModal1(false);
  };

  const handleDateSelect1 = (selectedDate) => {
    // console.log(dayjs(selectedDate).format("YYYY-MM-DD"))
    const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");

    //  const timestamp = dayjs(selectedDate).valueOf();
    // const timestamp = dayjs(selectedDate).unix();

    // console.log('timestamp', dayjs(selectedDate).valueOf());
    // console.log('timestamp', dayjs(selectedDate).unix());

    // setDate1(dayjs(selectedDate).valueOf());
    setDate1(formattedDate);
    setOpenModal(false);
  };

  const getDateFromOneWeekLater = () => {
    const OneWeekLater = new Date();
    OneWeekLater.setDate(OneWeekLater.getDate() + 9);
    return OneWeekLater.toISOString().split('T')[0];
  }
  const [email2, setEmail2] = useState('')
  // const [email2, setEmail2] = useState(getDateFromOneWeekLater())
  const handleModalOpen2 = () => {
    setOpenModal2(true);
  };

  const handleModalClose2 = () => {
    setOpenModal2(false);
  };


  const handleDateSelect2 = (selectedDate) => {
    const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
    // const formattedDate = selectedDate.toISOString().replace('T', ' ').split('.')[0];
    // setDate2(formattedDate);
    // setDate2(dayjs(selectedDate).valueOf());
    setDate2(formattedDate);
    // console.log("====>>>>>", formattedDate);
    handleModalClose1(false)
  };

  const handleDateSelect3 = (selectedDate) => {
    const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
    // const formattedDate = selectedDate.toISOString().replace('T', ' ').split('.')[0];
    setDate3(formattedDate);
    // setDate3(dayjs(selectedDate).valueOf());
    // console.log("====>>>>>", formattedDate);
    setOpenModal2(false);
  };

  const [modalOpen, setModalOpen] = useState(false);

  // const handleOpenModal = () => {
  //   // alert('hello')
  //   getCandidateId()
  //   setModalOpen(true);

  // };

  const handleOpenModal = (id) => {
    setSelectedCandidateId(id);
    setModalOpen(true);
    // alert(`Selected Candidate ID: ${id}`);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  // const getTemplList = () => {
  //   const token = localStorage.getItem('token');
  //   // console.log("token ===>>>>> ",token)
  //   Api('email/getEmailTemplateList', 'GET', '', token)
  //     .then((response) => {
  //       console.log('Response:---------', response);
  //       if (response.status === 200) {
  //         if (response.data.code === 200) {
  //           //  console.log("hhh")
  //           // if (response.data.result.length > 0) {
  //           //   const firstTemplate = response.data.result;
  //           //   setUserId(firstTemplate.userId);
  //           //   setCompanyId(firstTemplate.companyId);
  //           // }
  //           const temp = response.data.result;
  //           const extractedData = temp.map((item) => {
  //             return {
  //               companyId: item.companyId,
  //               userId: item.userId
  //             };
  //           });
  //           // console.log('Extracted Data:', extractedData);

  //           if (extractedData.length > 0) {
  //             const firstItem = extractedData;
  //             // setCompanyId(firstItem.companyId); 
  //             // setUserId(firstItem.userId); 
  //           }

  //         } else {
  //           console.log('data:', response.data.message);
  //         }
  //       }
  //       setTempList(response.data.result);
  //       // setUserId(response.data.result.userId)
  //       // setCompanyId(response.data.result.companyId)
  //     })
  //     .catch((error) => {
  //       console.error("Error:", error);
  //     });
  // };

  useEffect(() => {

    // console.log('=================date===>>>', filterTab);
    if (skillsett.length > 0) {
      setSkillset(skillsett);
    }
    if (row.skill) {

      row.skill.map((item) => temparr.push({ title: item }))
    }
  }, []);

  const navigate = useNavigate();
  const [tmpskl, setTmpskl] = useState([]);

  const [status, setStatus] = useState('Pending');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openpdf, setOpenpdf] = useState(false);

  const [openskill, setOpenskill] = useState(true);
  const skillclose = () => setOpenskill(false);
  const [open1, setOpen1] = useState(false);
  const handleEdit = () => {
    setOpen1(true);
  };
  const handleCloseEdit = () => setOpen1(false);

  const [esub, setSub] = useState(false);
  const openEsub = () => setSub(true);
  const closeEsub = () => setSub(false);
  const [subto, setSubto] = useState(row.type);
  const [esubdata, setEsubdata] = useState({
    subjobid: row.jobId,
    expectedCom: row.expectedCompensation,
    comType: row.chargeType,
    pname: row.positionName,
    cname: row.clientName,
    tax: row.taxTerm,
    clientid: ''
  });
  const [clientlist, setClientlst] = useState([])
  const [eplace, setEplace] = useState(false);
  const openEplace = () => setEplace(true);
  const closeEplace = () => setEplace(false);
  const [eplacedata, setEplacedata] = useState({
    placestatus: "placed",
    jobType: row.jobType,
    offeredJob: row.offeredJob,
    AnnualSalary: row.annualSalary,
    JoiningBonus: row.joiningBonus,
    AnnualBonus: row.annualBonus,
    ReloAssistance: row.relocationAssistance,
    hro: row.hourlyRateRateOffered,
    TaxTerm: row.taxTerm,
    OvertimeExpense: row.overTimeExpence,
    Additional: row.additionals,
    placenote: ""
  });
  const [tsd, setTsd] = React.useState(dayjs(row.tentativeStartDate));
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [totalDays, setTotalDays] = useState(0);
  const [opens, setOpens] = useState(false);
  const handleOpens = () => setOpens(true);
  const handleCloses = () => setOpens(false);

  const [addSkill, setAddSkill] = useState(false);
  const handleSkillOpen = () => setAddSkill(true);
  const handleSkillClose = () => setAddSkill(false);

 
 
 

  const [his, setHis] = useState([]);



// const [openn, setOpenn] = useState(false);

//   const handleOpenn = () => {
//     setOpenn(true);
//     getHis();
//   };
//   const handleClosen = () => setOpenn(false);



//  function MouseHoverPopover() {
//   const [anchorEl, setAnchorEl] = React.useState(null);

//   const handlePopoverOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//       getHis();
//   };

//   const handlePopoverClose = () => {
//     setAnchorEl(null);
//   };

//   const open = Boolean(anchorEl);

//   return (
//     <div>
//       <Typography
//         aria-owns={open ? 'mouse-over-popover' : undefined}
//         aria-haspopup="true"
//         onMouseEnter={handlePopoverOpen}
//         onMouseLeave={handlePopoverClose}
//       >
//         Notes
//       </Typography>
//       <Popover
//         id="mouse-over-popover"
//         sx={{ pointerEvents: 'none' }}
//         open={open}
//         anchorEl={anchorEl}
      
//         onClose={handlePopoverClose}
//         disableRestoreFocus

//          anchorReference="anchorPosition"
//   anchorPosition={{ top: window.innerHeight / 2, left: window.innerWidth / 2 }}
//   transformOrigin={{
//     vertical: 'center',
//     horizontal: 'center',
//   }}
//       >
   
//          <Box 
//            sx={{ p: 3 }}
//   >
//           <Stack sx={{ width: '100%', alignItems: 'flex-end' }}>
//             <Button
//               color="custom"
//               variant="contained"
//               size="small"
//               onClick={() =>
//                 navigate('/resumeDetail', {
//                   state: {
//                     addedSkills,
//                     row,
//                     mtab: 'Resume',
//                     fTab:
//                       filterTab === 'worksheet'
//                         ? 'submitted'
//                         : '' || filterTab === 'favourites'
//                           ? 'submitted'
//                           : '' || filterTab === 'interview'
//                             ? 'placement'
//                             : '' || filterTab === 'placement'
//                               ? 'start'
//                               : '',
//                   },
//                 })
//               }
//             >
//               Add Note
//             </Button>
//           </Stack>
//           <Typography variant="h5" color={'#3C6BA5'} sx={{ textTransform: 'capitalize', mt: -3 }} textAlign={'center'}>
//             Notes
//           </Typography>
//           <Divider sx={{ mb: 2 }} />

//           <Box sx={{ maxHeight: 400, overflowX: 'auto' }}>
//             <Stack sx={{ backgroundColor: 'text.secondary', flexDirection: 'row', p: 1, py: 0.5, borderRadius: 1, minWidth: 600 }}>
//               <Typography color={'white'} sx={{ width: '20%', fontSize: '0.976rem', fontWeight: '600' }}>
//                 Date
//               </Typography>
//               <Typography color={'white'} sx={{ width: '20%', fontSize: '0.976rem', fontWeight: '600' }}>
//                 User
//               </Typography>
//               <Typography color={'white'} sx={{ width: '60%', fontSize: '0.976rem', fontWeight: '600' }}>
//                 Note
//               </Typography>
//             </Stack>

//             {his.length
//               ? his.map((item, index) => {
//                 return (
//                   <Stack
//                     key={index}
//                     sx={[
//                       { background: index % 2 === 0 ? 'text.background' : tablebg },
//                       { flexDirection: 'row', p: 1, minWidth: 600 },
//                     ]}
//                   >
//                     <Typography sx={{ width: '20%' }}>
//                       {`${new Date(item.createdAt).toLocaleString('en-US', optionsDate)} 
// ${String(new Date(item?.createdAt).getHours()).padStart(2, '0')}:${String(new Date(item?.createdAt).getMinutes()).padStart(2, '0')}`}
//                     </Typography>
//                     <Typography sx={{ width: '20%', textTransform: 'capitalize', fontWeight: '800', color: 'text.secondary' }}>
//                       {item.actionBy}
//                     </Typography>
//                     <Box sx={{ width: '60%', overflowX: 'auto' }}>

//                       <div
//   dangerouslySetInnerHTML={{
//     __html: `<span>${item?.noteReason || ''} :</span> ${item?.note || ''}`,
//   }}
//   style={{
//     lineHeight: '1.6',
//     fontSize: '1rem',
//     whiteSpace: 'pre-wrap',
//   }}
// />

// {/*                       
//                       <div
//                         dangerouslySetInnerHTML={{ __html: item?.note }}
//                         style={{
//                           lineHeight: '1.6',
//                           fontSize: '1rem',
//                           whiteSpace: 'pre-wrap',
//                         }}
//                       /> */}
//                     </Box>
//                   </Stack>
//                 );
//               })
//               : null}
//           </Box>
//         </Box>
//       </Popover>
//     </div>
//   );
// }





// Modal state
const [openn, setOpenn] = useState(false);

// Popover state
const [anchorEl, setAnchorEl] = useState(null);

// MODAL
const handleOpenn = () => {
  setOpenn(true);
  getHis();
};

const handleClosen = () => {
  setOpenn(false);
};

// POPOVER
const handlePopoverOpen = (event) => {
  setAnchorEl(event.currentTarget);
  getHis();
};

const handlePopoverClose = () => {
  setAnchorEl(null);
};

const openPopover = Boolean(anchorEl);


  // code  of avtivity  

const [openActivitiesModal, setOpenActivitiesModal] = useState(false);
const [activitiesAnchorEl, setActivitiesAnchorEl] = useState(null);

const handleOpenActivitiesModal = () => {
  getClients();
          setOpenActivitiesModal(true);
};

const handleCloseActivitiesModal = () => {
         setOpenActivitiesModal(false);
};

const handleActivitiesPopoverOpen = (event) => {
  getClients();
  setActivitiesAnchorEl(event.currentTarget);
};

const handleActivitiesPopoverClose = () => {
  setActivitiesAnchorEl(null);
};
const openActivitiesPopover = Boolean(activitiesAnchorEl);

















































































































































































































  const [loadingSub, setLoadingSub] = useState(false)

  const EditSubmitted = async () => {
    setLoadingSub(true)
    const token = localStorage.getItem('token');
    // console.log("=====row.clientId", row.clientId)
    const body = {
      submissionId: row._id,
      clientId: esubdata.clientid,
      resumeId: row.resumeId,
      type: subto,
      jobId: esubdata.subjobid,
      expectedCompensation: esubdata.expectedCom,
      chargeType: esubdata.comType,
      positionName: esubdata.pname,
      clientName: esubdata.cname,
      taxTerm: esubdata.tax,
    };

    Api(`resume/update_any_step`, 'POST', body, token)
      .then((response) => {
        // console.log('==========update_any_step=====>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setLoadingSub(false)
            // setLevelM(false);
            closeEsub()
            row.clientId = esubdata.clientid;

            row.type = subto;
            row.jobId = esubdata.subjobid;
            row.expectedCompensation = esubdata.expectedCom;
            row.chargeType = esubdata.comType;
            row.positionName = esubdata.pname;
            row.clientName = esubdata.cname;
            row.taxTerm = esubdata.tax;
            row.createdAt = new Date().toISOString();
            toast.success(response.data.message);
            // console.log(row);
            // fun2();
          } else {
            toast.warn(response.data.message);
            setLoadingSub(false)
          }
        }
      })
      .catch((err) => { });
  };

  const EditPlacement = async () => {
    const token = localStorage.getItem('token');
    const body = {

      submissionId: row._id,
      resumeId: row.resumeId,
      status: eplacedata.placestatus === 'placed' ? 'placement' : 'prospect',
      result: eplacedata.placestatus,
      note: eplacedata.placenote,
      jobType: eplacedata.jobType,
      offeredJob: eplacedata.offeredJob,
      chargeType: eplacedata.offeredJob === 'fulltime' ? 'K' : 'hourly',
      annualSalary: eplacedata.AnnualSalary,
      joiningBonus: eplacedata.JoiningBonus,
      annualBonus: eplacedata.AnnualBonus,
      relocationAssistance: eplacedata.ReloAssistance,
      additionals: eplacedata.Additional,
      tentativeStartDate: tsd,
      taxTerm: eplacedata.TaxTerm,
      hourlyRateRateOffered: eplacedata.hro,
      overTimeExpence: eplacedata.OvertimeExpense,
      startStatus: '',

      type: subto,
      jobId: esubdata.subjobid,

    };
    Api(`resume/update_any_step`, 'POST', body, token)
      .then((response) => {
        // console.log('==========update_any_step=====>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            // setLevelM(false);
            toast.success(response.data.message);
            // console.log(row);
            fun2();
          } else {
            toast.warn(response.data.message);
          }
        }
      })
      .catch((err) => { });
  };

  const getHis = () => {
    const token = localStorage.getItem('token');
    Api(`resume/get_history/${filterTab === 'worksheet' ? row._id : row.resumeId}`, 'GET', '', token)
      .then((response) => {
        // console.log('==========get_history=====>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setHis(response.data.data);
            // setJoblst(response.data.data);
          }
        }
      })
      .catch((err) => { });
  };
    // const handleClosen = () => setOpenn(false);


  const [openinterview, setOpeninterview] = useState(false);
  const handleopeninterview = () => setOpeninterview(true);
  const handlecloseinterview = () => setOpeninterview(false);

  const [levelM, setLevelM] = useState(false);

  const [openclient, setOpenclient] = useState(false);
  const handleOpenclient = () => setOpenclient(true);
  const handleCloseclient = () => setOpenclient(false);

  const handleOpenpdf = () => setOpenpdf(true);
  const Closepdf = () => setOpenpdf(false);
  const [pdffile, setPdffile] = useState(row.resumeUrl);
  const [docfile, setDocfile] = useState();
  const [commentt, setCommentt] = useState('');
  const [statusNote, setStatusNote] = useState('')

  const [value, setValue] = useState({
    email: row?.email,
    name: row?.fullName,
    jobtitle: row?.jobTitle,
    currCompany: row?.currentCompany,
    phone: row?.phone,
    visa: row?.visaType,
    tax: row?.taxTerm,
    expectedCom: row?.expectedCompensation,
    jobid: row?.jobId,
    city: filterTab === 'worksheet' ? row?.city : row?.cityOrZipcode,
    reloc: row?.reallocate,
    notes: '',
    comType: row?.chargeType,
    fcity: '',
    scode: row?.stateCode,
    zip: row?.zipcode,
    status: row?.status,
    country: row?.country || localStorage.getItem("country"),
    userStatus: row?.userStatus,
    linkedinUrl: row?.linkedinUrl,
    state: row?.status,
  });

  const [tempskill, setTempskill] = useState([]);
  const temparr = [];
  const [skill, setSkill] = useState([{ title: 'zashi' }]);
  // console.log('new skill========>', row.skill);


  const [openy, setOpeny] = useState(false);
  // const [editMode, setEditMode] = useState(false);

  const [emaily, setEmaily] = useState(null);
  const [body, setBody] = useState("");





  const openAndLoad = (apiEmailData) => {
    setEmaily(apiEmailData);
    setBody(apiEmailData.emailBody);
    setOpeny(true);
  };

  const handleSave = () => {
    console.log("Final Body:", body);

    // Yaha API Save hoga
    // Api.updateEmail({ body })

    setOpeny(false);
  };
















  const [finallst, setFinallst] = useState(temparr);
  const [evalid, setEvalid] = useState(true);
  const [cityy, setCityy] = useState(filterTab === 'worksheet' ? row.city : row.cityOrZipcode || '');
  const [cityData, setcityData] = useState([]);
  // const [ city , setCity] = useState('')
  const [askill, setAskill] = React.useState(null);
  const [statee, setStatee] = useState('');
  const cities = [];
  const [skillset, setSkillset] = useState([{ title: 'item.skillName' }]);
  const [client, setClients] = useState([]);
  // console.log("client", client)
  const [cityandstate, setCityandstate] = useState({
    city: filterTab === 'worksheet' ? row.city : row.cityOrZipcode,
    state: row.state,
    stateCode: row.stateCode
  });
  const [choosefile, setChoosefile] = useState(false);
  const [leveltype, setLeveltype] = useState('');
  const [leveltimez, setLeveltimez] = useState('');
  const [leveltime, setLeveltime] = React.useState(dayjs());
  const [leveldate, setLeveldate] = React.useState(dayjs());
  const [subStatus, setSubStatus] = useState('');
  const [phoneCopy, setPhoneCopy] = useState(false);
  const [emailCopy, setEmailCopy] = useState(false);
  const [newcv, setNewcv] = useState('no')

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: '500px',
    // height: '50%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    // flexDirection: 'row',
    display: 'flex',
    gap: 2,
  };
  const style2 = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  };
  const style3 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 3,
  };
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#3366FF',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    color: 'white',
  }));
  const visalist = [
    { label: 'USC' },
    { label: 'GC' },
    { label: 'GCEAD' },
    { label: 'TN' },
    { label: 'H1B' },
    { label: 'H1b I 140 ' },
    { label: 'H4 EAD' },
    { label: 'OPT EAD' },
    { label: 'CPT EAD' },
    { label: 'E2 Visa' },
    { label: 'B 1 Visa' },
    { label: 'Canadian citizen' },
    { label: 'Open work permit' },
    { label: 'Permanent Resident' },
  ];

  function fixCity(e) {
    setValue({ ...value, city: e.target.value });
    if (e.target.value.length > 2) {
      getCity();
      // console.log('city set');
    }
  }

  const [err, setErr] = useState(false);
  const [helperText, setHelperText] = useState('');

  const getCity = async (val) => {
    setErr(false)
    setHelperText('')
    setcityData([])
    const token = localStorage.getItem('token');
    const body = {
      country: value.country,
      query: val,
    };
    Api(`resume/get_city_states`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          // console.log('=========status 200======>>>>>>>', response);
          if (response.data.code === 200) {
            // console.log('city========', JSON.stringify(response.data));
            setcityData(response.data.data);
            // setCityandstate(response.data.data[0]);
            // if (response.data.data[0].zip) {
            //   setValue({ ...value, zip: response.data.data[0].zip, scode: response.data.data[0].stateCode });
            // } else {
            //   setValue({ ...value, zip: '' });
            // }
          } else {
            // toast.error(response.data.message)
            setErr(true)
            setHelperText("No cities found for the given city name.")
            // toast.error(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };


  const pdfUpload = async (pdf) => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', pdf);
    formData.append("directoryName", "resume");
    formData.append("resumeName", value.name);
    UploadFile(`resume/upload_resume`, formData, token).then((Response) => {
      // console.log('=====upload Response========>', Response.data);
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          setNewcv('yes')
          setChoosefile(true);
          setDocfile('');
          toast.success(Response.data.status, +'!');
          //  console.log('=====404=gst===', Response.data.message);
          setPdffile(Response.data.filePath);
        } else {
          // console.log('=====404=gst===', Response.data.message);
          toast.warn(Response.data.status, +'!');
        }
      } else {
        toast.warn(Response.data.message, +'!');
      }
    });
  };

  const setContact = (e) => {
    const reg = /^[a-zA-Z]*$/;
    if (e.length) {
      const lst = e[e.length - 1];
      if (!lst.match(reg)) {
        setValue({
          ...value,
          phone: e,
        });
      }
    } else {
      setValue({
        ...value,
        phone: e,
      });
    }
  };

  // const [stateCode1, setStateCode1] = useState()
  // useState(() => {
  //   if (cityandstate) {
  //     setStateCode1(cityandstate.state);
  //   }
  // }, [cityandstate]);

  const [loadingEdit, setLoadingEdit] = useState(false)

  const editResume = (row) => {
    // console.log('update skill', finallst);
    const skillLst = [];
    finallst?.map((item) => {
      return skillLst?.push(item?.title?.toLowerCase());
    });

    const uniqueSkillLst = [...new Set(skillLst)];

    // console.log('after map skill', skillLst);
    const id = row._id;
    const token = localStorage.getItem('token');
    if (!value?.name) {
      toast.error("Full Name is Required");
      return;
    }
    if (!value?.jobtitle) {
      toast.error("Job Title is Required");
      return;
    }
    if (!value?.email) {
      toast.error("Email is Required");
      return;
    }

    setLoadingEdit(true)
    const body = {
      "newCV": newcv,
      resumeId: id,
      fullName: value.name,
      email: value.email,
      jobTitle: value?.jobtitle?.trim(),
      phone: value.phone,
      currentCompany: value.currCompany,
      skill: uniqueSkillLst,
      visaType: value.visa,
      taxTerm: value.tax,
      expectedCompensation: value.expectedCom,
      // cityOrZipcode: cityy,
      "city": cityy,
      zipcode: value.zip,
      stateCode: cityandstate.stateCode,
      state: cityandstate.state,
      // cityOrZipcode: "90291",
      reallocate: value.reloc,
      resumeUrl: pdffile,
      jobId: value.jobid,
      note: value.notes,
      status: value.status,
      chargeType: value.comType,
      userStatus: value.userStatus,
      country: value.country,
      linkedinUrl: value.linkedinUrl,
    };

    Api(`resume/update_resume`, 'POST', body, token)
      .then((Response) => {
        // console.log('======getUser==response=====>', Response);
        if (Response.status === 200) {
          if (Response.data.code === 200) {

            // Directly updating the `row` object
            row.newCV = newcv;
            row.fullName = value.name;
            row.email = value.email;
            row.jobTitle = value?.jobtitle?.trim();
            row.phone = value.phone;
            row.currentCompany = value.currCompany;
            row.skill = uniqueSkillLst;
            row.visaType = value.visa;
            row.taxTerm = value.tax;
            row.expectedCompensation = value.expectedCom;
            row.city = cityy;
            row.zipcode = value.zip;
            row.stateCode = cityandstate.stateCode;
            row.state = cityandstate.state;
            row.reallocate = value.reloc;
            row.resumeUrl = pdffile;
            row.jobId = value.jobid;
            row.note = value.notes;
            row.status = value.status;
            row.chargeType = value.comType;
            row.userStatus = value.userStatus;
            row.country = value.country;
            row.linkedinUrl = value.linkedinUrl;
            row.updatedAt = new Date().toISOString();

            // setValue({...value,
            //   email: "",
            //   name: "",
            //   jobtitle: "",
            //   currCompany: "",
            //   phone: "",
            //   visa: "",
            //   tax: "",
            //   expectedCom: "",
            //   jobid:"" ,
            //   city: "",
            //   reloc: "",
            //   notes: "",
            //   comType: "",
            //   fcity: '',
            //   scode: '',
            //   zip: "",
            //   status: "",
            //   country: "",
            //   userStatus: "",
            // })
            handleCloseEdit();
            toast.success(Response.data.message);
            // fun();
            setcityData([]);
            // setFinallst([]);
            setDocfile();
            setChoosefile(false);
            // console.log('======getUser===data.data pdata====>', Response);
            setLoadingEdit(false)
          } else {
            // console.log('======getUser=======>', +Response);
            // toast.warn(Response.data.message);
            // enqueueSnackbar(Response.data.message);
            setLoadingEdit(false)
          }
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
        // console.log('===========', err);
      });
  };

  const delfile = () => {
    // console.log('doc file', docfile);
    setDocfile(null);
    // setDocfile('')
    setPdffile('');
    // console.log('doc file------', docfile);
  };
  const handleEmail = (e) => {
    // console.log('======================true=====1=============>>>>>>>>>', evalid);

    setValue({ ...value, email: e.target.value });
    const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEvalid(reg.test(e.target.value));
    // setTimeout(() => {
    if (evalid === true) {
      // console.log('=======email valid', evalid);
    } else {
      // console.log('=======email unvalid', evalid);
    }
    // }, 1000);
    // console.log('======================true==================>>>>>>>>>', evalid);
  };
  // const chkmail = async (e) => {
  //   const token = localStorage.getItem('token');
  //   const body = {
  //     email: value.email,
  //   };
  //   Api(`resume/duplicate_check`, 'POST', body, token)
  //     .then((response) => {
  //       console.log('===============>>>>>>>', response);
  //       if (response.status === 200) {
  //       } else {
  //         toast.warn(response.data.message, +'!');
  //       }
  //     })
  //     .catch((err) => {
  //       console.log('===========', err);
  //     });
  // };

  const getClients = async () => {
    const token = localStorage.getItem('token');
    let id;
    if (filterTab === 'worksheet' || filterTab === 'favourites') {
      id = row._id
    }
    else {
      id = row.resumeId
    }
    // console.log("==========id", id)

    Api(`resume/get_history/${id}`, 'GET', '', token)
      .then((response) => {
        if (response.status === 200) {
          // console.log('=========get_client_for_resume======>>>>>>>', response);
          if (response.data.code === 200) {
            setClients(response.data.data);
            // console.log('client========', JSON.stringify(response.data));
            // handleOpenclient();
          } else {
            // toast.error(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };





//    function MouseHoverPopover1() {
//   const [anchorEl, setAnchorEl] = React.useState(null);

//   const handlePopoverOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//     getClients();
//   };

//   const handlePopoverClose = () => {
//     setAnchorEl(null);
//   };

//   const open = Boolean(anchorEl);

//   return (
//     <div>
//       <Typography
//         aria-owns={open ? 'mouse-over-popover' : undefined}
//         aria-haspopup="true"
//         onMouseEnter={handlePopoverOpen}
//         onMouseLeave={handlePopoverClose}
//         sx={{
//           cursor: 'pointer',
//           width: 'fit-content',
//         }}
//       >
//       <Iconify icon="tabler:activity" fontSize={20} color={'text.secondary'} />
       
//       </Typography>

//       <Popover
       
       

//                id="mouse-over-popover"
//         sx={{ pointerEvents: 'none' }}
//         open={open}
//         anchorEl={anchorEl}
      
//         onClose={handlePopoverClose}
//         disableRestoreFocus

//          anchorReference="anchorPosition"
//   anchorPosition={{ top: window.innerHeight / 2, left: window.innerWidth / 2 }}
//   transformOrigin={{
//     vertical: 'center',
//     horizontal: 'center',
//   }}
//       >
//          {/* <Modal open={openclient} onClose={handleCloseclient} style={{ borderRadius: 10 }}> */}
//           {/* sx={styleClients} */}
//         <Box sx={{p:3}}>
//           <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
//             Activities
//           </Typography>
//           <Divider sx={{ mb: 2 }} />
//           <Scrollbar sx={{ maxHeight: 400, overflowX: 'auto' }}>
        
//             <Box  sx={{ minWidth: 600 }} >
//               <Stack sx={{ alignItems: 'center' }}>
//                 <Stack
//                   sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}
//                 >
//                   <Stack
//                     sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}
//                   >
//                     <Typography sx={{ width: '25%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
//                       Date
//                     </Typography>
//                     <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
//                       User Name
//                     </Typography>
//                     <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
//                       Job ID
//                     </Typography>
//                     <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
//                       Client
//                     </Typography>
//                     <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
//                       Job Title
//                     </Typography>
//                     <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
//                       Status
//                     </Typography>
//                   </Stack>
//                 </Stack>

//                 {client
//                   ? client.map((item, index) => {
//                     return (
//                       <Stack
//                         key={index}
//                         sx={[
//                           { background: index % 2 === 0 ? 'text.background' : tablebg },
//                           { width: '100%', flexDirection: 'row', justifyContent: 'space-between', p: 1 },
//                         ]}
//                       >
//                         <Typography sx={{ width: '25%' }}>
//                           {`${new Date(item.createdAt)?.toLocaleString('en-US', optionsDate)} 
// ${String(new Date(item?.createdAt)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.createdAt)?.getMinutes())?.padStart(2, '0')}`}
//                         </Typography>
//                         <Typography sx={{ width: '20%', textTransform: 'capitalize', fontWeight: '800', color: 'text.secondary' }}>
//                           {item.actionBy}
//                         </Typography>
//                         <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
//                           {item.jobId ? item.jobId : '-'}
//                         </Typography>
//                         <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
//                           {item.clientName ? item.clientName : '-'}
//                         </Typography>
//                         <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
//                           {item.jobIdTitle || item.jobTitle}
//                         </Typography>
//                         <Typography
//                           sx={[
//                             {
//                               color:
//                                 item.actionTo === 'started' || item.actionTo === 'placement'
//                                   ? 'green'
//                                   : item.actionTo === 'Backout from Job offer'
//                                     ? 'red'
//                                     : '',
//                             },
//                             { width: '20%', textTransform: 'capitalize' },
//                           ]}
//                         >
//                           {item.actionTo}
//                         </Typography>
//                       </Stack>
//                     );
//                   })
//                   : null}
//               </Stack>
//             </Box>
//           </Scrollbar>
//         </Box>
     
//       </Popover>
//     </div>
//   );
// }


// function MouseHoverPopover1() {
//   const [anchorEl, setAnchorEl] = React.useState(null);

//   const handlePopoverOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//     getClients();
//   };

//   const handlePopoverClose = () => {
//     setAnchorEl(null);
//   };

//   const open = Boolean(anchorEl);

//   return (
//     <div>
//       <Typography
//         aria-owns={open ? 'mouse-over-popover' : undefined}
//         aria-haspopup="true"
//         onMouseEnter={handlePopoverOpen}
//           onMouseLeave={handlePopoverClose}
//         sx={{
//           cursor: 'pointer',
//           width: 'fit-content',
//         }}
//       >
//         <Iconify
//           icon="tabler:activity"
//           fontSize={20}
//           color={'text.secondary'}
//         />
//       </Typography>

//       <Popover
//         id="mouse-over-popover"
//         open={open}
//         anchorEl={anchorEl}
//         onClose={handlePopoverClose}
//         disableRestoreFocus
//         sx={{ pointerEvents: 'none' }}
//         // onMouseLeave={handlePopoverClose}
//         anchorReference="anchorPosition"
//         anchorPosition={{
//           top: window.innerHeight / 2,
//           left: window.innerWidth / 2,
//         }}
//         transformOrigin={{
//           vertical: 'center',
//           horizontal: 'center',
//         }}
//         PaperProps={{
//           sx: {
//             width: '70vw',
//             maxWidth: '900px',
//             borderRadius: 2,
//             p: 2,
//             overflow: 'hidden',
//           },
//         }}
//       >
//         <Box sx={{ p: 1 }}>
//           <Typography
//             variant="h5"
//             color={'#3C6BA5'}
//             textAlign={'center'}
//           >
//             Activities
//           </Typography>

//           <Divider sx={{ mb: 2 }} />

//           <Scrollbar
//             sx={{
//               maxHeight: 400,
//               overflow: 'auto',
//             }}
//           >
//             <Box sx={{ minWidth: 900 }}>
//               <Stack sx={{ alignItems: 'center' }}>
//                 {/* HEADER */}
//                 <Stack
//                   sx={{
//                     backgroundColor: 'text.secondary',
//                     width: '100%',
//                     alignItems: 'center',
//                     p: 0.5,
//                     borderRadius: 1,
//                   }}
//                 >
//                   <Stack
//                     sx={{
//                       width: '100%',
//                       flexDirection: 'row',
//                       justifyContent: 'space-between',
//                     }}
//                   >
//                     <Typography
//                       sx={{
//                         width: '25%',
//                         color: 'white',
//                         fontSize: '0.976rem',
//                         fontWeight: '600',
//                       }}
//                     >
//                       Date
//                     </Typography>

//                     <Typography
//                       sx={{
//                         width: '20%',
//                         color: 'white',
//                         fontSize: '0.976rem',
//                         fontWeight: '600',
//                       }}
//                     >
//                       User Name
//                     </Typography>

//                     <Typography
//                       sx={{
//                         width: '20%',
//                         color: 'white',
//                         fontSize: '0.976rem',
//                         fontWeight: '600',
//                       }}
//                     >
//                       Job ID
//                     </Typography>

//                     <Typography
//                       sx={{
//                         width: '20%',
//                         color: 'white',
//                         fontSize: '0.976rem',
//                         fontWeight: '600',
//                       }}
//                     >
//                       Client
//                     </Typography>

//                     <Typography
//                       sx={{
//                         width: '20%',
//                         color: 'white',
//                         fontSize: '0.976rem',
//                         fontWeight: '600',
//                       }}
//                     >
//                       Job Title
//                     </Typography>

//                     <Typography
//                       sx={{
//                         width: '20%',
//                         color: 'white',
//                         fontSize: '0.976rem',
//                         fontWeight: '600',
//                       }}
//                     >
//                       Status
//                     </Typography>

//                       <Typography
//                       sx={{
//                         width: '20%',
//                         color: 'white',
//                         fontSize: '0.976rem',
//                         fontWeight: '600',
//                       }}
//                     >
//                       Task
//                     </Typography>
//                   </Stack>
//                 </Stack>

//                 {/* DATA */}
//                 {client?.length
//                   ? client.map((item, index) => {
//                       return (
//                         <Stack
//                           key={index}
//                           sx={[
//                             {
//                               background:
//                                 index % 2 === 0
//                                   ? 'text.background'
//                                   : tablebg,
//                             },
//                             {
//                               width: '100%',
//                               flexDirection: 'row',
//                               justifyContent: 'space-between',
//                               p: 1,
//                             },
//                           ]}
//                         >
//                           <Typography sx={{ width: '25%' }}>
//                             {`${new Date(
//                               item.createdAt
//                             )?.toLocaleString(
//                               'en-US',
//                               optionsDate
//                             )} 
// ${String(
//   new Date(item?.createdAt)?.getHours()
// )?.padStart(2, '0')}:${String(
//   new Date(item?.createdAt)?.getMinutes()
// )?.padStart(2, '0')}`}
//                           </Typography>

//                           <Typography
//                             sx={{
//                               width: '20%',
//                               textTransform: 'capitalize',
//                               fontWeight: '800',
//                               color: 'text.secondary',
//                             }}
//                           >
//                             {item.actionBy}
//                           </Typography>

//                           <Typography
//                             sx={{
//                               width: '20%',
//                               textTransform: 'capitalize',
//                             }}
//                           >
//                             {item.jobId || '-'}
//                           </Typography>

//                           <Typography
//                             sx={{
//                               width: '20%',
//                               textTransform: 'capitalize',
//                             }}
//                           >
//                             {item.clientName || '-'}
//                           </Typography>

//                           <Typography
//                             sx={{
//                               width: '20%',
//                               textTransform: 'capitalize',
//                             }}
//                           >
//                             {item.jobIdTitle || item.jobTitle}
//                           </Typography>

//                           <Typography
//                             sx={{
//                               width: '20%',
//                               textTransform: 'capitalize',
//                               color:
//                                 item.actionTo === 'started' ||
//                                 item.actionTo === 'placement'
//                                   ? 'green'
//                                   : item.actionTo ===
//                                     'Backout from Job offer'
//                                   ? 'red'
//                                   : 'inherit',
//                             }}
//                           >
//                             {item.actionTo}
//                           </Typography>

//                              <Typography
//                             sx={{
//                               width: '20%',
//                               textTransform: 'capitalize',
//                             }}
//                           >
//                             {item.noteReason
//  || item.noteReason
// }
//                           </Typography>

//                         </Stack>
//                       );
//                     })
//                   : (
//                     <Typography sx={{ mt: 2 }}>
//                       No Activities Found
//                     </Typography>
//                   )}
//               </Stack>
//             </Box>
//           </Scrollbar>
//         </Box>
//       </Popover>
//     </div>
//   );
// }  



     














































  const getClientSub = async () => {
    const token = localStorage.getItem('token');
    Api(`company/active_clients`, 'GET', '', token)
      .then((response) => {
        // console.log('==========resume_submission=====>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setClientlst(response.data.data);
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };
  // const getClients = async () => {
  //   const token = localStorage.getItem('token');
  //   Api(`resume/get_client_for_resume/${row._id}`, 'GET', '', token)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         console.log('=========get_client_for_resume======>>>>>>>', response);
  //         if (response.data.code === 200) {
  //           setClients(response.data.data);
  //           console.log('client========', JSON.stringify(response.data));
  //           handleOpenclient();
  //         } else {
  //           // toast.error(response.data.message, +'!');
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       console.log('===========', err);
  //       // toast.error(err, +'!');
  //     });
  // };
  const styleSkill = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '95%', sm: '70%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const styleSkillset11 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '60%', sm: '80%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    //     paddingTop:3,
    // paddingBottom:3,
    borderRadius: 3,
  };

  const styleSkillset = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '60%', sm: '80%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    //     paddingTop:3,
    // paddingBottom:3,
    borderRadius: 3,
  };

  const styleSkillset1 = {
    position: 'absolute',
    top: '50%',
    left: '55%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '30%', sm: '50%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const styleClients = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '80%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: { xs: 2, sm: 3 },
    borderRadius: 3,
  };
//   const popoverStyle = {
//    width: { xs: '90%', sm: '80%' },
//      top: '50%',
//     left: '50%',
//      transform: 'translate(-50%, -50%)',
 
//   bgcolor: 'background.paper',
//   border: '3px solid #3C6BA5',
 
//   p: { xs: 2, sm: 3 },
//   borderRadius: 3,
// };

  const styleClients1 = {
      height: '90%',
    position: 'absolute',
    top: '53%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
     width: { xs: '90%', sm: '65%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const childFuc = (e) => {
    setCityy(e);
    if (e.length >= 3) {
      getCity(e);
    } else if (e.length === 0) {
      setCityy(e);
      setcityData([]);
      setCityandstate({});
    }
  };

  const fullVal = (val) => {
    // console.log(val);
    setCityandstate(val);
    setCityy(val.city);
    setValue({ ...value, zip: val.zip || val.postal });
  };

  const setLevel = (subId) => {
    const token = localStorage.getItem('token');
    const body = {
      submissionId: subId,
      level: leveltype,
      timeZone: leveltimez,
      date: leveldate,
      time: leveltime,
    };
    // console.log('body', body);

    Api(`resume/set_level`, 'POST', body, token)
      .then((response) => {
        // console.log('====update Notes====', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            fun2();
            setLevelM(false);
            toast.success(response.data.message);
            // setEditable(!editable);
          }
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
      });
  };

  const [loading, setLoading] = useState(false);

  const Submitted1 = async (row) => {
    setLoading(true)
    const token = localStorage.getItem('token');
    const body = {
      submissionId: row._id,
      resumeId: row.resumeId,
      tempSubmitStatus: subStatus,
      note: `Marked ${subStatus} ${statusNote}`,
      // stepWiseStatus: subStatus,
      jobId: row?.type === "position" ? row?.jobId : "",
      clientName: row?.type === "client" ? row?.clientName : ''
    };

    Api(`resume/update_sub_status`, 'POST', body, token)
      .then((response) => {
        // console.log('==========update_any_step=====>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            row.tempSubmitStatus = subStatus;
            row.note = `Marked ${subStatus} ${statusNote}`;
            row.jobId = row?.type === "position" ? row?.jobId : "";
            row.clientName = row?.type === "client" ? row?.clientName : "";
            setLoading(true)
            setLevelM(false);
            toast.success(response.data.message);
            // console.log(row);
            // fun2();
          } else {
            toast.warn(response.data.message);
          }
        }
      })
      .catch((err) => { });
  };

  const setFav = async (data) => {
    // alert(data)
    const token = localStorage.getItem('token');
    const body = {
      resumeId: row._id,
      // favStatus: data,
    };
    Api(`resume/favourite`, 'POST', body, token)
      .then((response) => {
        // console.log('==========resume/favourite=====>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {

            fun3();
            // fun()
            // toast.success(response.data.message);
            //  if(data === 'favourite'){
            //    fun3()
            //  }
            // favFun()
          } else {
            toast.warn(response.data.message);
          }
        }
      })
      .catch((err) => { });
  };

  const setUnFav = async (data) => {
    // alert(data)
    const token = localStorage.getItem('token');
    const body = {
      resumeId: row._id,
      // favStatus: data,
    };
    Api(`resume/unfavourite`, 'POST', body, token)
      .then((response) => {
        // console.log('==========resume/favourite=====>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            fun3();
            // fun()
            // toast.success(response.data.message);
            //  if(data === 'favourite'){
            //    fun3()
            //  }
            // favFun()
          } else {
            toast.warn(response.data.message);
          }
        }
      })
      .catch((err) => { });
  };

  const handleCopy = () => {
    toast.success('Copied to clipboard!', {
      position: toast.POSITION.TOP_CENTER
    });
  };


  // const pinData = () => {
  //   alert("pinned") 

  // }
  // const [pinned ,setPinned] = useState(false)

  const pinData = async (row) => {
    // const skillLst = [];
    // finallst.map((item) => {
    //   return skillLst.push(item.title);
    // });
    // setPinned(true)
    const skillLst = [];
    finallst.map((item) => {
      return skillLst?.push(item?.title?.toLowerCase());
    });

    const token = localStorage.getItem('token');
    const body = {
      "newCV": "no",
      email: row.email,
      fullName: row.fullName,
      jobTitle: row?.jobTitle?.trim(),
      phone: row.phone,
      currentCompany: row.currCompany,
      skill: skillLst,
      visaType: row.visa,
      taxTerm: row.taxTerm,
      chargeType: row.chargeType,
      expectedCompensation: row.expectedCompensation,
      // cityOrZipcode: row.cityOrZipcode,
      linkedinUrl: row.linkedinUrl,
      reallocate: row.reallocate,
      // zipcode: row.zipcode,
      // stateCode: row.stateCode,
      resumeUrl: row.resumeUrl,
      jobId: row.jobid,
      note: row.notes,
      status: row.status,
      userStatus: row.userStatus,
      // country: row.country,
    };
    // console.log('=====create_resume==========>>>>>>>', finallst);
    Api(`resume/create_resume`, 'POST', body, token)
      .then((response) => {
        // console.log('=====create_resume==========>>>>>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            // console.log('success')
          }
          toast.success('Data successfully pinned!');
        }
        else {

          toast.error("Email, fullName, and jobTitle are required fields");
        }

      })
  };

  const [autoMail, setAutoMail] = useState(false);

  const handleChangebtn = (event) => {
    // console.log("event", event)
    setChecked(event.target.checked);
    // console.log('=========mail chk=====>>>', event.target.checked);
    setCheckedEmail1(event.target.checked);
    // console.log('checkboxEmail 1=====>>>', event.target.checked);
    setCheckedEmail2(event.target.checked);
    // console.log('checkboxEmail 2=====>>>', event.target.checked);
    setCheckedEmail3(event.target.checked);
    // console.log('checkboxEmail 3=====>>>', event.target.checked);
    // handleChangeEmail1()
    // handleChangeEmail2()
    // handleChangeEmail3()
  };

  const handleChangeEmail1 = (event) => {
    // console.log('checkboxEmail 1=====>>>', event.target.checked);
    setCheckedEmail1(event.target.checked);
  };


  const handleChangeEmail2 = (event) => {
    // console.log('checkboxEmail 2=====>>>', event.target.checked);
    setCheckedEmail2(event.target.checked);
  };

  const handleChangeEmail3 = (event) => {
    // console.log('checkboxEmail 3=====>>>', event.target.checked);
    setCheckedEmail3(event.target.checked);
  };
  // const [autoEmail1, setAutoEmail1] = useState(false);

  // const toggleEmail1 = () => {
  //   setAutoEmail1(!autoEmail1);
  // };

  // const [autoEmail2, setAutoEmail2] = useState(false);

  // const toggleEmail2 = () => {
  //   setAutoEmail2(!autoEmail2);
  // };

  // const [autoEmail3, setAutoEmail3] = useState(false);

  // const toggleEmail3 = () => {
  //   setAutoEmail3(!autoEmail3);
  // };

  // console.log(" rec row====>>>+++", row)
  // console.log("row.resumeUrl[0]===>>>>>>>", row.additionalResumes)

  const [newSkill, setNewSkill] = useState([])
  const [details1, setDetails1] = useState([])
  // console.log("details1", details1)

  const [details2, setDetails2] = useState([])
  // console.log("details2", details2)

  const [details3, setDetails3] = useState([])
  // console.log("details3", details3)

  const [details4, setDetails4] = useState([])
  // console.log("details4", details4)

  // console.log("<<<<<<<< >>>>> newSkill", newSkill)

  const [skillss, setSkillss] = useState([])
  // console.log("skillss", skillss)

  const validSkills = row?.skill?.filter(item => item !== '' && item !== null);
  const validSkills1 = newSkill?.filter(item => item !== '' && item !== null);

  const [hideButton, setHideButton] = useState(true)
  const [hideCross, setHideCross] = useState(true)

  const handleDeleteSkill = (index) => {
    // console.log("===============indx", index)
    // console.log("====validSkills", validSkills)

    const arrr = validSkills.filter((_, i) => i !== index);
    const arrr1 = validSkills1.filter((_, i) => i !== index);
    // console.log("arrr", arrr1)
    setNewSkill(arrr1)
    // setSkill(arrr)  
    // setSkillss(arrr); 
  }

  const [skillLst1, setSkillLst1] = useState([]);
  // const [finallst, setFinallst] = useState([]);

  const [loading12, setLoading12] = useState(false);

  const deleteSkill = async () => {
    setLoading12(true)
    // console.log('===========update', newSkill);
    const updatedSkill = [];
    newSkill?.map((item) => {
      return updatedSkill?.push(item);
    });
    // console.log('=======after map skill', updatedSkill);

    const token = localStorage.getItem('token');
    const body = {
      "newCV": "no",
      resumeId: details4,
      fullName: details1,
      email: details2,
      jobTitle: details3?.trim(),
      skill: updatedSkill,
    };

    Api(`resume/update_resume`, 'POST', body, token)
      .then((Response) => {
        // console.log('======getUser==response=====>', Response);
        if (Response.status === 200) {
          if (Response.data.code === 200) {
            toast.success(Response.data.message);
            // fun();
            row.skill = updatedSkill;
            row.updatedAt = new Date().toISOString();

            setLoading12(false)
            // console.log('=====>', Response);
            setHideButton(true)
            setHideCross(true)
          } else {
            // console.log('+++======>', +Response);
            toast.warn(Response.data.message);
            // enqueueSnackbar(Response.data.message);
          }
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
        // console.log('===========', err);
      });
  };
  const [loading11, setLoading11] = useState(false);


  const handleEmail22 = async (candidateIdo) => {
    setCandidateId2(candidateIdo);
    const body = { candidateId: candidateIdo };
    try {
      const apiRes = await Api("email/scheduled_mails_list", "POST", body);
      const res = apiRes.data;
      const list = res.data || [];

      if (apiRes.data.code === 200) {
        const finalList = list.flatMap((item) =>

          (item.scheduleData || []).map((mail) => ({
            date: mail.date,
            subject: mail.subject || item.sendEmail?.subject || "",
            emailBody: mail.emailBody || "",
            emailOrder: mail.emailOrder || "",
            sendStatus: mail.sendStatus || "",
            scheduleId: item._id,
          }))
        );


        // date: mail.date ? new Date(mail.date).toLocaleDateString() : "",
        console.log("FINAL LIST:", finalList);

        setEmails2(finalList);
        handleEmailModalOpen2();

      }
      else {
        setEmails2([]);
        toast.error(apiRes.data.message);
      }



    } catch (err) {
      console.log("API Error:", err);
    }
  };






  const handleSwitchChange = (item) => {
    setSelectedItem(item); // { scheduleId, emailOrder }
    setConfirmOpen(true);
  };

  const handleConfirmYes = async () => {
    if (selectedItem) {

      await deleteOne(selectedItem.scheduleId, selectedItem.emailOrder);
    }
    setConfirmOpen(false);
  };

  const handleConfirmNo = () => {
    setConfirmOpen(false);
  };




  const deleteOne = async (scheduleId, emailOrder) => {
    try {
      const apiRes = await Api("email/delete-one-scheduled-mail", "POST", { scheduleId, emailOrder });


      if (apiRes.data.code === 200) {
        toast.success(apiRes.data.message);
        handleEmail22(candidateId2);
      }
      else {
        toast.error(apiRes.data.message);
      }
    } catch (err) {
      console.error(err);
    }
  };



  const emailDeleteAllConfirm = async () => {

    try {
      const res = await Api("email/delete-all-scheduled-mails", "POST", {
        candidateId: candidateId2
      });

      // setEmailDeleteAllOpen(false);
      //   handleEmail22(candidateId2);

      if (res.data.code === 200) {
        toast.success(res.data.message);
        setEmailDeleteAllOpen(false);
        handleEmailModalClose2();
        //    handleEmail22(candidateId2);
      }
      else {
        toast.error(res.data.message);
      }


      // if (res.code === 200) {
      //   console.log("All emails deleted!");

      // }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditSecond = () => {
    console.log("hello")
  }



  const AdddSkill = () => {
    setLoading11(true);
    const updatedSkill = [];

    skillss?.forEach((item) => {
      const lowerCaseSkill = item.title.toLowerCase();
      if (!newSkill?.map(skill => skill?.toLowerCase())?.includes(lowerCaseSkill)) {
        updatedSkill?.push(item.title);
      }
    });

    const combinedSkills = [...newSkill, ...updatedSkill];
    const uniqueSkills = [...new Set(combinedSkills?.map(skill => skill?.toLowerCase()))];

    const token = localStorage.getItem('token');
    const body = {
      "newCV": "no",
      resumeId: details4,
      fullName: details1,
      email: details2,
      jobTitle: details3?.trim(),
      skill: uniqueSkills,
    };

    Api(`resume/update_resume`, 'POST', body, token)
      .then((Response) => {
        if (Response.status === 200) {
          if (Response.data.code === 200) {
            toast.success(Response.data.message);
            // fun();
            row.skill = uniqueSkills;
            row.updatedAt = new Date().toISOString();

            setLoading11(false);
            handleSkillClose();
            handleCloses();
            setSkillss([]);
          } else {
            toast.warn(Response.data.message);
          }
        }
      })
      .catch((err) => {
        // toast.error(err + '!');
      });
  };

  // const AdddSkill = async () => {
  //   setLoading11(true)
  //   // console.log('===========update', skillss);
  //   const updatedSkill = [];
  //   skillss?.map((item) => {
  //     return updatedSkill.push(item.title);
  //   });
  //   // console.log('=======after map skill', updatedSkill);
  //   const newUpdatedArr = [...newSkill, ...updatedSkill]
  //   const uniqueSkills = [...new Set(newUpdatedArr)];

  //   const token = localStorage.getItem('token');
  //   const body = {
  //     "newCV": "no",
  //     resumeId: details4,
  //     fullName: details1,
  //     email: details2,
  //     jobTitle: details3,
  //     // skill: newUpdatedArr,
  //     skill: uniqueSkills,
  //   };

  //   Api(`resume/update_resume`, 'POST', body, token)
  //     .then((Response) => {
  //       // console.log('======getUser==response=====>', Response);
  //       if (Response.status === 200) {
  //         if (Response.data.code === 200) {
  //           toast.success(Response.data.message);
  //           fun();
  //           setLoading11(false)
  //           handleSkillClose();
  //                 handleCloses()
  //                 setSkillss([]);
  //           // console.log('=====>', Response);
  //         } else {
  //           // console.log('+++======>', +Response);
  //           toast.warn(Response.data.message);
  //           // enqueueSnackbar(Response.data.message);
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       toast.error(err, +'!');
  //       // console.log('===========', err);
  //     });
  // };

  const optionsDate = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    // timeZone: 'UTC'
  };

  const optionsTime = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    // timeZone: 'UTC'
  };

  const [openRes, setOpenRes] = useState('');
  const [openR, setOpenR] = useState(false);
  const openResume = (resUrl) => {
    setOpenRes(resUrl);
    setOpenR(true);
  };
  const closeResume = () => {
    setOpenR(false);
  };

  const suru = 'https://docs.google.com/viewer?url=';
  const lll = '&embedded=true';

  // const [endClientName, setEndClientName] = useState('')

  // console.log("endClientName", endClientName)
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const handleOpenDeleteModal = () => {
    setDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  const moveToTrash = (data) => {

    let type = '';
    if (filterTab === 'submitted') {
      type = "submission"
    } else {
      type = "resume"
    }

    const body = {
      "_id": data?._id,
      "type": type,
      "trashStatus": true
    };

    const token = localStorage.getItem('token');
    Api(`resume/moveTrash`, 'POST', body, token).then((response) => {
      if (response.status === 200) {
        if (response.data.status === 200) {
          handleCloseDeleteModal()
          if (filterTab === "worksheet") {
            fun()
          } else {
            fun2();
          }
          toast.success(response.data.resmessage);
        } else {
          toast.warn(response.data.resmessage);
        }
      }
    })
      .catch((err) => { });
  };

  const selectCheckBox = (id, email, fullName) => {
    // setCheckRow(row)
    handleCheck1(id, email, fullName)
  }



       const [openJourneyHistory, setOpenJourneyHistory] = useState(false);

const [openHotlistModal, setOpenHotlistModal] = useState(false);

const [hotlistName, setHotlistName] = useState("");

const [hotlistList, setHotlistList] = useState([]);

const [loadingBtn, setLoadingBtn] = useState(false);
const [openRemoveHotlist, setOpenRemoveHotlist] = useState(false);

const getHotlists = () => {
  const token = localStorage.getItem("token");

  Api("resume/getHotlists", "POST", {}, token)

    .then((res) => {
               console.log("hello shyamlal", res)
      if (res?.status === 200) {
        setHotlistList(res?.data?.result|| []);
      } else {
        setHotlistList([]);
      }
    })
    .catch((err) => {
      console.log(err);
      setHotlistList([]);
    });
};
// const getHotlistList = async () => {
//   const token = localStorage.getItem("token");

//   Api("resume/getHotlists", "POST", {}, token)
//     .then((response) => {
//       if (response.status === 200 && response.data.code === 200) {
//         const list = response.data.result || [];

//         setHotlists(list);

//         if (list.length > 0) {
//           setSelectedHotlist(list[0]);

//           // first hotlist ka data load
//           getHotlist(1, list[0].hotlistName);
//         }
//       }
//     });
// };

const removeFromHotlist = async (id, resumeId) => {
  const token = localStorage.getItem("token");

  const body = {
    "hotlistId": selectedHotlist._id,
    "resumeIds": [row._id]
  };

  try {
    const response = await Api(
      "resume/removeResumeFromHotlist",
      "POST",
      body,
      token
    );

    if (response.status === 200 && response.data.code === 200) {
      toast.success("Removed from Hot List");

      setOpenRemoveHotlist(false);

      // Hotlist ko refresh karo
      // getHotlist(1, selectedHotlist?.hotlistName);
      getHotlistList();
      // ya getHotlistList();
    } else {
      toast.error(response.data.message);
    }
  } catch (err) {
    toast.error("Something went wrong");
  }
};

const createHotlist = () => {

  if (!hotlistName.trim()) {
    toast.warn("Hotlist Name is required");
    return;
  }
  setLoadingBtn(true);

  const token = localStorage.getItem("token");

  const body = {
    hotlistName: hotlistName.trim(),
  };

  Api("resume/create_hotlist", "POST", body, token)
    .then((res) => {

    console.log("kkkinin", res);

      if (res?.status === 200) {
        toast.success(res?.data?.message || "Hotlist created");

        setHotlistName("");
        setOpenHotlistModal(false);
        addToHostList(res?.data.data._id)
        getHotlists();
      } else {
        toast.warn(res?.data?.message || "Something went wrong");
      }

      setLoadingBtn(false);
    })
    .catch((err) => {
      console.log(err);
      setLoadingBtn(false);
    });
};


const addToHostList = (id) => {
  const token = localStorage.getItem("token"); 
  const body = {
    "hotlistId": id,
    "resumeIds": [row._id]
}

  Api("resume/addResumeToHotlist", "POST", body, token)
    .then((res) => {
      console.log("hello ji responce ====>>", res)
      if (res?.status === 200) {
        toast.success(res?.data?.message);
      } else {
        toast.warn(res?.data?.message || "Something went wrong");
      }
    })
    .catch((err) => {
      console.log(err);
    });
};


const handleCheckDownloadLimit = async (resumeId, openRes) => {
  try {
    const token = localStorage.getItem('token');

    const res = await Api(
      'resume_down_limit/check',
      'POST',
      { resumeId },
      token
    );

    console.log('Download Limit Check Response:', res);

    // if (res?.status) {
      if (res?.data?.allowed === true) {
  const link = document.createElement('a');
  link.href = openRes;
  link.setAttribute('download', '');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
} else {
  toast.error('Download limit exceeded. Please contact admin.');
}
    // }
  } catch (error) {
    console.log(
      'Error checking download limit:',
      error?.response?.data || error.message
    );
  }
};



  console.log("tab fillters ====>>>", filterTab);
  return (
    <>
      <TableRow
        key={row._id}
        sx={[
          { background: index % 2 === 0 ? 'text.background' : tablebg },
          { '&:last-child td, &:last-child th': { border: 0 } },
          { '&:hover': { boxShadow: 5 } },
        ]}
      >
        {(filterTab === 'worksheet' || 'Hotlist') && (
          <TableCell sx={{ py: 0 }}>
            <Typography sx={{ mt: 0.1 }} >
              {/* Updated {moment().diff(row.updatedAt, 'days')} days ago */}
              {/* Upd - {moment(row.updatedAt).format('lll')} */}
              Up - {`${new Date(row.updatedAt).toLocaleString('en-US', optionsDate)} 
${String(new Date(row?.updatedAt).getHours()).padStart(2, '0')}`}:{`${String(new Date(row?.updatedAt).getMinutes()).padStart(2, '0')}`}
              {/* ${new Date(row.updatedAt).toLocaleString('en-US', optionsTime)} */}
            </Typography>
            <Typography sx={{}}>
              {/* Cr - {moment(row.createdAt).format('lll')} */}
              Cr - {`${new Date(row.createdAt).toLocaleString('en-US', optionsDate)} 
  ${String(new Date(row?.createdAt).getHours()).padStart(2, '0')}:${String(new Date(row?.createdAt).getMinutes()).padStart(2, '0')}`}
            </Typography>

            <Stack sx={{ flexDirection: 'row' }}>
              {(!tableShow || filterTab === 'Hotlist') ? (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked1 || false}
                      sx={{
                        padding: 0,
                        margin: 0,
                        ml: 1.,
                        transform: 'scale(0.9)',
                        mt: -0.1
                      }}
                      onChange={() => selectCheckBox(row?._id, row?.email, row?.fullName)}
                    />

                  }
                  label=""
                />
              ) : (
                null
              )}

              {/* </Stack> */}
              {row?.status !== "started" && (

                <Typography
                  sx={{
                    color: 'text.secondary', textDecoration: 'underline',
                    cursor: 'pointer', ml: tableShow ? 0 : -1
                  }}
                  onClick={() => handleEdit()}
                >
                  Edit
                </Typography>
              )}
              {row.favouriteStatus === true ? (
                <Iconify
                  icon="ph:heart-fill"
                  color={'text.secondary'}
                  sx={{ m: 0.3, height: 15, ml: 1, width: 15, cursor: 'pointer' }}
                  hover
                  onClick={() => setUnFav()}
                />
              ) : (
                <Iconify
                  icon="ph:heart"
                  color={'text.secondary'}
                  sx={{ m: 0.3, height: 15, ml: 1, width: 15, cursor: 'pointer' }}
                  hover
                  onClick={() => {
                    // setTimeout(() => {
                    // favFun();
                    setFav('favourite');
                    // }, 1000);
                  }}
                />
              )}
                      {/* <FaStar 
                      
                       onClick={()=>{setOpenJourneyHistory(true);
        getHotlists();}} 
        
        /> */}

                      <Iconify
              icon="mdi:star"
        color={'text.secondary'}
              sx={{ m: 0.3, height: 16, ml: 0.5, width: 16, cursor: 'pointer' }}
               onClick={() => {
    if (filterTab === "Hotlist") {
      setOpenRemoveHotlist(true);
    } else {
      setOpenJourneyHistory(true);
      getHotlists();
    }
  }}
              //     onClick={()=>{setOpenJourneyHistory(true);
              //  getHotlists();}} 
              // onClick={() => setOpenRemoveHotlist(true)}
                 />

              <Iconify
                icon="line-md:trash"
                color={'text.secondary'}
                sx={{ m: 0.3, height: 16, ml: 0.5, width: 16, cursor: 'pointer' }}
                hover
              
                onClick={() => handleOpenDeleteModal()}
              />


              {pinned && (
                <Iconify
                  icon="icon-park-solid:pin"
                  color='#2ECC71'
                  sx={{ m: 0.3, ml: 5.5, fontSize: 15, cursor: 'pointer' }}
                  hover
                  onClick={() => pinData(row)}
                />
              )}
            </Stack>
          </TableCell>
        )}

<Dialog
  open={openRemoveHotlist}
  onClose={() => setOpenRemoveHotlist(false)}
  maxWidth="xs"
  fullWidth
 PaperProps={{
    sx: {
      border: "3px solid #3C6BA5",
      borderRadius: 3, // Modal जैसा same radius
      boxShadow: 24,
      overflow: "hidden",
    },
  }}
>
  <DialogContent
    sx={{
      pt: 4,
      pb: 3,
      textAlign: "center",
      // border: '3px solid #3C6BA5',
      
    }}
  >
    <Typography variant="h6" color="red" textAlign="center">
      Remove this candidate from  Hotlist?
    </Typography>
  </DialogContent>

  <DialogActions
    sx={{
      justifyContent: "center",
      gap: 2,
      pb: 3,
    }}
  >

    <Button
      variant="contained"
      color="custom"
      sx={{ minWidth: 100 }}
      onClick={() => {
        removeFromHotlist();
      }}
    >
      Yes
    </Button>

    <Button
      variant="contained"
      color="custom"
      onClick={() => setOpenRemoveHotlist(false)}
      sx={{ minWidth: 100 }}
    >
      No
    </Button>

  </DialogActions>
</Dialog>

        
       

        

        {filterTab === 'placement' ? (
          <TableCell sx={{ py: 0, maxWidth: 170, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
              {row.userStatus === 'fake' || row.userStatus === 'blacklisted' ? (
                <Typography
                  sx={{ fontWeight: '600', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}
                  color={'red'}
                  onClick={() =>
                    navigate('/resumeDetail', {
                      state: {
                        // endClientName,

                        addedSkills,
                        row,
                        mtab: 'Resume',
                        fTab:
                          filterTab === 'worksheet'
                            ? 'submitted'
                            : '' || filterTab === 'favourites'
                              ? 'submitted'
                              : '' || filterTab === 'interview'
                                ? 'placement'
                                : '' || filterTab === 'placement'
                                  ? 'start'
                                  : '',
                      },
                    })
                  }
                >
                  {row.fullName}

                </Typography>
              ) : (filterTab === 'placement' && row.status === 'placement' && row.startStatus === 'started') ||
                row.startStatus === '' ? (
                <Typography
                  sx={{
                    cursor: 'pointer',
                    fontWeight: '600',
                    maxWidth: 160,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                  color={'#2ECC71'}
                  onClick={() =>
                    navigate('/resumeDetail', {
                      state: {
                        // endClientName,
                        addedSkills,
                        row,
                        mtab: 'Resume',
                        fTab:
                          filterTab === 'worksheet'
                            ? 'submitted'
                            : '' || filterTab === 'favourites'
                              ? 'submitted'
                              : '' || filterTab === 'interview'
                                ? 'placement'
                                : '' || filterTab === 'placement'
                                  ? 'start'
                                  : '',
                      },
                    })
                  }
                >
                  {row.fullName}
                </Typography>
              ) : (
                <Typography
                  sx={{
                    cursor: 'pointer',
                    fontWeight: '600',
                    maxWidth: 160,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                  color={'text.secondary'}
                  onClick={() =>
                    navigate('/resumeDetail', {
                      state: {
                        // endClientName,
                        addedSkills,
                        row,
                        mtab: 'Resume',
                        fTab:
                          filterTab === 'worksheet'
                            ? 'submitted'
                            : '' || filterTab === 'favourites'
                              ? 'submitted'
                              : '' || filterTab === 'interview'
                                ? 'placement'
                                : '' || filterTab === 'placement'
                                  ? 'start'
                                  : '',
                      },
                    })
                  }
                >
                  {row.fullName}
                </Typography>
              )}
              <Iconify
                icon="devicon:linkedin"
                color={'text.textG'}
                // color={row.linkedinUrl ? 'text.textG' : 'text.disabled'}
                sx={{
                  ml: 1, height: 18, width: 18,
                  cursor: 'pointer'
                  // opacity: row.linkedinUrl ? 1 : 0.5,
                }}
                hover
                onClick={() => window.open(row.linkedinUrl, '_blank')}
              // onClick={() => {
              //   if (row.linkedinUrl) {
              //     window.open(row.linkedinUrl, '_blank');
              //   }
              // }}
              />
              <Iconify
                icon="cuida:document-text-outline"
                color="#1E74B3"
                sx={{
                  ml: 0.6, height: 18, width: 18,
                  cursor: 'pointer'
                }}
                hover
                onClick={() => openResume(row.resumeUrl)}

              />
              {/* {row?.dataFrom === "foxearchdb" || row?.dataFrom === "foxearchDB" && (

              <Avatar sx={{ cursor: 'pointer', width:"23px", height:"23px", ml:1,
                // position:"absolute"
                mt:-0.5, mb:-0.5
               }} src="/assets/logoFoxearchNew.svg"/>
              )} */}
            </Stack>









            <Typography sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }} >
              {row.jobTitle}
              {/* <Iconify
                icon="cuida:document-text-outline"
                color="#1E74B3"
                sx={{
                  ml: 0.6, height: 18, width: 18, mb:-0.4,
                  cursor: 'pointer'
                }}
                hover
                onClick={() => openResume(row.resumeUrl)}
              
              /> */}
            </Typography>
            <Typography sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }} color={'text.textG'}>
              {/* {row.currentCompany ? row.currentCompany : '-'} */}
              {(row?.currentCompany || '').trim() || '-'}
            </Typography>
          </TableCell>
        ) : (
          <TableCell sx={{ py: 0 }}>
            <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
              {row.userStatus === 'fake' || row.userStatus === 'blacklisted' ? (
                <Typography
                  sx={{ fontWeight: '600', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '0.9rem' }}
                  color={'red'}
                  onClick={() =>
                    navigate('/resumeDetail', {
                      state: {
                        // endClientName,
                        addedSkills,
                        row,
                        mtab: 'Resume',
                        fTab:
                          filterTab === 'worksheet'
                            ? 'submitted'
                            : '' || filterTab === 'favourites'
                              ? 'submitted'
                              : '' || filterTab === 'interview'
                                ? 'placement'
                                : '' || filterTab === 'placement'
                                  ? 'start'
                                  : '',
                      },
                    })
                  }
                >

                  {row.fullName}
                </Typography>
              ) : (filterTab === 'worksheet' && row.status === 'started') || row.status === 'placement' ? (
                <Typography
                  sx={{
                    cursor: 'pointer',
                    fontWeight: '600',
                    maxWidth: 160,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '0.9rem'
                  }}
                  color={'#2ECC71'}
                  onClick={() =>
                    navigate('/resumeDetail', {
                      state: {
                        // endClientName,
                        addedSkills,
                        row,
                        mtab: 'Resume',
                        fTab:

                          filterTab === 'worksheet'
                            ? 'submitted'
                            : '' || filterTab === 'favourites'
                              ? 'submitted'
                              : '' || filterTab === 'interview'
                                ? 'placement'
                                : '' || filterTab === 'placement'
                                  ? 'start'
                                  : '',
                      },
                    })
                  }
                >
                  {row.fullName}
                </Typography>
              ) : (
                <Typography
                  sx={{
                    cursor: 'pointer',
                    fontWeight: '600',
                    maxWidth: 160,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '0.9rem'
                  }}
                  color={'text.secondary'}
                  onClick={() =>
                    navigate('/resumeDetail', {
                      state: {
                        // endClientName,
                        addedSkills,
                        row,
                        mtab: 'Resume',
                        fTab:
                          filterTab === 'worksheet'
                            ? 'submitted'
                            : '' || filterTab === 'favourites'
                              ? 'submitted'
                              : '' || filterTab === 'interview'
                                ? 'placement'
                                : '' || filterTab === 'placement'
                                  ? 'start'
                                  : '',
                      },
                    })
                  }
                >
                  {(row.fullName) ? row.fullName : "#"}
                </Typography>
              )}
              <Iconify
                icon="devicon:linkedin"
                color={'text.textG'}
                // color={row.linkedinUrl ? 'text.textG' : 'text.disabled'}

                sx={{
                  m: 0.3, height: 15, width: 15, cursor: 'pointer',
                }}
                hover
                onClick={() => window.open(row.linkedinUrl, '_blank')}
              // onClick={() => {
              //   if (row.linkedinUrl) {
              //     window.open(row.linkedinUrl, '_blank');
              //   }
              // }}
              />
              <Iconify
                icon="cuida:document-text-outline"
                color="#1E74B3"
                sx={{
                  ml: 0.6, height: 18, width: 18,
                  cursor: 'pointer'
                }}
                hover
                onClick={() => openResume(row.resumeUrl)}
              />
              {/* {row?.dataFrom === "foxearchdb" || row?.dataFrom === "foxearchDB" && (

<Avatar sx={{ cursor: 'pointer', width:"23px", height:"23px", ml:1,
  // position:"absolute"
  mt:-0.5, mb:-0.5
 }} src="/assets/logoFoxearchNew.svg"/>
)} */}
            </Stack>
            <Typography sx={{ width: 160, overflow: 'hidden', textOverflow: 'ellipsis' }} >
              {row.jobTitle ? row.jobTitle : "-"}
              {/* <Iconify
                icon="cuida:document-text-outline"
                color="#1E74B3"
                sx={{
                  ml: 0.6, height: 18, width: 18, mb:-0.4,
                  cursor: 'pointer'
                }}
                hover
                onClick={() => openResume(row.resumeUrl)}
              
              /> */}
            </Typography>
            <Typography sx={{ width: 160, overflow: 'hidden', textOverflow: 'ellipsis' }} color={'text.textG'}>
              {/* {row?.currentCompany?.trim() ? row?.currentCompany?.trim()  : '-'} */}

              {(row?.currentCompany || '').trim() || '-'}

            </Typography>
          </TableCell>
        )}

        <TableCell sx={{ py: 0 }}>
          {row.phone ? (
            <Stack sx={{ flexDirection: 'row' }}>
              {/* <Typography sx={{ flexDirection: 'row', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {row.phone}
              </Typography> */}
              {/* <Typography sx={{ flexDirection: 'row', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {row?.phone?.replace(/(\d{3})(?=\d)/g, '$1 ').trim()}
              </Typography> */}
              <Typography sx={{ flexDirection: 'row', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {
                  row?.phone?.trim()
                    ? row?.phone?.trim()
                      ?.replace(/\s+/g, '')
                      ?.replace(/^(\+?\d{1,3})?(\d{10,20})$/, (match, p1, p2) => {
                        if (p1) {
                          const countryCode = p1;
                          const lastDigits = p2?.slice(-10);
                          return `${countryCode} ${lastDigits?.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')}`;
                        }
                        return p2?.replace(/(\d{3})(\d{3})(\d{4})(\d{3,4})?/, '$1 $2 $3 $4')?.trim();
                      })
                    : ''
                }
              </Typography>

              <CopyToClipboard text=
                {
                  row?.phone?.trim()
                    ? row?.phone?.trim()
                      ?.replace(/\s+/g, '')
                      ?.replace(/^(\+?\d{1,3})?(\d{10,20})$/, (match, p1, p2) => {
                        if (p1) {
                          const countryCode = p1;
                          const lastDigits = p2?.slice(-10);
                          return `${countryCode} ${lastDigits?.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')}`;
                        }
                        return p2?.replace(/(\d{3})(\d{3})(\d{4})(\d{3,4})?/, '$1 $2 $3 $4')?.trim();
                      })
                    : ''
                }
                onCopy={() => setPhoneCopy(true)}>
                <Iconify
                  icon="radix-icons:copy"
                  color={phoneCopy ? 'text.secondary' : 'text.textG'}
                  sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                  hover
                />
              </CopyToClipboard>
            </Stack>
          ) : (
            <Typography>-</Typography>
          )}
          {row.email ? (
            <Stack sx={{ flexDirection: 'row' }}>
              <Typography
                sx={{ textTransform: 'lowercase', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                {row.email}
              </Typography>
              <CopyToClipboard text={row.email} onCopy={() => setEmailCopy(true)}>
                <Iconify
                  icon="radix-icons:copy"
                  color={emailCopy ? 'text.secondary' : 'text.textG'}
                  sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                />
              </CopyToClipboard>
            </Stack>
          ) : (
            <Typography>-</Typography>
          )}
          {row.city || row.stateCode || row.reallocate === 'yes' ? (
            <Stack sx={{ flexDirection: 'row', gap: 0.5, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
              <Typography sx={{}} color={'text.textG'}>
                {row.city ? row.city : null},
              </Typography>
              <Typography sx={{}} color={'text.textG'}>
                {row.stateCode ? row.stateCode : null}
              </Typography>

              {row.reallocate === 'yes' ? (
                <Iconify icon="mdi:aeroplane" fontSize={20} color={'text.secondary'} />
              ) : null}
            </Stack>
          ) : (
            <Typography color={'text.textG'}>-</Typography>
          )}
        </TableCell>


        <TableCell sx={{ py: 0, width: 170 }}>
          {row.skill && row.skill.length > 0 ? (
            <Grid container sx={{ maxWidth: 160, height: 44, overflow: 'hidden', textOverflow: 'ellipsis', gap: 0.3 }}>
              {row.skill.map((item, index) => (
                item && (
                  <Typography key={index} sx={{}}>
                    {item}
                    {index < row.skill.filter(skill => skill).length - 1 && ' | '}
                  </Typography>
                )
              ))}
            </Grid>
          ) : (
            <Typography>-</Typography>
          )}
          {row.skill && row.skill.length > 0 ? (
            <Typography
              sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => {
                handleOpens(); setNewSkill(row.skill); setDetails1(row.fullName);
                setDetails2(row.email); setDetails3(row.jobTitle); setDetails4(row._id);
              }}

            >
              view all
            </Typography>
          ) : null}
        </TableCell>

        <TableCell sx={{ py: 0, width: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <Typography sx={{}}>{row.visaType ? row.visaType : '-'}</Typography>
          {filterTab === 'placement' ? (
            <Typography sx={{}} >
              {localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country")=== "UK" ? "£" : "$"}{row.offeredJob === 'fulltime' ? row.annualSalary : row.hourlyRateRateOffered}
              {row.chargeType === 'hourly' ? '/Hour' : localStorage.getItem("country") === "INDIA" ? 'Lac':'k'}
            </Typography>
          ) : (
            <Typography sx={{}} >
              {localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country")=== "UK" ? "£" : "$"}{row.expectedCompensation}
              {row.chargeType === 'hourly' ? '/Hour' : localStorage.getItem("country")==="INDIA"? 'Lac' :'K'}
            </Typography>
          )}
          <Typography sx={{ textTransform: "capitalize" }} color={'text.textG'}>
            {row.taxTerm ? row.taxTerm : '-'}
          </Typography>
        </TableCell>

        <TableCell sx={{ py: 0, width: 130, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {filterTab === 'interview' && (
            <Typography
              sx={{
                color: 'text.secondary',
                textDecoration: (row.status === 'interview' || row.status !== 'interview') ? 'underline' : 'none',
                // cursor: (row.status === 'interview' || row.stepWiseStatus === "l1" === "l2" === "l3") ? 'pointer' : '',
                cursor: (row.status === 'interview' || ['l1', 'l2', 'l3, l4, l5'].includes(row.stepWiseStatus)) ? 'pointer' : '',

              }}
              onClick={() => {
                if (row.status === 'interview') {
                  navigate('/resumeDetail', {
                    state: {
                      // endClientName,
                      addedSkills,
                      row: {
                        _id: row._id,
                        resumeId: row.resumeId,
                        status: 'submitted',
                        fullName: row.fullName,
                        resumeUrl: row.resumeUrl,
                        clientName: row.clientName,
                        interviewStatus: row.stepWiseStatus,
                      },
                      fTab: 'interview',
                    },
                  });
                }
              }}
            >

              {row.status === 'interview' && (
                <span>{row.stepWiseStatus} </span>
              )}

              <span
                style={{
                  color: (row.status === 'interview' || row.status !== 'interview') ? 'inherit' : 'gray',
                }}
              >
                {row.status}
              </span>
            </Typography>
          )}

          {filterTab === 'placement' ? (
            <Typography sx={{}}>{row.startStatus !== '' ? row.startStatus : row.status} </Typography>
          ) : null}
          {filterTab !== 'placement' && filterTab !== 'interview' && filterTab !== 'submitted' ? (
            <Typography sx={{}}>{row.status}</Typography>
          ) : null}
          {filterTab === 'submitted' ? (
            <Typography sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
              // disabled={
              //   (localStorage.getItem("recRole") === "recruiterTrainee" || 
              //   localStorage.getItem("recRole") === "recruiterTeamLead" ||
              //   localStorage.getItem("recRole") === "recruiter") && 
              //   localStorage.getItem("recId") === row?.userId
              // }
              // disabled
              // onClick={() => {
              //   if (row.status === "submitted" &&
              //     (
              //       (localStorage.getItem("recRole") !== "recruiterTrainee" ||
              //       localStorage.getItem("recRole") !== "recruiterTeamLead" ||
              //       localStorage.getItem("recRole") !== "recruiter")
              //     )
              //     &&
              //    localStorage.getItem("recId") !== row?.userId
              //     ) 
              //     {
              //     setLevelM(true)
              //   }
              // }}

              onClick={() => {
                const recRole = localStorage.getItem("recRole");
                const recId = localStorage.getItem("recId");

                if (
                  row.status === "submitted" &&
                  !["recruiterTrainee", "recruiterTeamLead", "recruiter"].includes(recRole)
                  // &&
                  // recId !== row?.userId
                ) {
                  setLevelM(true);
                }
              }}

            >
              {/* {row.stepWiseStatus} */}
              {row.tempSubmitStatus !== "" && row.status === "submitted" ? row.tempSubmitStatus : row.status}
            </Typography>
          ) : null}
          {filterTab === 'worksheet' || filterTab === 'favourites' || filterTab === 'submitted' ||
            filterTab === 'placement' || filterTab === 'interview' || filterTab === 'backout' ? (
            <Stack sx={{ flexDirection: 'row', gap: 0.5 }}>
              <Typography sx={{}} >
                {row.jobId}
              </Typography>
              < Stack sx={{ flexDirection: 'row' }}

                  onClick={handleOpenActivitiesModal}
                  onMouseEnter={handleActivitiesPopoverOpen}
                  onMouseLeave={handleActivitiesPopoverClose}

              // onClick={(e) =>{ 
              //   console.log("hello ")
              //     getClients()
              //   }}
                >
                {/* {MouseHoverPopover1()} */}
                  <Iconify
          icon="tabler:activity"
          fontSize={20}
          color={'text.secondary'}
        />
                <Typography sx={{ color: 'text.secondary', cursor: 'pointer' }}>
         {row.clients ? `+ ${row.clients}` : ''}
                </Typography>
              </Stack>
            </Stack>
          ) : (
            <Typography sx={{}}>
              {row.jobId ? row.jobId : '-'}
            </Typography>
          )}

          <Stack sx={{ flexDirection: "row" }}>

            <Typography sx={{}} color={'text.textG'}>
              {row.contactPersonName ? row.contactPersonName : '-'}
            </Typography>

            {row?.dataFrom === "foxearchdb" && (  
              <Avatar sx={{
                cursor: 'pointer', width: "18px", height: "18px", ml: 1,
                
                mb: -0.5
              }} src="/assets/FoxearchLogo.png" />
            )
            
            }
          </Stack>

        </TableCell>

        {/* <TableCell sx={{ maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}> */}






        <TableCell sx={{ width: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <Typography sx={{}}>
            {row.clientName && row?.clientName.length > 17 ? `${row?.clientName?.slice(0, 17)}...` : row.clientName || '-'}
          </Typography>

  
          {filterTab === 'worksheet' || filterTab === 'favourites' ? (
            <Typography sx={{}}>
              {row.jobIdTitle?.length > 20
                ? `${row.jobIdTitle.slice(0, 20)}...`
                : row.jobIdTitle}
            </Typography>
          ) : (
            <Typography sx={{}}>
              {row.type === 'position' ? (
                row.jobIdTitle?.length > 20
                  ? `${row.jobIdTitle.slice(0, 20)}...`
                  : row.jobIdTitle
              ) : (
                row.positionName?.length > 20
                  ? `${row.positionName.slice(0, 20)}...`
                  : row.positionName
              )}
            </Typography>
          )}

          {/* <Typography
            sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
                  onClick={() => handleOpenn()}
          >
             {MouseHoverPopover()} 
             Notes
          </Typography> */}

          <Typography
  sx={{
    color: 'text.secondary',
    textDecoration: 'underline',
    cursor: 'pointer',
  }}
  
  // CLICK -> MODAL
  onClick={handleOpenn}

  // HOVER -> POPOVER
  onMouseEnter={handlePopoverOpen}
  onMouseLeave={handlePopoverClose}
>
  Notes
        </Typography>
        </TableCell>



















        <TableCell sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
          <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
            <Iconify icon="ic:baseline-email" fontSize={10} />
            {/* <Typography sx={{}} onClick={() => { navigate('/Email') }}>Email</Typography> */}



            <Typography sx={{}} onClick={() => handleOpenModal((row._id))}>Email </Typography>



            <button
              onClick={() => { handleEmail22(row._id) }}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
                display: "flex",
                alignItems: "center"
              }}
            >
              <img
                src="/assets/visaversa.png"
                alt="email"
                style={{ width: 14, height: 14, marginRight: 5, marginLeft: 3 }}
              />
            </button>






          </Stack>










          <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
            <Iconify icon="bx:support" fontSize={10} />
            <Typography sx={{}}>Contact</Typography>
          </Stack>
          {row.userStatus !== 'fake' && row.userStatus !== 'blacklisted' ? (
            <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
              {row.startStatus !== 'quit' && row.startStatus !== 'terminated' && row.startStatus !== 'project ended' ? (
                <Iconify icon="icon-park-solid:check-one" fontSize={10} />
              ) : (
                <Typography sx={{ color: 'transparent' }}>cdcd</Typography>
              )}
              {filterTab === 'worksheet' ? (
                <Typography onClick={() => navigate('/resumeDetail', {
                  state: {
                    endClientName,
                    addedSkills, row, fTab: 'submitted',
                    ...((row.status === 'placement' || row.status === 'started') && { openModal: "editOrNot" })
                  }
                })}>
                  {row.status === 'prospect' ? 'Submit' : 'Resubmit'}
                </Typography>
              ) : null}
              {filterTab === 'favourites' ? (
                <Typography onClick={() => navigate('/resumeDetail', { state: { row, addedSkills, fTab: 'submitted' } })}>
                  {row.status === 'prospect' ? 'Submit' : 'Resubmit'}
                </Typography>
              ) : null}
              {filterTab === 'Hotlist' ? (
                <Typography onClick={() => navigate('/resumeDetail', { state: { row, addedSkills, fTab: 'submitted' } })}>
                  {row.status === 'prospect' ? 'Submit' : 'Resubmit'}
                </Typography>
              ) : null}
              {filterTab === 'submitted' ? (
                <Typography onClick={() => navigate('/resumeDetail', { state: { row, addedSkills, fTab: 'interview' } })}>
                  {/* {row.status === 'submitted' ? 'Interview' : ''} */}
                  {row.status === 'submitted' && (row.tempSubmitStatus !== "Duplicate Submission" && row.tempSubmitStatus !== "unqualified") ? 'Interview' : ''}

                  {/* Interview */}
                </Typography>
              ) : null}
              {filterTab === 'interview' ? (
                <Typography onClick={() => navigate('/resumeDetail', { state: { row, addedSkills, fTab: 'placement' } })}>
                  {row.status === 'interview' ? 'Offer/Reject' : ''}
                </Typography>
              ) : null}
              {filterTab === 'placement' ? (
                <>
                  <Typography
                    onClick={() =>
                      navigate('/resumeDetail', {
                        state: { row, addedSkills, fTab: 'start', q: row.startStatus === 'started' ? 'quit' : '' },
                      })
                    }
                  >
                    {row.startStatus === '' && row.status === 'placement' ? 'Start/Backout' : ''}
                  </Typography>
                  <Typography
                    onClick={() =>
                      navigate('/resumeDetail', {
                        state: { row, addedSkills, fTab: 'start', q: row.startStatus === 'started' ? 'quit' : '' },
                      })
                    }
                  >
                    {row.startStatus === 'started' && row.status === 'placement' ? 'Quit/Pro.End' : ''}
                  </Typography>
                </>
              ) : null}
              {filterTab === 'backout' ? (
                <Typography onClick={() => navigate('/resumeDetail', { state: { addedSkills, row, fTab: 'submitted' } })}>
                  {row.status === 'backout' ? 'Resubmit' : ''}
                </Typography>
              ) : null}
            </Stack>
          ) : (
            <Typography sx={{ color: 'transparent' }}>cdcd</Typography>
          )}
        </TableCell>





      </TableRow>








      <Modal
  open={openJourneyHistory}
  onClose={() => setOpenJourneyHistory(false)}
  sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }}
>
  <Box
    sx={{
      width: { xs: "95%", sm: "90%", md: "85%", lg: "80%" },
      maxWidth: "1100px",
      maxHeight: "90vh",
      overflow: "hidden",
      bgcolor: "#fff",
      p: 3,
      borderRadius: 2,
    }}
  >
    <Stack
      direction={{ xs: "column", md: "row" }}
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
    >
      <Box flex={1} />
      <Typography variant="h5" color="#3C6BA5">
        Hotlists
      </Typography>

      <Box flex={1} display="flex" justifyContent="flex-end">
      <Button
         color="custom"
              variant="contained"
        onClick={() => setOpenHotlistModal(true)}
      >
        Add New
      </Button>
     </Box>
      
    </Stack>

    <Divider sx={{ my: 2 }} />

    {hotlistList?.length === 0 ? (
      <Typography textAlign="center" color="text.secondary">
        No Hotlists Found
      </Typography>
    ) : (
      <>
        <Stack
          direction="row"
          sx={{
            bgcolor: "#3C6BA5",
            p: 1,
            borderRadius: 1,
          }}
        >
          
          <Typography
            sx={{
              flex: 1,
              color: "#fff",
              fontWeight: 600,
            }}
          >
            Date
          </Typography>
          <Typography
            sx={{
              flex: 1,
              color: "#fff",
              fontWeight: 600,
            }}
          >
            User
          </Typography>


          <Typography
            sx={{
              flex: 1,
              color: "#fff",
              fontWeight: 600,
            }}
          >
            Hotlist Name
          </Typography>
             <Typography
            sx={{
              flex: 1,
              color: "#fff",
              fontWeight: 600,
            }}
          >
            Action
          </Typography>
        </Stack>

        <Scrollbar sx={{ maxHeight: 350 }}>
          {hotlistList?.map((item, index) => (
            <Stack
              key={item?._id || index}
              direction="row"
              // sx={{
              //   p: 1,
              //   borderBottom: "1px solid #E5E7EB",
              //   bgcolor: index % 2 === 0 ? "#fff" : "#F9FAFB",
              // }}
              sx={[
                      { background: index % 2 === 0 ? 'text.background' : tablebg },
                      { flexDirection: 'row', p: 1, minWidth: 600 },
                    ]}
            >

                <Typography sx={{ flex: 1 }}>
                {item?.createdAt
                  ?`${new Date(item.createdAt).toLocaleDateString("en-US", optionsDate)}
                    ${new Date(item.createdAt).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    })}`
                  : "-"}
              </Typography>

              <Typography sx={{ flex: 1 }}>
                {item?.userName || "-"}
              </Typography>

            

              <Typography sx={{ flex: 1 }}>
                {/* {item?.hotlistName || "-"} */}
                {item?.hotlistName
    ? item.hotlistName.charAt(0).toUpperCase() + item.hotlistName.slice(1)
    : "-"}
              </Typography>
               <Typography sx={{ flex: 1 }}>
                 <Button
         color="custom"
              variant="contained"
        onClick={() => {addToHostList(item._id)}}
      >
        Add To List
      </Button>
              </Typography>
            </Stack>
          ))}
        </Scrollbar>
      </>
    )}
  </Box>
</Modal>


      <Modal
  open={openHotlistModal}
  onClose={() => {
    setOpenHotlistModal(false);
    setHotlistName("");
  }}
  sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }}
>
  <Box
    sx={{
      width: { xs: "90%", sm: 450 },
      bgcolor: "#fff",
      p: 3,
      borderRadius: 2,
    }}
  >
    <Typography
      variant="h6"
      sx={{
        mb: 2,
        color: "#3C6BA5",
        fontWeight: 600,
      }}
    >
      Add Hotlist
    </Typography>

    <TextField
      fullWidth
      label="Hotlist Name"
      value={hotlistName}
      onChange={(e) => setHotlistName(e.target.value)}
    />

    <Stack
      direction="row"
      spacing={2}
      justifyContent="flex-end"
      mt={3}
    >
      <Button
       
          color="custom"
              variant="contained"
        onClick={() => {
          setOpenHotlistModal(false);
          setHotlistName("");
        }}
      >
        Cancel
      </Button>

      <Button
     
          color="custom"
              variant="contained"
        onClick={createHotlist}
        disabled={loadingBtn}
      >
        {loadingBtn ? "Saving..." : "Save" }
      </Button>
    </Stack>
  </Box>
</Modal>









      <Modal open={deleteModalOpen} onClose={handleCloseDeleteModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '50%', md: '40%' },
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
            bgcolor: 'background.paper',
          }}
        >
          <Typography variant="h6" color="red" textAlign="center">
            Are you sure you want to delete this {filterTab === 'submitted' ? "submission" : "candidate"}?
          </Typography>

          <Stack
            flexDirection={{ xs: 'column', md: 'row' }}
            gap={2}
            mt={2}
            alignItems="center"
            justifyContent="center"
          >
            <Button
              color="custom"
              variant="contained"
              // fullWidth={{ xs: true, md: false }} 
              onClick={() => moveToTrash(row)}
            >
              Yes
            </Button>
            <Button
              color="custom"
              variant="contained"
              // fullWidth={{ xs: true, md: false }} 
              onClick={handleCloseDeleteModal}
            >
              No
            </Button>
          </Stack>
        </Box>
      </Modal>






      <Modal open={confirmOpen} onClose={handleConfirmNo}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '50%', md: '40%' },
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
            bgcolor: 'background.paper',
          }}
        >
          <Typography variant="h6" color="red" textAlign="center">
            Do you want to delete this email?”
          </Typography>

          <Stack
            flexDirection={{ xs: 'column', md: 'row' }}
            gap={2}
            mt={2}
            alignItems="center"
            justifyContent="center"
          >
            <Button
              color="custom"
              variant="contained"
              // fullWidth={{ xs: true, md: false }} 
              onClick={() => handleConfirmYes()}
            >     
              Yes
            </Button>
            <Button
              color="custom"
              variant="contained"
              // fullWidth={{ xs: true, md: false }} 
              onClick={handleConfirmNo}
            >
              No
            </Button>
          </Stack>
        </Box>
      </Modal>



      <Modal open={emailDeleteAllOpen} onClose={emailDeleteAllCloseModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '50%', md: '40%' },
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
            bgcolor: 'background.paper',
          }}
        >
          <Typography variant="h6" color="red" textAlign="center">
            Are you sure you want to delete all scheduled emails?
          </Typography>

          <Stack
            flexDirection={{ xs: 'column', md: 'row' }}
            gap={2}
            mt={2}
            alignItems="center"
            justifyContent="center"
          >
            <Button
              color="custom"
              variant="contained"
              // fullWidth={{ xs: true, md: false }} 
              onClick={() => emailDeleteAllConfirm()}
            >
              Yes
            </Button>
            <Button
              color="custom"
              variant="contained"
              // fullWidth={{ xs: true, md: false }} 
              onClick={emailDeleteAllCloseModal}
            >
              No
            </Button>
          </Stack>
        </Box>
      </Modal>

 

<Popover
  id="mouse-over-popover"
  sx={{ pointerEvents: 'none' }}
  open={openPopover}
  anchorEl={anchorEl}
  onClose={handlePopoverClose}
  disableRestoreFocus
  anchorReference="anchorPosition"
  anchorPosition={{
    top: window.innerHeight / 2,
    left: window.innerWidth / 2,
  }}
  transformOrigin={{
    vertical: 'center',
    horizontal: 'center',
  }}

>
  

             


               <Box 
           sx={{p:2}}
  >
          <Stack sx={{ width: '100%', alignItems: 'flex-end' }}>
            <Button
              color="custom"
              variant="contained"
              size="small"
              onClick={() =>
                navigate('/resumeDetail', {
                  state: {
                    addedSkills,
                    row,
                    mtab: 'Resume',
                    fTab:
                      filterTab === 'worksheet'
                        ? 'submitted'
                        : '' || filterTab === 'favourites'
                          ? 'submitted'
                          : '' || filterTab === 'interview'
                            ? 'placement'
                            : '' || filterTab === 'placement'
                              ? 'start'
                              : '',
                  },
                })
              }
            >
              Add Note
            </Button>
          </Stack>
          <Typography variant="h5" color={'#3C6BA5'} sx={{ textTransform: 'capitalize', mt: -3 }} textAlign={'center'}>
            Notes
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Box sx={{ maxHeight: 400, overflowX: 'auto' }}>
            <Stack sx={{ backgroundColor: 'text.secondary', flexDirection: 'row', p: 1, py: 0.5, borderRadius: 1, minWidth: 800 }}>
              <Typography color={'white'} sx={{ width: '20%', fontSize: '0.976rem', fontWeight: '600' }}>
                Date
              </Typography>
              <Typography color={'white'} sx={{ width: '20%', fontSize: '0.976rem', fontWeight: '600' }}>
                User
              </Typography>
              <Typography color={'white'} sx={{ width: '60%', fontSize: '0.976rem', fontWeight: '600' }}>
                Note
              </Typography>
            </Stack>

            {his.length
              ? his.map((item, index) => {
                return (
                  <Stack
                    key={index}
                    sx={[
                      { background: index % 2 === 0 ? 'text.background' : tablebg },
                      { flexDirection: 'row', p: 1, minWidth: 600 },
                    ]}
                  >
                    <Typography sx={{ width: '20%' }}>
                      {`${new Date(item.createdAt).toLocaleString('en-US', optionsDate)} 
${String(new Date(item?.createdAt).getHours()).padStart(2, '0')}:${String(new Date(item?.createdAt).getMinutes()).padStart(2, '0')}`}
                    </Typography>
                    <Typography sx={{ width: '20%', textTransform: 'capitalize', fontWeight: '800', color: 'text.secondary' }}>
                      {item.actionBy}
                    </Typography>
                    {/* <Box sx={{ width: '60%', overflowX: 'auto' }}>

                      <div
  dangerouslySetInnerHTML={{
    __html: `<span>${item?.noteReason || ''} :</span> ${item?.note || ''}`,
  }}
  style={{
    lineHeight: '1.6',
    fontSize: '1rem',
    whiteSpace: 'pre-wrap',
  }}
/>

                       
                      <div
                        dangerouslySetInnerHTML={{ __html: item?.note }}
                        style={{
                          lineHeight: '1.6',
                          fontSize: '1rem',
                          whiteSpace: 'pre-wrap',
                        }}
                      /> 
                    </Box> */}

                                        <Box sx={{ width: '60%', overflowX: 'auto' }}>
  <div
    dangerouslySetInnerHTML={{
      __html: item?.noteReason
        ? `<strong>${item?.noteReason}</strong>: ${item?.note || ''}`
        : item?.note || '',
    }}
    style={{
      lineHeight: '1.6',
      fontSize: '0.8rem',
      whiteSpace: 'pre-wrap',
     
    }}
  />
                                 </Box>
                  </Stack>
                );
              })
              : null}
          </Box>
        </Box>
</Popover>


<Popover
  id="activities-popover"
  // open={activitiesPopoverOpen}
  open={openActivitiesPopover}
  anchorEl={activitiesAnchorEl}   
  onClose={handleActivitiesPopoverClose}
  disableRestoreFocus
  sx={{ pointerEvents: 'none' }}
  anchorReference="anchorPosition"
  anchorPosition={{
    top: window.innerHeight / 2,
    left: window.innerWidth / 2,
  }}
  transformOrigin={{
    vertical: 'center',
    horizontal: 'center',
  }}
  PaperProps={{
    sx: {
      width: '80%',
      maxWidth: '1200',
      borderRadius: 2,
      p: 2,
      overflow: 'hidden',
    },
  }}
>
  <Box sx={{ p: 1 }}>
    <Typography
      variant="h5"
      color={'#3C6BA5'}
      textAlign={'center'}
    >
      Activities
    </Typography>

    <Divider sx={{ mb: 2 }} />

    <Scrollbar
      sx={{
        maxHeight: 400,
        overflow: 'auto',
      }}
    >
      <Box sx={{ minWidth: 600 }}>
        <Stack sx={{ alignItems: 'center' }}>
          
          {/* HEADER */}
          <Stack
            sx={{
              backgroundColor: 'text.secondary',
              width: '100%',
              alignItems: 'center',
              p: 0.5,
              borderRadius: 1,
            }}
          >
            <Stack
              sx={{
                width: '100%',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <Typography sx={{ width: '25%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                Date
              </Typography>

              <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                User Name
              </Typography>

              <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                Job ID
              </Typography>

              <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                Client
              </Typography>

              <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                Job Title
              </Typography>

              <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                Status
              </Typography>

              <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                Task
              </Typography>
            </Stack>
          </Stack>

          {/* DATA */}
          {client?.length ? (
            client.map((item, index) => (
              <Stack
                key={index}
                sx={[
                  {
                    background:
                      index % 2 === 0
                        ? 'text.background'
                        : tablebg,
                  },
                  {
                    width: '100%',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    p: 1,
                  },
                ]}
              >
                <Typography sx={{ width: '25%' }}>
                  {`${new Date(item.createdAt)?.toLocaleString(
                    'en-US',
                    optionsDate
                  )}
${String(new Date(item?.createdAt)?.getHours()).padStart(2, '0')}:${String(
  new Date(item?.createdAt)?.getMinutes()
).padStart(2, '0')}`}
                </Typography>

                <Typography
                  sx={{
                    width: '20%',
                    textTransform: 'capitalize',
                    fontWeight: '800',
                    color: 'text.secondary',
                  }}
                >
                  {item.actionBy}
                </Typography>

                <Typography sx={{ width: '20%' }}>
                  {item.jobId || '-'}
                </Typography>

                <Typography sx={{ width: '20%' }}>
                  {item.clientName || '-'}
                </Typography>

                <Typography sx={{ width: '20%' }}>
                  {item.jobIdTitle || item.jobTitle}
                </Typography>

                <Typography
                  sx={{
                    width: '20%',
                    color:
                      item.actionTo === 'Started' ||
                      item.actionTo === 'Placement'
                        ? 'green'
                        : item.actionTo === 'Backout from Job offer'
                        ? 'red'
                        : 'inherit',
                  }}
                >
                   {item.actionTo
                       ? item.actionTo.charAt(0).toUpperCase() + item.actionTo.slice(1)
                       : ''}
                </Typography>

                <Typography
                  sx={{
                    width: '20%',
                    textTransform: 'capitalize',
                  }}
                >
                  {item.noteReason || '-'}
                </Typography>
              </Stack>
            ))
          ) : (
            <Typography sx={{ mt: 2 }}>
              No Activities Found
            </Typography>
          )}
        </Stack>
      </Box>
    </Scrollbar>
  </Box>
</Popover>










      {/* 

           <Modal open={emailDeleteAllOpen} onClose={emailDeleteAllCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "white",
            borderRadius: 3,
            p: 3,
            boxShadow: 24,
            border: "2px solid #1A73E8",
            textAlign: "center",
          }}
        >
    
          <Typography
            sx={{
              fontWeight: 700,
              color: "#3C6BA5",
              fontSize: "20px",
              mb: 2,
            }}
          >
            Delete All Emails?
          </Typography>

         
          <Typography sx={{ fontSize: "16px", mb: 3, color: "#3C6BA5" }}>
            Are you sure you want to delete all scheduled emails?
          </Typography>

         
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
            <Button
              variant="outlined"
              sx={{
                borderColor: " #3C6BA5",
                color: "#3C6BA5",
                textTransform: "none",
                px: 3,
                ":hover": {
                  borderColor: " #3C6BA5",
                  color: " #3C6BA5",
                },
              }}
              onClick={emailDeleteAllCloseModal}
            >
              No
            </Button>

            <Button
              variant="contained"
              sx={{
                background: " #3C6BA5",
                textTransform: "none",
                px: 3,
                ":hover": {
                  background: " #3C6BA5",
                },
              }}
              onClick={emailDeleteAllConfirm}
            >
              Yes, Delete All
            </Button>

          </Box>
        </Box>
             </Modal>


 */}









      {/*         
         <Modal
        open={confirmOpen}
        onClose={handleConfirmNo}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
          }}
        >
          <Typography variant="h6" sx={{ mb: 2, color: "#3C6BA5", }}>
            Delete Email?
          </Typography>

          <Typography sx={{ mb: 3, color: "#3C6BA5", }}>
            Do you want to delete this email?”
          </Typography>

          <Box sx={{ textAlign: "right" }}>
            <Button onClick={handleConfirmNo} sx={{ mr: 1 }}>
              No
            </Button>

            <Button color="error" onClick={handleConfirmYes}>
              Yes, Delete
            </Button>
          </Box>
        </Box>
      </Modal> */}
















      <Modal open={openR} onClose={closeResume} style={{ borderRadius: 10 }}>
        <Box sx={styleClients1}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              mt: -2.5,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                textAlign: 'center',
                color: 'text.secondary',
                fontWeight: 'bold',
                flex: 1,
                mb: 1,
                mt: 1,
              }}
            >
              Resume
            </Typography>
            {/* <a href={openRes} download>
              <Iconify icon="mdi:download" width="1.3rem" color="text.secondary" />
            </a> */}
            <button
              type="button"
              onClick={() => handleCheckDownloadLimit(row._id, openRes)}
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              <Iconify
                icon="mdi:download"
                width="1.3rem"
                color="text.secondary"
              />
            </button>
          </Box>
          <Scrollbar
            sx={{
              height: '97%',
              Scrollbar: 'thin',
              border: '2px solid #3C6BA5',
              borderColor: 'text.secondary',
              borderRadius: 2,
            }}
          >
            <Stack sx={{ p: 1.5 }}>

              <Box sx={{ overflowX: 'auto', minWidth: '600px' }}>
                <iframe title="resume" src={suru + openRes + lll} width="100%" height="700px" />
              </Box>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>













      <Modal open={open1} onClose={handleCloseEdit} style={{ borderRadius: 10 }}>
        <Box sx={styleSkill}>
          <Typography variant="h4" color={'#3C6BA5'} textAlign={'center'}>
            Edit Candidate
          </Typography>
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Divider />
            <Grid display={'grid'} gridTemplateColumns={{ md: 'repeat(2, 1fr)', sm: 'repeat(1, 1fr)' }} py={2} gap={4}>
              <Stack gap={2}>
                <FormControl fullWidth>
                  <TextField
                    disabled
                    type="email"
                    id="outlined-basic"
                    label="Email"
                    placeholder="Email"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    value={value.email}
                  />
                </FormControl>

                <TextField
                  id="outlined-basic"
                  label="Full Name"
                  placeholder="Full Name"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.name}
                  onChange={(e) => setValue({ ...value, name: e.target.value })}
                />
                <TextField
                  id="outlined-basic"
                  label="Job title"
                  placeholder="Job title"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.jobtitle}
                  onChange={(e) => setValue({ ...value, jobtitle: e.target.value })}
                />
                <TextField
                  id="outlined-basic"
                  label="Current Company"
                  placeholder="Current Company"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.currCompany}
                  onChange={(e) => setValue({ ...value, currCompany: e.target.value })}
                />

                <TextField
                  id="outlined-basic"
                  label="Phone"
                  placeholder="Phone"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.phone}
                  onChange={(e) => setContact(e.target.value)}
                // type="text"
                // inputProps={{
                //   maxLength: 20,
                // }}
                // onChange={(e) => setValue({ ...value, phone: e.target.value })}
                />
                <Autocomplete
                  disablePortal
                  // id="combo-box-demo"
                  options={visalist}
                  disabled={localStorage.getItem("country") === "INDIA"}
                  value={value.visa}
                  sx={{ width: '100%' }}
                  onChange={(e) => {
                    setValue({ ...value, visa: e.target.innerText });
                    // console.log(e.target.innerText);
                  }}
                  renderInput={(params) => <TextField {...params} label="Visa" />}
                />

                <FormControl disabled={localStorage.getItem("country") === "INDIA"}>
                  <FormLabel id="demo-radio-buttons-group-label">Contract (Tax Term) / Fulltime</FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="c2c"
                    name="radio-buttons-group"
                    value={value.tax}
                    onChange={(e) => setValue({ ...value, tax: e.target.value })}
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      ml: 1,
                    }}
                  >
                    <FormControlLabel value="c2c" control={<Radio />} label="C2C" />
                    <FormControlLabel value="w2" control={<Radio />} label="W2" />
                    <FormControlLabel value="1099" control={<Radio />} label="1099" />
                    <FormControlLabel value="T4" control={<Radio />} label="T4" />
                    <FormControlLabel value="INC" control={<Radio />} label="INC" />
                    <FormControlLabel value="fulltime" control={<Radio />} label="Full-Time" />
                  </RadioGroup>
                </FormControl>


                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Compensation Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value.comType}
                    label="Compensation Type"
                    onChange={(e) => setValue({ ...value, comType: e.target.value })}
                  >
                    <MenuItem value={'hourly'}>Per hour Rate </MenuItem>
                    <MenuItem value={'Annually'}>Annual Compensation</MenuItem>;
                  </Select>
                </FormControl>
                <TextField
                  id="outlined-basic"
                  // label="Expected Compensation( In Dollars )*"
                  // label={`Expected Compensation( In ${value.country === "INDIA" ? "INR" : "Dollars"} )*`}
                    label={`Expected Compensation( In ${localStorage.getItem("country") === "INDIA"
                      ? "₹"
                      : localStorage.getItem("country") === "UK"
                        ? "£"
                        : "$"
                    } )`}
                  placeholder="Expected Compensation"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={value.expectedCom}
                  type="text"
                  InputProps={{
                      startAdornment: <InputAdornment position="start" sx={{ color: "black" }}>{localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country")=== "UK" ? "£" : "$"}</InputAdornment>,
                    // startAdornment: <InputAdornment position="start">{value.country === "INDIA" ? "₹" : value.country === "UK" ? "£" : "$"}</InputAdornment>,
                    endAdornment: value.comType && (
                      <InputAdornment position="end">{value.comType === 'hourly' ? 'per/hour' : localStorage.getItem("country") === 'INDIA' ? 'Lac':'K'}</InputAdornment>
                    ),
                  }}
                  // onChange={(e) => setValue({ ...value, expectedCom: e.target.value })}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(newValue)) {
                      setValue({ ...value, expectedCom: newValue });
                    }
                  }}
                />
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Job Id</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value.jobid}
                    label="Job Id"
                    onChange={(e) => {
                      const selectedJob = joblst1?.find(item => item?.jobId === e.target.value);
                      setEndClientName(selectedJob?.endClientOrImpPartner);
                      // console.log("selectedJob", selectedJob?.endClientOrImpPartner)
                      setValue(prev => ({
                        ...prev,
                        jobid: e.target.value
                      }));
                    }}
                  >
                    <MenuItem value={''}>NA</MenuItem>
                    {joblst1?.map((item, index) => {
                      return <MenuItem key={index} value={item.jobId}>{item.jobId}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Stack>
              <Stack gap={2}>
                {/* <FormControl fullWidth sx={{}}>
                  <TextField
                    id="outlined-basic"
                    label="Linkedin URL"
                    placeholder="Linkedin URL"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    value={value.linkedinUrl}
                    // type='number'
                    onChange={(e) => setValue({ ...value, linkedinUrl: e.target.value })}

                  />
                </FormControl> */}

                <FormControl fullWidth sx={{}}>
                  <TextField
                    id="outlined-basic"
                    label="Linkedin URL"
                    placeholder="Linkedin URL"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    value={value.linkedinUrl}
                    onChange={(e) => {
                      let updatedUrl = e.target.value?.trim();
                      updatedUrl = updatedUrl?.replace(/^(https?:\/\/)?(www\.)?/i, '');

                      if (updatedUrl?.startsWith('www')) {
                        updatedUrl = `https://${updatedUrl}`;
                      } else if (updatedUrl !== '') {
                        updatedUrl = `https://www.${updatedUrl}`;
                      }

                      setValue({ ...value, linkedinUrl: updatedUrl });
                    }}
                  />
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Select Country</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value.country}
                    label="Select Country"
                    onChange={(e) => setValue({ ...value, country: e.target.value })}
                  >
                    {/* <MenuItem value="USA">USA</MenuItem>;
                    <MenuItem value="CANADA">CANADA</MenuItem>;
                     <MenuItem value={'INDIA'}>INDIA</MenuItem>; */}
                    {countries?.map((item) => (
                      <MenuItem key={item.id} value={item.country}>
                        {item.country}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <CustomComplete
                  placeholder={'City & Pincode'}
                  option={cityData}
                  propVal={cityy}
                  childFuc={childFuc}
                  fullVal={fullVal}
                  fetch={'state'}
                  err={err}
                  helperText={helperText}
                />
                <FormControl>
                  {cityandstate ? (
                    <Stack sx={{ ml: 1, mt: -1, flexDirection: 'row' }}>
                      <Typography color={'text.textG'} variant="body">
                        {cityandstate.city},
                      </Typography>
                      <Typography color={'text.textG'} variant="body" sx={{ ml: 1 }}>
                        {cityandstate.stateCode}
                        {/* {console.log("=====cityandstate.state===>>>", cityandstate.state)} */}
                      </Typography>
                    </Stack>
                  ) : null}
                </FormControl>

                <FormControl fullWidth>
                  <TextField
                    id="outlined-basic"
                     label={localStorage.getItem("country") === "INDIA" ? "Pincode" : "Zip Code"}
                   // label="Zip code"
                    placeholder={localStorage.getItem("country") === "INDIA" ? "Pincode" : "Zip Code"}
                  //  placeholder=
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    value={value.zip}
                    // type="number"
                    onChange={(e) => setValue({ ...value, zip: e.target.value })}
                  />
                </FormControl>
                <FormControl fullWidth>
                  <FormLabel id="demo-radio-buttons-group-label">Can Relocate </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="yes "
                    name="radio-buttons-group"
                    value={value.reloc}
                    onChange={(e) => setValue({ ...value, reloc: e.target.value })}
                    sx={{ display: 'flex', flexDirection: 'row', ml: 1 }}
                  // defaultValue={row}
                  >
                    <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                    <FormControlLabel value="no" control={<Radio />} label="No" />
                  </RadioGroup>
                </FormControl>

                <Autocomplete
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setFinallst([...newValue]);
                  }}
                  options={addedSkills || skill}
                  getOptionLabel={(option) => option.title}
                  value={finallst.map((item) => item)}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({
                        inputValue,
                        title: `${inputValue}`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => <TextField {...params} label="Skills" placeholder="Skills" />}
                />
                {/* <Stack sx={{ position: 'relative', width: '100%' }}>
                  <Autocomplete
                    value={askill}
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        addskill(newValue);
                        console.log('first----- ', newValue);
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        // setAskill({title: newValue.inputValue});
                        console.log('second------ ', newValue.inputValue);
                        addskill(newValue.inputValue);
                      } else {
                        console.log('third----- ', newValue.title);
                        addskill(newValue.title);
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      const { inputValue } = params;
                      // Suggest the creation of a new value
                      const isExisting = options.some((option) => inputValue === option.title);
                      if (inputValue !== '' && !isExisting) {
                        filtered.push({
                          inputValue,
                          title: `Add "${inputValue}"`,
                        });
                      }

                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    id="free-solo-with-text-demo"
                    options={skillset}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === 'string') {
                        // console.log("re 1-----",option);
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      return option.title;
                    }}
                    renderOption={(props, option) => <li {...props}>{option.title}</li>}
                    sx={{}}
                    freeSolo
                    renderInput={(params) => <TextField {...params} label="Skill" />}
                  />

                  {finallst.length ? (
                    <Stack sx={{ marginTop: 1 }}>
                      <Grid container spacing={2}>
                        {finallst.map((item) => {
                          return (
                            <Grid item>
                              <Item>
                                {item}
                                <Iconify
                                  icon="basil:cross-outline"
                                  sx={{ color: 'white', width: 20, height: 20 }}
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => del(item)}
                                />
                              </Item>
                            </Grid>
                          );
                        })}
                      </Grid>
                    </Stack>
                  ) : null}
                </Stack> */}
                <Stack sx={{ flexDirection: 'row' }}>
                  <Stack
                    sx={{
                      flexDirection: 'row',
                      // justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Typography variant="subtitle1">Upload Resume*</Typography>

                    <Stack sx={{ flexDirection: 'row' }}>
                      <Stack sx={{ position: 'relative' }}>
                        <Stack
                          sx={{
                            cursor: 'pointer',
                            m: 1,
                            border: 1,
                            p: 0.5,
                            borderRadius: 2,
                            width: 100,
                            borderColor: 'text.secondary',
                          }}
                        >
                          <Typography sx={{ alignSelf: 'center' }} color={'text.secondary'}>
                            choose file
                          </Typography>
                        </Stack>
                        <input
                          style={{ opacity: 0, position: 'absolute', margin: 5, width: 100 }}
                          type="file"
                          accept=".doc,.docx, application/pdf"
                          onChange={(e) => {
                            setDocfile(e.target.files[0]);
                            setChoosefile(false);
                            pdfUpload(e.target.files[0]);
                          }}
                        />
                      </Stack>
                      {pdffile && (
                        <Stack sx={{ mt: 0.5, flexDirection: 'row', alignItems: 'center' }}>
                          <a href={pdffile} target="_foxearch">
                            <Button color="custom" variant="outlined">
                              View File
                            </Button>
                          </a>
                        </Stack>
                      )}
                      {docfile ? (
                        <Stack sx={{ justifyContent: 'center' }}>
                          <Typography variant="body2" sx={{ width: 200 }}>
                            {docfile.name}
                          </Typography>
                        </Stack>
                      ) : null}
                    </Stack>
                  </Stack>
                  {docfile ? (
                    <Stack>
                      <Iconify
                        icon="basil:cross-outline"
                        sx={{ color: 'text.secondary' }}
                        fontSize={20}
                        style={{ cursor: 'pointer' }}
                        onClick={() => delfile()}
                      />
                    </Stack>
                  ) : null}

                  {/* {docfile && (
                    <Stack sx={{ mt: 0.5, flexDirection: 'row' }}>
                      <Button color="custom" variant="outlined" size="small" onClick={() => pdfUpload()}>
                        Upload File
                      </Button>
                    </Stack>
                  )} */}
                  {choosefile === true ? (
                    <Stack sx={{ justifyContent: 'center', alignItems: 'center', ml: 2 }}>
                      <Typography color={'green'}>Success</Typography>
                    </Stack>
                  ) : null}
                </Stack>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Change Status</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value.userStatus}
                    label="Change Status"
                    onChange={(e) => setValue({ ...value, userStatus: e.target.value })}
                  >
                    <MenuItem value={'fake'}>Fake</MenuItem>
                    <MenuItem value={'blacklisted'}>Blacklisted</MenuItem>
                    <MenuItem value={'active'}>Active</MenuItem>;
                  </Select>
                </FormControl>
                <TextField
                  sx={{}}
                  id="outlined-multiline-static"
                  label="Notes"
                  multiline
                  rows={4}
                  value={value.notes}
                  onChange={(e) => setValue({ ...value, notes: e.target.value })}
                // defaultValue="Default Value"
                />
                {/* <Stack sx={{ width: 500 }}>
                  <CKEditor
                    editor={ClassicEditor}
                    // data="<p>{value.notes}<br><br></p>"
                    onReady={(editor) => {
                      // You can store the "editor" and use when it is needed.
                      console.log('Editor is ready to use!', editor);
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setValue({ ...value, notes: data });
                      console.log('ckeditor------data', { event, editor, data });
                    }}
                    onBlur={(event, editor) => {
                      console.log('Blur.', editor);
                    }}
                    onFocus={(event, editor) => {
                      console.log('Focus.', editor);
                    }}
                  />
                </Stack> */}
              </Stack>
            </Grid>
            <Stack flexDirection={'row'} gap={1} mt={1} sx={{ justifyContent: 'center' }}>
              <Button color="custom" variant="contained"
                onClick={(e) => editResume(row)}
                disabled={loadingEdit}
              >
                {loadingEdit ? <CircularProgress size={21} /> : 'Save CV'}
                {/* Save CV */}
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>













      <Modal open={opens} onClose={handleCloses} style={{ borderRadius: 10 }}>
        <Box sx={styleSkillset11}>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              justifyContent: { xs: "center", sm: "space-between" },
              width: "100%",
              position: "relative",
              textAlign: "center",
            }}
          >

            <Typography
              variant="h5"
              color="#3C6BA5"
              sx={{
                position: { sm: "absolute" },
                left: { sm: "50%" },
                transform: { sm: "translateX(-50%)" },
                mb: { xs: 1, sm: 0 },
              }}
            >
              Skills
            </Typography>

            <Stack
              direction="row"
              spacing={1.9}
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-end" },
                width: { xs: "100%", sm: "auto" },
                ml: "auto",
              }}
            >
              <Button color="custom" variant="contained" onClick={handleSkillOpen}>Add</Button>
              {hideButton ? (
                <Button color="custom" variant="contained" onClick={() => { setHideButton(!hideButton); setHideCross(false); }}>
                  Delete
                </Button>
              ) : (
                <Button color="custom" variant="contained" onClick={deleteSkill} disabled={loading12}>
                  {loading12 ? <CircularProgress size={24} /> : 'Save'}
                </Button>
              )}
            </Stack>
          </Box>

          <Scrollbar sx={{ maxHeight: 600, Scrollbar: 'thin' }}>
            <Divider sx={{ mt: 0.5, borderWidth: 1.7, borderColor: '#3C6BA5' }} />
            <Stack
              sx={{
                flexDirection: 'row',
                justifyContent: 'center',
                gap: 0.5,


                flexWrap: 'wrap'
              }}
            >

              {newSkill?.filter(item => item !== '' && item != null).map((item, index) => (

                item && (
                  <Box
                    key={index}
                    sx={{
                      position: 'relative',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mt: 2,
                    }}
                  >
                    <Typography
                      variant="h6"
                      color="text.textG"
                      textAlign="center"
                      textTransform="capitalize"
                      sx={{ paddingRight: '2px', position: 'relative', paddingTop: '-3px' }}
                    >
                      {item} {index < row.skill.length - 1 && '|'}

                      {!hideCross && (
                        <Iconify
                          icon="system-uicons:cross-circle"
                          width="1.45rem"
                          height="1.45rem"
                          sx={{
                            position: 'absolute',
                            top: '-15px',
                            right: '1px',
                            cursor: 'pointer',
                            color: 'red',
                          }}
                          onClick={() => handleDeleteSkill(index)}
                        />
                      )}

                    </Typography>
                  </Box>
                )
              ))}

            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

















      <Modal open={addSkill} onClose={handleSkillClose} sx={{ borderRadius: 10 }}>
        <Box sx={styleSkillset1}>
          <Stack spacing={3}>
            <Autocomplete
              multiple
              id="tags-outlined"
              onChange={(event, newValue) => {
                setSkillss([...newValue]);
              }}
              options={addedSkills}
              getOptionLabel={(option) => option.title}
              value={skillss}
              filterSelectedOptions
              filterOptions={(options, params) => {
                const filtered = filter(options, params);
                const { inputValue } = params;

                const isExisting = options.some((option) => inputValue === option.title);
                if (inputValue !== '' && !isExisting) {
                  filtered.push({
                    inputValue,
                    title: `${inputValue}`,
                  });
                }
                return filtered;
              }}
              renderInput={(params) => (
                <TextField {...params} label="Skills" placeholder="Enter Skill" autoFocus />
              )}
            />
            <Stack direction="row" justifyContent="center" spacing={3}>
              <Button
                color="custom"
                variant="contained"
                onClick={() => {
                  // handleSkillClose();
                  // handleCloses()
                  // setSkillss([]);
                  AdddSkill()
                }}
                disabled={loading11}
              >
                {/* Add Skill */}
                {loading11 ? <CircularProgress size={24} /> : 'Add Skill'}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>






      

      <Modal
  onClose={handleClosen}
       open={openn} 
      style={{ borderRadius: 10 }}>


        <Box sx={styleClients}
       
  >
          <Stack sx={{ width: '100%', alignItems: 'flex-end' }}>
            <Button
              color="custom"
              variant="contained"
              size="small"
              onClick={() =>
                navigate('/resumeDetail', {
                  state: {
                    addedSkills,
                    row,
                    mtab: 'Resume',
                    fTab:
                      filterTab === 'worksheet'
                        ? 'submitted'
                        : '' || filterTab === 'favourites'
                          ? 'submitted'
                          : '' || filterTab === 'interview'
                            ? 'placement'
                            : '' || filterTab === 'placement'
                              ? 'start'
                              : '',
                  },
                })
              }
            >
              Add Note
            </Button>
          </Stack>
          <Typography variant="h5" color={'#3C6BA5'} sx={{ textTransform: 'capitalize', mt: -3 }} textAlign={'center'}>
            Notes
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Box sx={{ maxHeight: 400, overflowX: 'auto' }}>
            <Stack sx={{ backgroundColor: 'text.secondary', flexDirection: 'row', p: 1, py: 0.5, borderRadius: 1, minWidth: 600 }}>
              <Typography color={'white'} sx={{ width: '20%', fontSize: '0.976rem', fontWeight: '600' }}>
                Date
              </Typography>
              <Typography color={'white'} sx={{ width: '20%', fontSize: '0.976rem', fontWeight: '600' }}>
                User
              </Typography>
              <Typography color={'white'} sx={{ width: '60%', fontSize: '0.976rem', fontWeight: '600' }}>
                Note
              </Typography>
            </Stack>

            {his.length
              ? his.map((item, index) => {
                return (
                  <Stack
                    key={index}
                    sx={[
                      { background: index % 2 === 0 ? 'text.background' : tablebg },
                      { flexDirection: 'row', p: 1, minWidth: 600 },
                    ]}
                  >
                    <Typography sx={{ width: '20%' }}>
                      {`${new Date(item.createdAt).toLocaleString('en-US', optionsDate)} 
${String(new Date(item?.createdAt).getHours()).padStart(2, '0')}:${String(new Date(item?.createdAt).getMinutes()).padStart(2, '0')}`}
                    </Typography>
                    <Typography sx={{ width: '20%', textTransform: 'capitalize', fontWeight: '800', color: 'text.secondary' }}>
                      {item.actionBy}
                    </Typography>
                    {/* <Box sx={{ width: '60%', overflowX: 'auto' }}>
                      <div
                        dangerouslySetInnerHTML={{ __html: item?.note }}
                        style={{
                          lineHeight: '1.6',
                          fontSize: '1rem',
                          whiteSpace: 'pre-wrap',
                        }}
                      />
                    </Box> */}



                    <Box sx={{ width: '60%', overflowX: 'auto' }}>
  <div
    dangerouslySetInnerHTML={{
      __html: item?.noteReason
        ? `<strong>${item?.noteReason}</strong>: ${item?.note || ''}`
        : item?.note || '',
    }}
    style={{
      lineHeight: '1.6',
      fontSize: '0.8rem',
      whiteSpace: 'pre-wrap',
    }}
  />
</Box>
                  </Stack>
                );
              })
              : null}
          </Box>
        </Box>
      </Modal>  












      <Modal open={levelM} onClose={() => setLevelM(false)} style={{ borderRadius: 10 }}>
        <Box sx={[styleSkillset, { width: { xs: '60%', sm: '50%' } }]}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Change Status
          </Typography>
          <Divider />
          <Stack sx={{ justifyContent: 'center', gap: 2, mb: 2, mt: 2, width: '100%' }}>
            <Stack sx={{ alignSelf: 'center', gap: 3, width: '60%' }}>
              <FormControl>
                <InputLabel id="demo-simple-select-label">Select New Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  InputLabelProps={{ shrink: true }}
                  label="Select New Status"
                  placeholder="Select New Status"
                  value={subStatus}
                  onChange={(e) => setSubStatus(e.target.value)}
                >
                  <MenuItem value={'client Submission'}>Client Submission</MenuItem>
                  <MenuItem value={'unqualified'}>Unqualified</MenuItem>
                  <MenuItem value={'shortlisted'}>Shortlisted</MenuItem>
                  <MenuItem value={'job On Hold'}>Job On Hold</MenuItem>
                  <MenuItem value={'out Of Market'}>Out of Market</MenuItem>
                  <MenuItem value={'Duplicate Submission'}>Duplicate Submission</MenuItem>
                </Select>
              </FormControl>

              <FormControl sx={{}}>
                <TextField
                  id="outlined-multiline-static"
                  label="Note... (Max 2000 char)"
                  placeholder="Note..."
                  multiline
                  rows={5}
                  value={statusNote}
                  onChange={(e) => setStatusNote(e.target.value)}
                />
              </FormControl>
              <Button
                color="custom"
                variant="contained"
                sx={{ width: '15%', alignSelf: 'center' }}
                disabled={loading}
                onClick={(e) => Submitted1(row)}
              >
                {/* Submit */}
                {loading ? <CircularProgress size={21} /> : 'Submit'}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      <Modal open={openinterview} onClose={handlecloseinterview} style={{ borderRadius: 10 }}>
        <Box sx={styleSkillset}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'} sx={{ textTransform: 'capitalize' }}>
            {row.fullName} Interview Schedule
          </Typography>
          <Scrollbar sx={{ maxHeight: 600, Scrollbar: 'thin' }}>
            <Divider />
            <Stack
              sx={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '100%',
                backgroundColor: 'text.secondary',
                borderRadius: 1,
                p: 0.5
              }}
            >
              <Typography color={'white'} sx={{ width: '30%', fontWeight: '600', fontSize: '0.976rem' }}>
                Date
              </Typography>
              <Typography color={'white'} sx={{ width: '30%', fontWeight: '600', fontSize: '0.976rem' }}>
                Time
              </Typography>
              {/* {row?.hiringManagerName && ( */}

              <Typography color={'white'} sx={{ width: '30%', fontWeight: '600', fontSize: '0.976rem' }}>
                Hiring Manager
              </Typography>
              {/* )} */}
              <Typography color={'white'} sx={{ width: '30%', fontWeight: '600', fontSize: '0.976rem' }}>
                Mode
              </Typography>
            </Stack>
            {filterTab === 'interview' ? (
              <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between', width: '100%', p: 1 }}>
                <Typography sx={{ width: '30%' }}>
                  {/* {moment(row.interviewDate).format('lll')} */}
                  {`${new Date(row?.interviewDate).toLocaleString('en-US', optionsDate)}`}

                  {/* {moment(row.interviewStartTime).format('LT')} - {moment(row.interviewEndTime).format('LT')}{' '} */}
                </Typography>
                <Typography sx={{ width: '30%', textTransform: 'uppercase' }}
                >
                  {(row.interviewStartTime)}{' - '}
                  {/* {`${String(new Date(row?.interviewStartTime).getHours()).padStart(2, '0')}`}:{`${String(new Date(row?.interviewStartTime).getMinutes()).padStart(2, '0')}`}{' - '} */}
                  {row.interviewEndTime}{" "}
                  {/* {`${String(new Date(row?.interviewEndTime).getHours()).padStart(2, '0')}`}:{`${String(new Date(row?.interviewEndTime).getMinutes()).padStart(2, '0')}`}{' - '} */}

                  {row.timezone}
                </Typography>

                <Typography sx={{ width: '30%' }}>

                  {row?.hiringManagerName}
                  {row.interviewMode !== 'phoneic' && (
                    row?.contactNo ? ` - (${row?.contactNo})` : ''
                  )}
                </Typography>

                <Stack sx={{ flexDirection: 'row', width: '30%', textTransform: 'capitalize', overflow: 'hidden' }}>
                  {row.interviewMode === 'phoneic' && (
                    <>
                      <Typography sx={{ textTransform: 'capitalize', marginLeft: "1%" }}>
                        Phone{row?.contactNo ? ` - (${row?.contactNo})` : ''}{" "}</Typography>
                      <CopyToClipboard
                        text={`
                          Date: ${moment(row.interviewDate).format('lll')}
                          
                          Time:  ${moment(row.interviewStartTime).format('LT')} - ${moment(row.interviewEndTime).format(
                          'LT'
                        )} ${row.timezone}                     
                          Mode: ${'Phone'} - ${row.contactNo
                          },                                                              
                          `}
                      >
                        <Iconify
                          icon="radix-icons:copy"
                          color={'text.textG'}
                          sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                          hover
                        />
                      </CopyToClipboard>
                    </>
                  )}
                  {row.interviewMode === 'video' && (
                    <>
                      <Typography sx={{ textTransform: 'capitalize', marginLeft: "1%" }}>
                        {/* {(row?.hiringManagerName)? `${row?.hiringManagerName} - `: ''} */}
                        {/* {row?.contactNo ? `(${row?.contactNo}) - ` : ''}{" "} */}
                        {(row.videoPlatform) ? `${row.videoPlatform} - ` : "Video Conference - "}
                        <Typography
                          sx={{ textTransform: 'capitalize', color: 'text.secondary', cursor: 'pointer', display: 'inline' }}
                          onClick={() => window.open(row.meetingLink, '_blank')}
                        >
                          {" "} Meeting url {" "}
                        </Typography>
                      </Typography>

                      {/* <a href={row.meetingLink} target="_blank" rel="noreferrer">
                        &nbsp; Meeting link
                      </a> */}
                      <CopyToClipboard
                        text={`
                          Date: ${moment(row.interviewDate).format('lll')}
                          Time:  ${moment(row.interviewStartTime).format('LT')} - ${moment(row.interviewEndTime).format(
                          'LT'
                        )} ${row.timezone}                     
                          Mode: ${row.videoPlatform} - ${row.meetingLink},
                                                                                         
                          `}
                      >
                        <Iconify
                          icon="radix-icons:copy"
                          color={'text.textG'}
                          sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                          hover
                        />
                      </CopyToClipboard>
                    </>
                  )}
                  {row.interviewMode === 'onsite' && (
                    <>
                      <Typography sx={{ textTransform: 'capitalize', maxWidth: '90%', marginLeft: "1%" }}>
                        {/* {row?.hiringManagerName?`${row?.hiringManagerName} - `:''}  {row?.contactNo ? `(${row?.contactNo}) - ` : ''} */}
                        face to face{(row?.companyAddress) ? ` - (${row?.companyAddress})` : ''}
                      </Typography>
                      <CopyToClipboard
                        text={`
                          Date: ${moment(row.interviewDate).format('lll')}
                          Time:  ${moment(row.interviewStartTime).format('LT')} - ${moment(row.interviewEndTime).format(
                          'LT'
                        )} ${row.timezone}                       
                          Mode: ${'Face To Face'} - ${row.companyAddress
                          }                                                              
                          `}
                      >
                        <Iconify
                          icon="radix-icons:copy"
                          color={'text.textG'}
                          sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                          hover
                        />
                      </CopyToClipboard>
                    </>
                  )}
                </Stack>{' '}
              </Stack>
            ) : null}
          </Scrollbar>
        </Box>
      </Modal>


 <Modal
//  open={openclient} onClose={handleCloseclient}
   open={openActivitiesModal}
onClose={handleCloseActivitiesModal}
 style={{ borderRadius: 10 }}>
        <Box sx={styleClients}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Activities
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Scrollbar sx={{ maxHeight: 400, overflowX: 'auto' }}>
            <Box sx={{ minWidth: 600 }}>
              <Stack sx={{ alignItems: 'center' }}>
                <Stack
                  sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}
                >
                  <Stack
                    sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}
                  >
                    <Typography sx={{ width: '25%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Date
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      User Name
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Job ID
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Client
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Job Title
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Status
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Task
                    </Typography>
                  </Stack>
                </Stack>

                {client
                  ? client.map((item, index) => {
                    return (
                      <Stack
                        key={index}
                        sx={[
                          { background: index % 2 === 0 ? 'text.background' : tablebg },
                          { width: '100%', flexDirection: 'row', justifyContent: 'space-between', p: 1 },
                        ]}
                      >
                        <Typography sx={{ width: '25%' }}>
                          {`${new Date(item.createdAt)?.toLocaleString('en-US', optionsDate)} 
${String(new Date(item?.createdAt)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.createdAt)?.getMinutes())?.padStart(2, '0')}`}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize', fontWeight: '800', color: 'text.secondary' }}>
                          {item.actionBy}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                          {item.jobId ? item.jobId : '-'}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                          {item.clientName ? item.clientName : '-'}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                          {item.jobIdTitle || item.jobTitle}
                        </Typography>
                        <Typography
                          sx={[
                            {
                              color:
                                item.actionTo === 'started' || item.actionTo === 'placement'
                                  ? 'green'
                                  : item.actionTo === 'Backout from Job offer'
                                    ? 'red'
                                    : '',
                            },
                            { width: '20%', textTransform: 'capitalize' },
                          ]}
                        >
                          {item.actionTo}
                        </Typography>
                        <Typography
                               sx={{
                                  width: '20%',
                                  textTransform: 'capitalize',
                                 }}
                              >
                             {item.noteReason || '-'}
                        </Typography>
                      </Stack>
                    );
                  })
                  : null}
              </Stack>
            </Box>
          </Scrollbar>
        </Box>
      </Modal> 

      <Modal open={esub} onClose={closeEsub} style={{ borderRadius: 10 }}>
        <Box sx={[styleSkillset, { width: { xs: '60%', sm: '50%' } }]}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Edit Submission
          </Typography>
          <Divider />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Stack gap={2}>
              <FormControl>
                <Typography fontWeight={500}>Submit to</Typography>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="position"
                  name="radio-buttons-group"
                  value={subto}
                  onChange={(e) => setSubto(e.target.value)}
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    ml: 1,
                  }}
                >
                  <FormControlLabel value="position" control={<Radio />} label="Position" />
                  <FormControlLabel value="client" control={<Radio />} label="Client" />
                </RadioGroup>
              </FormControl>
              {subto === 'position' && (
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Job Id</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={esubdata.subjobid}
                    label="Job Id"
                    onChange={(e) => setEsubdata({ ...esubdata, subjobid: e.target.value })}
                  // onChange={(e) => alert(e.target.value)}
                  >
                    <MenuItem value={''}>NA</MenuItem>
                    {joblst1.map((item, index) => {
                      return <MenuItem key={index} value={item.jobId}>{item.jobId}: {item.jobTitle}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              )}
              {subto === 'client' && (
                <>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Select Client</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={esubdata.cname}
                      label="Select Client"
                      onChange={(e) => {
                        const selectedClient = clientlist.find(item => item.companyName === e.target.value);
                        if (selectedClient) {
                          setEsubdata({
                            ...esubdata,
                            clientid: selectedClient._id,
                            cname: selectedClient.companyName
                          });
                        }
                      }}
                    // onChange={(e) => setEsubdata({ ...esubdata, cname: e.target.value,
                    //   clientid: e.target._id,
                    //  })}
                    >
                      {clientlist.map((item) => {
                        return <MenuItem value={item.companyName}>{item.companyName}</MenuItem>;
                      })}

                    </Select>
                  </FormControl>
                  <FormControl>
                    <TextField
                      sx={{ mt: 2 }}
                      id="outlined-basic"
                      label="Position Name"
                      placeholder="Position Name"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      value={esubdata.pname}
                      onChange={(e) => setEsubdata({ ...esubdata, pname: e.target.value })}
                    />
                  </FormControl>
                </>
              )}
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Compensation Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={esubdata.comType}
                  label="Compensation Type"
                  onChange={(e) => setEsubdata({ ...esubdata, comType: e.target.value })}
                >
                  <MenuItem value={'hourly'}>Per hour Rate </MenuItem>
                  <MenuItem value={'Annually'}>Annual Compensation</MenuItem>;
                </Select>
              </FormControl>
              <FormControl>
                <TextField
                  id="outlined-basic"
                  label="Expected Compensation( In Dollars )*"
                  placeholder="Expected Compensation"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={esubdata.expectedCom}
                  type="text"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    endAdornment: esubdata.comType && (
                      <InputAdornment position="end">
                        {esubdata.comType === 'hourly' ? 'per/hour' : 'K'}
                      </InputAdornment>
                    ),
                  }}
                  // onChange={(e) => setEsubdata({ ...esubdata, expectedCom: e.target.value })}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(newValue)) {
                      setEsubdata({ ...esubdata, expectedCom: newValue });
                    }
                  }}
                />
              </FormControl>
              <FormControl>
                <FormLabel id="demo-radio-buttons-group-label">Contract (Tax Term) / Fulltime</FormLabel>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="c2c"
                  name="radio-buttons-group"
                  value={esubdata.tax}
                  onChange={(e) => setEsubdata({ ...esubdata, tax: e.target.value })}
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    ml: 1,
                  }}
                >
                  <FormControlLabel value="c2c" control={<Radio />} label="C2C" />
                  <FormControlLabel value="w2" control={<Radio />} label="W2" />
                  <FormControlLabel value="1099" control={<Radio />} label="1099" />
                  <FormControlLabel value="T4" control={<Radio />} label="T4" />
                  <FormControlLabel value="INC" control={<Radio />} label="INC" />
                  <FormControlLabel value="fulltime" control={<Radio />} label="Full-Time" />
                </RadioGroup>
              </FormControl>
              <Button
                type="submit"
                variant="contained"
                color="custom"
                size="small"
                sx={{ width: 'fit-content', mb: 2, alignSelf: 'center' }}
                onClick={() => EditSubmitted()}
                disabled={loadingSub}
              >
                {/* Submit */}
                {loadingSub ? <CircularProgress size={21} /> : 'Submit'}

              </Button>

            </Stack>
          </Scrollbar>
        </Box>
      </Modal>
      <Modal open={eplace} onClose={closeEplace} style={{ borderRadius: 10 }}>
        <Box sx={[styleSkillset, { width: { xs: '60%', sm: '50%' } }]}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Edit Placement
          </Typography>
          <Divider />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Stack sx={{}}>
              <FormControl fullWidth>
                <Typography fontWeight={500} sx={{ my: 2 }}>
                  Placement Status
                </Typography>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="c2c"
                  name="radio-buttons-group"
                  value={eplacedata.placestatus}
                  onChange={(e) => setEplacedata({ ...eplacedata, placestatus: e.target.value })}
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    ml: 1,
                  }}
                >
                  <FormControlLabel value="placed" control={<Radio />} label="Placed" />
                  <FormControlLabel value="rejected" control={<Radio />} label="Rejected" />
                </RadioGroup>
              </FormControl>
              {eplacedata.placestatus === 'placed' && (
                <Stack gap={2}>
                  <FormControl sx={{}}>
                    <InputLabel id="demo-simple-select-label">Job Type</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Job Type"
                      value={eplacedata.jobType}
                      onChange={(e) => setEplacedata({ ...eplacedata, jobType: e.target.value })}
                    >
                      <MenuItem value="onsite">On Site</MenuItem>
                      <MenuItem value="hybrid">Hybrid</MenuItem>
                      <MenuItem value="wfh">WFH</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl sx={{}}>
                    <InputLabel id="demo-simple-select-label">Offered Job</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Offered Job"
                      value={eplacedata.offeredJob}
                      onChange={(e) => setEplacedata({ ...eplacedata, offeredJob: e.target.value })}
                    >
                      <MenuItem value="fulltime">Fulltime</MenuItem>
                      <MenuItem value="contract">Contract</MenuItem>
                      <MenuItem value="cth">CTH</MenuItem>
                    </Select>
                  </FormControl>
                  {eplacedata.offeredJob === 'fulltime' ? (
                    <>
                      <FormControl sx={{}}>
                        <TextField
                          sx={{}}
                          id="outlined-multiline-static"
                          label="Annual Salary"
                          value={eplacedata.AnnualSalary}
                          type="number"
                          InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                            endAdornment: <InputAdornment position="end">K</InputAdornment>
                          }}
                          onChange={(e) => setEplacedata({ ...eplacedata, AnnualSalary: e.target.value })}
                        />
                      </FormControl>
                      <FormControl>
                        <TextField
                          id="outlined-multiline-static"
                          label="Joining Bonus"
                          value={eplacedata.JoiningBonus}
                          onChange={(e) => setEplacedata({ ...eplacedata, JoiningBonus: e.target.value })}
                        />
                      </FormControl>
                      <FormControl>
                        <TextField
                          id="outlined-multiline-static"
                          label="Annual Bonus"
                          value={eplacedata.AnnualBonus}
                          onChange={(e) => setEplacedata({ ...eplacedata, AnnualBonus: e.target.value })}
                        />
                      </FormControl>
                      <FormControl>
                        <TextField
                          id="outlined-multiline-static"
                          label="Relocation Assistance"
                          value={eplacedata.ReloAssistance}
                          onChange={(e) => setEplacedata({ ...eplacedata, ReloAssistance: e.target.value })}
                        />
                      </FormControl>
                    </>
                  ) : null}

                  {eplacedata.offeredJob !== 'fulltime' ? (
                    <>
                      <FormControl>
                        <TextField
                          sx={{}}
                          id="outlined-multiline-static"
                          label="Hourly Rate Offered"
                          value={eplacedata.hro}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                            endAdornment: <InputAdornment position="end">per/hour</InputAdornment>
                          }}
                          onChange={(e) => setEplacedata({ ...eplacedata, hro: e.target.value })}
                        />
                      </FormControl>
                      <FormControl>
                        <TextField
                          id="outlined-multiline-static"
                          label="Tax Term"
                          value={eplacedata.TaxTerm}
                          onChange={(e) => setEplacedata({ ...eplacedata, TaxTerm: e.target.value })}
                        />
                      </FormControl>
                      <FormControl>
                        <TextField
                          id="outlined-multiline-static"
                          label="Overtime Expense"
                          value={eplacedata.OvertimeExpense}
                          onChange={(e) => setEplacedata({ ...eplacedata, OvertimeExpense: e.target.value })}
                        />
                      </FormControl>
                    </>
                  ) : null}

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer sx={{ mt: -0.8 }} components={['DatePicker', 'DatePicker']}>
                      <DatePicker
                        disablePast
                        label="Tentative Start Date"
                        value={tsd}
                        onChange={(newValue) => setTsd(newValue)}
                        slotProps={{
                          textField: {
                            readOnly: true,
                          },
                        }}
                      // console.log("uncontrol date",newValue)}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                  <TextField
                    id="outlined-multiline-static"
                    label="Additional"
                    value={eplacedata.Additional}
                    onChange={(e) => setEplacedata({ ...eplacedata, Additional: e.target.value })}
                  />
                </Stack>
              )}

              <TextField
                sx={{ mt: 2 }}
                id="outlined-multiline-static"
                label="Notes"
                multiline
                value={eplacedata.placenote}
                rows={4}
                onChange={(e) => setEplacedata({ ...eplacedata, placenote: e.target.value })}
              // defaultValue="Default Value"
              />

              <Button
                type="submit"
                variant="contained"
                color="custom"
                size="small"
                sx={{ width: 230, mt: 3 }}
                onClick={() => EditPlacement()}
              >
                Update Placement
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={modalOpen} onClose={handleCloseModal} style={{ borderRadius: 10 }}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: '70%' },
          // width: { xs: '85%', sm: '60%' },
          bgcolor: 'background.paper',
          border: '3px solid #3C6BA5',
          boxShadow: 24,
          p: 3,
          borderRadius: 3,
        }}
        >
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Send Email
          </Typography>
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            {/* <Divider sx={{ mb: 2 }} /> */}
            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <TextField
                  fullWidth
                  required
                  label="To"
                  variant="outlined"
                  size="small"
                  // value={to}
                  value={recipientEmail}
                  // onChange={(e) => setTo(e.target.value)}
                  onChange={(e) => setRecipientEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={5.9}>
                <Autocomplete
                  size='small'
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setCcEmail([...newValue]);
                  }}
                  options={[{ title: '' }]}
                  getOptionLabel={(option) => option.title}
                  value={ccEmail.map((item) => item)}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({
                        inputValue,
                        title: `${inputValue}`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => <TextField {...params} label="Cc" placeholder="Cc"

                    size="small"
                  />}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1} mt={1}>





              <Grid item xs={5.9}>
                <Autocomplete
                  size='small'
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setBccEmail([...newValue]);
                  }}
                  options={[{ title: '' }]}
                  getOptionLabel={(option) => option.title}
                  value={bccEmail.map((item) => item)}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;

                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({
                        inputValue,
                        title: `${inputValue}`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => <TextField {...params} label="BCc" placeholder="BCc"

                    size="small"
                  />}
                />

              </Grid>













              <Grid item xs={5} sx={{}}>
                <FormControl variant="outlined" fullWidth size="small" >
                  <InputLabel >Select Template</InputLabel>
                  <Select
                    label="Select Template"
                    // value={formValues.resource}
                    onChange={(e) => handleTemplateSelect(e.target.value)}

                  >
                    {tempList.map((item) => (
                      <MenuItem key={item.id} value={item}>
                        {item.templateName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Typography
                // component={Button}
                // onClick={() => { navigate('/Email'),{ state: { undid:"undid" } } }}
                onClick={() => navigate('/Email', { state: { undid: "undid", bodyDis: "" } })}

                sx={{
                  color: '#23A6F0',
                  fontWeight: 'bold',
                  fontSize: '17px',
                  marginLeft: '30px',
                  marginTop: '18px',
                  cursor: 'pointer',
                }}
              >
                Edit
              </Typography>
            </Grid>
            {/* <Grid container alignItems="center" style={{ flexDirection: 'row' }}>
              <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ ml: 1, color: '#1E74B3' }}>Attachment:</Typography>
                <input type="file" onChange={FileChange} style={{ marginLeft: '9px' }} />
                
              </Grid>
            </Grid> */}

            <Grid container alignItems="center" style={{ flexDirection: 'row' }}>
              <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ ml: 1, color: '#1E74B3', whiteSpace: 'nowrap' }}>
                  Attachment:
                </Typography>
                <input
                  type="file"
                  onChange={FileChange}
                  style={{
                    marginLeft: '9px',
                    flex: 1,
                    minWidth: 0,
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={11.8}>
                <TextField
                  label='Sub'
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                />
              </Grid>
              <Grid item xs={11.8}>
                <Stack sx={{ flexDirection: 'row', gap: 1, alignItems: 'center' }}>
                  {/* <TextField
                  label='Greeting'
                  variant="outlined"
                  sx={{width:'20%'}}
                  size="small"
                  value={greeting}
                  onChange={(e) => setGreeting(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                /> */}
                  <Typography sx={{ textTransform: 'capitalize' }}>
                    {/* {greeting}, {row.fullName} */}
                    {/* {greeting ? `${greeting}, ${row.fullName}` : row.fullName} */}
                    {greeting
                      ? `${greeting} ${row?.fullName?.split(" ")[0]},`
                      : row?.fullName?.split(" ")[0]}

                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={11.8}>
                <CKEditor
                  data={emailBody}
                  config={{
                    // licenseKey: process.env.REACT_APP_TLK,
                    // toolbar: [
                    //   'heading', '|',
                    //   'bold', 'italic', 'link', '|',
                    //   'insertImage', 'undo', 'redo'
                    // ],
                    extraPlugins: [MyCustomUploadAdapterPlugin]
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    // console.log("body", data)
                    setEmailBody(data);
                  }}
                  editor={ClassicEditor}
                />
              </Grid>
            </Grid>
            <Stack sx={{ mt: 1 }}>
              <div dangerouslySetInnerHTML={{ __html: localStorage.getItem('sign') }} />
            </Stack>

            {/* <Stack flexDirection={'row'} gap={1} mt={1} sx={{ justifyContent: 'space-between', alignItems: 'center', px: 2 }}>
              <Stack sx={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                <Typography sx={{ fontSize: '1rem', fontWeight: 'bold' }}>Automailer</Typography>
                <Switch checked={checked} onChange={()=>handleChangebtn()} inputProps={{ 'aria-label': 'controlled' }} />
              </Stack>
              {checked && (<Typography sx={{ fontWeight: 'bold', color: '#2ECC71' }}>Automailer Activated !</Typography>)}
            </Stack> */}

            <Stack
              flexDirection="row"
              gap={1}
              mt={1}
              sx={{ justifyContent: 'space-between', alignItems: 'center', px: 2 }}
            >
              <FormControlLabel
                label={
                  <Typography sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
                    Automailer
                  </Typography>
                }
                control={
                  <Switch
                    checked={checked}
                    onChange={handleChangebtn}
                    inputProps={{ 'aria-label': 'automailer-switch' }}
                  />
                }
                labelPlacement="start"
                sx={{ m: 0, cursor: 'pointer' }}
              />
              {checked && (
                <Typography sx={{ fontWeight: 'bold', color: '#2ECC71' }}>
                  Automailer Activated!
                </Typography>
              )}
            </Stack>

            {/* {checked ? (
  <> */}

            {/* for Email 1 */}

            {hideEmail && (
              <Typography sx={{ ml: 7 }}>Sub: Re:{subject}</Typography>
            )}
            <Grid container spacing={1} alignItems="center">
              <Grid>
                {/* <Checkbox
                  checked={checkedEmail1 || false}
                  onChange={handleChangeEmail1}
                  inputProps={{ 'aria-label': 'controlled' }}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }}
                /> */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkedEmail1 || false}
                      onChange={handleChangeEmail1}
                      disableRipple
                      sx={{
                        padding: 0,
                        "& .MuiSvgIcon-root": { fontSize: 30 },
                      }}
                    />
                  }
                  label={null}
                  sx={{
                    ml: 2,
                    mt: 3.2,
                    mr: -0.1,
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                />

              </Grid>
              <Grid item xs={7.9}>
                <TextField
                  disabled
                  // label="Email 1"
                  label="Follow up Email 1"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  // value={sub1}
                  value={body1?.replace(/<[^>]+>/g, '')}
                  InputProps={{ style: { borderRadius: '10px' } }}
                />
              </Grid>
              {/* <Grid item xs={2}>
                <FormControl fullWidth sx={{ mt: 1 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      slotProps={{ textField: { size: 'small' } }}
                      value={time1}
                      onChange={(e) => setTime1(e)}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid> */}
              {/* <Grid item xs={2}>
                <FormControl fullWidth sx={{ mt: 1 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      ampm={false}
                      slotProps={{ textField: { size: 'small' } }}
                      value={time1}
                      onChange={(newValue) => setTime1(newValue)}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid> */}
              <Grid item xs={2}>
                <TextField
                  label="Date"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={date1}
                  onChange={(e) => setDate1(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                />
              </Grid>
              <Grid item xs="auto">
                <IconButton
                  onClick={handleModalOpen}
                  sx={{
                    color: '#1E74B3',
                    padding: '10px',
                    borderRadius: '15%',
                    width: '90px',
                    height: '35px',
                    marginTop: '7%',
                    // backgroundColor: '#1E74B3',
                    backgroundColor: '#E6F3FD',
                    // '&:hover': { backgroundColor: '#E6F3FD' }
                  }}
                >
                  <Icon icon="uil:calender" />
                </IconButton>
              </Grid>
            </Grid>

            <Modal
              open={openModal}
              onClose={handleModalClose}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Box sx={{
                width: '24%',
                height: '53%',
                overflowY: 'auto',
                backgroundColor: 'white',
                borderRadius: '10px',
                border: '2px solid #1E74B3'
              }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateCalendar
                    disablePast
                    date={dayjs(date1)}
                    onChange={handleDateSelect1}
                  />
                </LocalizationProvider>
              </Box>
            </Modal>

            {/* for Email 2 */}
            {
              hideEmail ? (
                <Stack spacing={1} sx={{ ml: 7 }}>
                  <Stack direction="row">
                    {/* <Typography>Cr- {`${new Date(emailDate).toLocaleString('en-US', optionsDate)}
${String(new Date(emailDate).getHours()).padStart(2, '0')}`}:{`${String(new Date(emailDate).getMinutes()).padStart(2, '0')}`}

      </Typography> */}


                    <Stack direction="row" spacing={1} sx={{ ml: "60%" }}>
                      <Typography sx={{ cursor: "pointer", color: '#1E74B3' }}
                        onClick={() => handleOpenEmailModal(sub1, greet1, body1, emailBody, '', '', '', "")}
                      >
                        Preview
                      </Typography>
                      <Typography sx={{ cursor: "pointer", color: '#1E74B3' }}
                        onClick={() => handleOpenEmailModal(sub1, greet1, body1, emailBody, '', '', edit, "editClickEmail1")}
                      >Edit</Typography>
                    </Stack>


                  </Stack>
                  {/* <Typography>Subject- {sub1}</Typography> */}
                </Stack>
              ) : (
                null
              )
            }

            {hideEmail && (
              <Typography sx={{ ml: 7 }}>Sub: Re:{subject}</Typography>
            )}

            <Grid container spacing={1} alignItems="center">
              <Grid>
                {/* <Checkbox
                  checked={checkedEmail2}
                  onChange={handleChangeEmail2}
                  inputProps={{ 'aria-label': 'controlled' }}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }}
                /> */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkedEmail2 || false}
                      onChange={handleChangeEmail2}
                      disableRipple
                      sx={{
                        padding: 0,
                        "& .MuiSvgIcon-root": { fontSize: 30 },
                      }}
                    />
                  }
                  label={null}
                  sx={{
                    ml: 2,
                    mt: 3.2,
                    mr: -0.1,
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                />
              </Grid>
              <Grid item xs={7.9} >
                <TextField
                  disabled
                  // label="Email 2"
                  label="Follow up Email 2"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  // value={sub2}

                  value={body2?.replace(/<[^>]+>/g, '')}
                  InputProps={{ style: { borderRadius: '10px' } }}
                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                />
              </Grid>
              {/* <Grid item xs={2}>
                <FormControl sx={{ mt: 1 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['TimePicker', 'TimePicker']}>
                      <TimePicker
                        slotProps={{ textField: { size: 'small' } }}
                        value={time2}
                        onChange={(e) => {
                          setTime2(e);
                          // setItime({ ...itime, hrs: e.$H, min: e.$m });
                          // console.log('===============time===', e.$H, ':', e.$m);
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </FormControl>
              </Grid> */}
              {/* <Grid item xs={2}>
                <FormControl fullWidth sx={{ mt: 1 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      ampm={false}
                      slotProps={{ textField: { size: 'small' } }}
                      value={time2}
                      onChange={(newValue) => setTime2(newValue)}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid> */}
              <Grid item xs={2}>

                <TextField
                  label="Date"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={date2}
                  onChange={(e) => setDate2(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                />
              </Grid>

              <Grid item xs="auto">
                <IconButton
                  onClick={handleModalOpen1}
                  sx={{
                    color: '#1E74B3',
                    padding: '10px',
                    borderRadius: '15%',
                    width: '90px',
                    height: '35px',
                    marginTop: '7%',
                    // backgroundColor: '#1E74B3',
                    backgroundColor: '#E6F3FD',
                    // '&:hover': { backgroundColor: '#E6F3FD' }
                  }}
                >
                  <Icon icon="uil:calender" />
                </IconButton>
              </Grid>

              <Modal
                open={openModal1}
                onClose={handleModalClose1}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Box sx={{
                  width: '24%',
                  height: '53%',
                  overflowY: 'auto',
                  backgroundColor: 'white',
                  borderRadius: '10px',
                  border: '2px solid #1E74B3'

                }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar
                      disablePast
                      date={dayjs(date2)}
                      onChange={handleDateSelect2}
                    />
                  </LocalizationProvider>

                </Box>
              </Modal>

            </Grid>

            {/* for Email 3 */}
            {
              hideEmail ? (
                <Stack spacing={1} sx={{ ml: 7 }}>
                  <Stack direction="row">

                    <Stack direction="row" spacing={1} sx={{ ml: "60%" }}>
                      <Typography sx={{ cursor: "pointer", color: '#1E74B3' }} onClick={() =>
                        handleOpenEmailModal(sub2, greet2, body2, emailBody, body1, '', '', "")}>Preview</Typography>
                      <Typography sx={{ cursor: "pointer", color: '#1E74B3' }}
                        onClick={() => handleOpenEmailModal(sub2, greet2, body2, emailBody, body1, '', edit, "editClickEmail2")}
                      >Edit</Typography>
                    </Stack>
                  </Stack>
                  {/* <Typography>Subject- {sub2}</Typography> */}
                </Stack>
              ) : (
                null
              )
            }

            {hideEmail && (
              <Typography sx={{ ml: 7 }}>Sub: Re:{subject}</Typography>
            )}

            <Grid container spacing={1} alignItems="center">
              <Grid>
                {/* <Checkbox
                  checked={checkedEmail3}
                  onChange={handleChangeEmail3}
                  inputProps={{ 'aria-label': 'controlled' }}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }}
                /> */}

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkedEmail3 || false}
                      onChange={handleChangeEmail3}
                      disableRipple
                      sx={{
                        padding: 0,
                        "& .MuiSvgIcon-root": { fontSize: 30 },
                      }}
                    />
                  }
                  label={null}
                  sx={{
                    ml: 2,
                    mt: 3.2,
                    mr: -0.1,
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                />
              </Grid>
              <Grid item xs={7.9}>

                <TextField
                  disabled
                  // label="Email 3"
                  label="Follow up Email 3"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  // value={sub3}

                  value={body3?.replace(/<[^>]+>/g, '')}
                  // onChange={(e) => setEmail2(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px' } }}
                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                />
              </Grid>
              {/* <Grid item xs={2}>
                <FormControl fullWidth sx={{ mt: 1 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      ampm={false}
                      slotProps={{ textField: { size: 'small' } }}
                      value={time3}
                      onChange={(newValue) => setTime3(newValue)}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid> */}
              <Grid item xs={2}>
                <TextField
                  label="Date"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={date3}
                  onChange={(e) => setDate3(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                />
              </Grid>

              <Grid item xs="auto">
                <IconButton
                  onClick={handleModalOpen2}
                  sx={{
                    color: '#1E74B3',
                    padding: '10px',
                    borderRadius: '15%',
                    width: '90px',
                    height: '35px',
                    marginTop: '7%',
                    // backgroundColor: '#1E74B3',
                    backgroundColor: '#E6F3FD',
                    // '&:hover': { backgroundColor: '#E6F3FD' }
                  }}
                >
                  <Icon icon="uil:calender" />
                </IconButton>
              </Grid>

              <Modal
                open={openModal2}
                onClose={handleModalClose2}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Box sx={{
                  width: '24%',
                  height: '53%',
                  overflowY: 'auto',
                  backgroundColor: 'white',
                  borderRadius: '10px',
                  border: '2px solid #1E74B3',

                }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar
                      disablePast
                      date={dayjs(date3)}
                      onChange={handleDateSelect3}
                    />
                  </LocalizationProvider>
                </Box>
              </Modal>

            </Grid>
            {/* for Email 3 */}

            {hideEmail ? (
              <Stack spacing={1} sx={{ ml: 7 }}>
                <Stack direction="row">

                  <Stack direction="row" spacing={1} sx={{ ml: "60%", mb: 1 }}>
                    <Typography sx={{ cursor: "pointer", color: '#1E74B3' }}
                      onClick={() => handleOpenEmailModal(sub3, greet3, body3, emailBody, body1, body2, '', '')}
                    >Preview</Typography>
                    <Typography sx={{ cursor: "pointer", color: '#1E74B3' }}
                      onClick={() => handleOpenEmailModal(sub3, greet3, body3, emailBody, body1, body2, edit, "editClickEmail3")}
                    >Edit</Typography>
                  </Stack>
                </Stack>
                {/* <Typography>Subject- {sub3}</Typography> */}
              </Stack>
            ) : (
              null
            )}

            {/* </> 
):(
  null 
)} */}
            <Stack flexDirection={'row'} gap={1} mt={1} sx={{ justifyContent: 'center' }}>
              <Button
                color="custom"
                variant="contained"
                onClick={SendEmail}
                disabled={recipientEmail === '' || subject === '' || loadingSend}
              >
                {/* Send */}
                {loadingSend ? "Sending" : 'Send'}
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>









      <Modal open={open} onClose={handleClose} style={{ borderRadius: 10 }}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: '70%' },
          // width: { xs: '85%', sm: '60%' },
          bgcolor: 'background.paper',
          border: '3px solid #3C6BA5',
          boxShadow: 24,
          p: 3,
          borderRadius: 3,
        }}
        >
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Send Email
          </Typography>
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            {/* <Divider sx={{ mb: 2 }} /> */}
            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <TextField
                  fullWidth
                  required
                  label="To"
                  variant="outlined"
                  size="small"
                  // value={to}
                  value={recipientEmail}
                  // onChange={(e) => setTo(e.target.value)}
                  onChange={(e) => setRecipientEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={5.9}>
                <Autocomplete
                  size='small'
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setCcEmail([...newValue]);
                  }}
                  options={[{ title: '' }]}
                  getOptionLabel={(option) => option.title}
                  value={ccEmail.map((item) => item)}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({
                        inputValue,
                        title: `${inputValue}`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => <TextField {...params} label="Cc" placeholder="Cc"

                    size="small"
                  />}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <Autocomplete
                  size='small'
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setBccEmail([...newValue]);
                  }}
                  options={[{ title: '' }]}
                  getOptionLabel={(option) => option.title}
                  value={bccEmail.map((item) => item)}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({
                        inputValue,
                        title: `${inputValue}`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => <TextField {...params} label="BCc" placeholder="BCc"

                    size="small"
                  />}
                />

              </Grid>

              <Grid item xs={5} sx={{}}>
                <FormControl variant="outlined" fullWidth size="small" >
                  <InputLabel >Select Template</InputLabel>
                  <Select
                    label="Select Template"
                    // value={formValues.resource}
                    onChange={(e) => handleTemplateSelect(e.target.value)}

                  >
                    {tempList.map((item) => (
                      <MenuItem key={item.id} value={item}>
                        {item.templateName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Typography
                // component={Button}
                // onClick={() => { navigate('/Email'),{ state: { undid:"undid" } } }}
                onClick={() => navigate('/Email', { state: { undid: "undid", bodyDis: "" } })}

                sx={{
                  color: '#23A6F0',
                  fontWeight: 'bold',
                  fontSize: '17px',
                  marginLeft: '30px',
                  marginTop: '18px',
                  cursor: 'pointer',
                }}
              >
                Edit
              </Typography>
            </Grid>
            {/* <Grid container alignItems="center" style={{ flexDirection: 'row' }}>
                                <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                                  <Typography sx={{ ml: 1, color: '#1E74B3' }}>Attachment:</Typography>
                                  <input type="file" onChange={FileChange} style={{ marginLeft: '9px' }} />
                                  
                                </Grid>
                              </Grid> */}

            <Grid container alignItems="center" style={{ flexDirection: 'row' }}>
              <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ ml: 1, color: '#1E74B3', whiteSpace: 'nowrap' }}>
                  Attachment:
                </Typography>
                <input
                  type="file"
                  onChange={FileChange}
                  style={{
                    marginLeft: '9px',
                    flex: 1,
                    minWidth: 0,
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={11.8}>
                <TextField
                  label='Sub'
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                />
              </Grid>
              <Grid item xs={11.8}>
                <Stack sx={{ flexDirection: 'row', gap: 1, alignItems: 'center' }}>
                  {/* <TextField
                                    label='Greeting'
                                    variant="outlined"
                                    sx={{width:'20%'}}
                                    size="small"
                                    value={greeting}
                                    onChange={(e) => setGreeting(e.target.value)}
                                    InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                                  // InputLabelProps={{ style: { marginLeft: '14px' } }}
                                  /> */}
                  <Typography sx={{ textTransform: 'capitalize' }}>
                    {/* {greeting}, {row.fullName} */}
                    {/* {greeting ? `${greeting}, ${row.fullName}` : row.fullName} */}
                    {greeting
                      ? `${greeting} ${row?.fullName?.split(" ")[0]},`
                      : row?.fullName?.split(" ")[0]}

                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={11.8}>
                <CKEditor
                  data={emailBody}
                  config={{
                    // licenseKey: process.env.REACT_APP_TLK,
                    // toolbar: [
                    //   'heading', '|',
                    //   'bold', 'italic', 'link', '|',
                    //   'insertImage', 'undo', 'redo'
                    // ],
                    extraPlugins: [MyCustomUploadAdapterPlugin]
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    // console.log("body", data)
                    setEmailBody(data);
                  }}
                  editor={ClassicEditor}
                />
              </Grid>
            </Grid>
            <Stack sx={{ mt: 1 }}>
              <div dangerouslySetInnerHTML={{ __html: localStorage.getItem('sign') }} />
            </Stack>

            {/* <Stack flexDirection={'row'} gap={1} mt={1} sx={{ justifyContent: 'space-between', alignItems: 'center', px: 2 }}>
                                <Stack sx={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                  <Typography sx={{ fontSize: '1rem', fontWeight: 'bold' }}>Automailer</Typography>
                                  <Switch checked={checked} onChange={()=>handleChangebtn()} inputProps={{ 'aria-label': 'controlled' }} />
                                </Stack>
                                {checked && (<Typography sx={{ fontWeight: 'bold', color: '#2ECC71' }}>Automailer Activated !</Typography>)}
                              </Stack> */}

            <Stack
              flexDirection="row"
              gap={1}
              mt={1}
              sx={{ justifyContent: 'space-between', alignItems: 'center', px: 2 }}
            >
              <FormControlLabel
                label={
                  <Typography sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
                    Automailer
                  </Typography>
                }
                control={
                  <Switch
                    checked={checked}
                    onChange={handleChangebtn}
                    inputProps={{ 'aria-label': 'automailer-switch' }}
                  />
                }
                labelPlacement="start"
                sx={{ m: 0, cursor: 'pointer' }}
              />
              {checked && (
                <Typography sx={{ fontWeight: 'bold', color: '#2ECC71' }}>
                  Automailer Activated!
                </Typography>
              )}
            </Stack>

            {/* {checked ? (
                    <> */}

            {/* for Email 1 */}

            {hideEmail && (
              <Typography sx={{ ml: 7 }}>Sub: Re:{subject}</Typography>
            )}
            <Grid container spacing={1} alignItems="center">
              <Grid>
                {/* <Checkbox
                                    checked={checkedEmail1 || false}
                                    onChange={handleChangeEmail1}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }}
                                  /> */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkedEmail1 || false}
                      onChange={handleChangeEmail1}
                      disableRipple
                      sx={{
                        padding: 0,
                        "& .MuiSvgIcon-root": { fontSize: 30 },
                      }}
                    />
                  }
                  label={null}
                  sx={{
                    ml: 2,
                    mt: 3.2,
                    mr: -0.1,
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                />

              </Grid>
              <Grid item xs={7.9}>
                <TextField
                  disabled
                  // label="Email 1"
                  label="Follow up Email 1"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  // value={sub1}
                  value={body1?.replace(/<[^>]+>/g, '')}
                  InputProps={{ style: { borderRadius: '10px' } }}
                />
              </Grid>
              {/* <Grid item xs={2}>
                                  <FormControl fullWidth sx={{ mt: 1 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <TimePicker
                                        slotProps={{ textField: { size: 'small' } }}
                                        value={time1}
                                        onChange={(e) => setTime1(e)}
                                      />
                                    </LocalizationProvider>
                                  </FormControl>
                                </Grid> */}
              {/* <Grid item xs={2}>
                                  <FormControl fullWidth sx={{ mt: 1 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <TimePicker
                                        ampm={false}
                                        slotProps={{ textField: { size: 'small' } }}
                                        value={time1}
                                        onChange={(newValue) => setTime1(newValue)}
                                      />
                                    </LocalizationProvider>
                                  </FormControl>
                                </Grid> */}
              <Grid item xs={2}>
                <TextField
                  label="Date"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={date1}
                  onChange={(e) => setDate1(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                />
              </Grid>
              <Grid item xs="auto">
                <IconButton
                  onClick={handleModalOpen}
                  sx={{
                    color: '#1E74B3',
                    padding: '10px',
                    borderRadius: '15%',
                    width: '90px',
                    height: '35px',
                    marginTop: '7%',
                    // backgroundColor: '#1E74B3',
                    backgroundColor: '#E6F3FD',
                    // '&:hover': { backgroundColor: '#E6F3FD' }
                  }}
                >
                  <Icon icon="uil:calender" />
                </IconButton>
              </Grid>
            </Grid>

            <Modal
              open={openModal}
              onClose={handleModalClose}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Box sx={{
                width: '24%',
                height: '53%',
                overflowY: 'auto',
                backgroundColor: 'white',
                borderRadius: '10px',
                border: '2px solid #1E74B3'
              }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateCalendar
                    disablePast
                    date={dayjs(date1)}
                    onChange={handleDateSelect1}
                  />
                </LocalizationProvider>
              </Box>
            </Modal>

            {/* for Email 2 */}
            {
              hideEmail ? (
                <Stack spacing={1} sx={{ ml: 7 }}>
                  <Stack direction="row">
                    {/* <Typography>Cr- {`${new Date(emailDate).toLocaleString('en-US', optionsDate)}
                  ${String(new Date(emailDate).getHours()).padStart(2, '0')}`}:{`${String(new Date(emailDate).getMinutes()).padStart(2, '0')}`}
                  
                        </Typography> */}
                    <Stack direction="row" spacing={1} sx={{ ml: "60%" }}>
                      <Typography sx={{ cursor: "pointer", color: '#1E74B3' }}
                        onClick={() => handleOpenEmailModal(sub1, greet1, body1, emailBody, '', '', '', "")}
                      >
                        Preview
                      </Typography>
                      <Typography sx={{ cursor: "pointer", color: '#1E74B3' }}
                        onClick={() => handleOpenEmailModal(sub1, greet1, body1, emailBody, '', '', edit, "editClickEmail1")}
                      >Edit</Typography>
                    </Stack>
                  </Stack>
                  {/* <Typography>Subject- {sub1}</Typography> */}
                </Stack>
              ) : (
                null
              )
            }

            {hideEmail && (
              <Typography sx={{ ml: 7 }}>Sub: Re:{subject}</Typography>
            )}

            <Grid container spacing={1} alignItems="center">
              <Grid>
                {/* <Checkbox
                                    checked={checkedEmail2}
                                    onChange={handleChangeEmail2}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }}
                                  /> */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkedEmail2 || false}
                      onChange={handleChangeEmail2}
                      disableRipple
                      sx={{
                        padding: 0,
                        "& .MuiSvgIcon-root": { fontSize: 30 },
                      }}
                    />
                  }
                  label={null}
                  sx={{
                    ml: 2,
                    mt: 3.2,
                    mr: -0.1,
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                />
              </Grid>
              <Grid item xs={7.9} >
                <TextField
                  disabled
                  // label="Email 2"
                  label="Follow up Email 2"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  // value={sub2}

                  value={body2?.replace(/<[^>]+>/g, '')}
                  InputProps={{ style: { borderRadius: '10px' } }}
                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                />
              </Grid>
              {/* <Grid item xs={2}>
                                  <FormControl sx={{ mt: 1 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <DemoContainer components={['TimePicker', 'TimePicker']}>
                                        <TimePicker
                                          slotProps={{ textField: { size: 'small' } }}
                                          value={time2}
                                          onChange={(e) => {
                                            setTime2(e);
                                            // setItime({ ...itime, hrs: e.$H, min: e.$m });
                                            // console.log('===============time===', e.$H, ':', e.$m);
                                          }}
                                        />
                                      </DemoContainer>
                                    </LocalizationProvider>
                                  </FormControl>
                                </Grid> */}
              {/* <Grid item xs={2}>
                                  <FormControl fullWidth sx={{ mt: 1 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <TimePicker
                                        ampm={false}
                                        slotProps={{ textField: { size: 'small' } }}
                                        value={time2}
                                        onChange={(newValue) => setTime2(newValue)}
                                      />
                                    </LocalizationProvider>
                                  </FormControl>
                                </Grid> */}
              <Grid item xs={2}>

                <TextField
                  label="Date"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={date2}
                  onChange={(e) => setDate2(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                />
              </Grid>

              <Grid item xs="auto">
                <IconButton
                  onClick={handleModalOpen1}
                  sx={{
                    color: '#1E74B3',
                    padding: '10px',
                    borderRadius: '15%',
                    width: '90px',
                    height: '35px',
                    marginTop: '7%',
                    // backgroundColor: '#1E74B3',
                    backgroundColor: '#E6F3FD',
                    // '&:hover': { backgroundColor: '#E6F3FD' }
                  }}
                >
                  <Icon icon="uil:calender" />
                </IconButton>
              </Grid>

              <Modal
                open={openModal1}
                onClose={handleModalClose1}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Box sx={{
                  width: '24%',
                  height: '53%',
                  overflowY: 'auto',
                  backgroundColor: 'white',
                  borderRadius: '10px',
                  border: '2px solid #1E74B3'

                }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar
                      disablePast
                      date={dayjs(date2)}
                      onChange={handleDateSelect2}
                    />
                  </LocalizationProvider>

                </Box>
              </Modal>

            </Grid>

            {/* for Email 3 */}
            {
              hideEmail ? (
                <Stack spacing={1} sx={{ ml: 7 }}>
                  <Stack direction="row">

                    <Stack direction="row" spacing={1} sx={{ ml: "60%" }}>
                      <Typography sx={{ cursor: "pointer", color: '#1E74B3' }} onClick={() =>
                        handleOpenEmailModal(sub2, greet2, body2, emailBody, body1, '', '', "")}>Preview</Typography>
                      <Typography sx={{ cursor: "pointer", color: '#1E74B3' }}
                        onClick={() => handleOpenEmailModal(sub2, greet2, body2, emailBody, body1, '', edit, "editClickEmail2")}
                      >Edit</Typography>
                    </Stack>
                  </Stack>
                  {/* <Typography>Subject- {sub2}</Typography> */}
                </Stack>
              ) : (
                null
              )
            }

            {hideEmail && (
              <Typography sx={{ ml: 7 }}>Sub: Re:{subject}</Typography>
            )}

            <Grid container spacing={1} alignItems="center">
              <Grid>
                {/* <Checkbox
                                    checked={checkedEmail3}
                                    onChange={handleChangeEmail3}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }}
                                  /> */}

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkedEmail3 || false}
                      onChange={handleChangeEmail3}
                      disableRipple
                      sx={{
                        padding: 0,
                        "& .MuiSvgIcon-root": { fontSize: 30 },
                      }}
                    />
                  }
                  label={null}
                  sx={{
                    ml: 2,
                    mt: 3.2,
                    mr: -0.1,
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                />
              </Grid>
              <Grid item xs={7.9}>

                <TextField
                  disabled
                  // label="Email 3"
                  label="Follow up Email 3"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  // value={sub3}

                  value={body3?.replace(/<[^>]+>/g, '')}
                  // onChange={(e) => setEmail2(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px' } }}
                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                />
              </Grid>
              {/* <Grid item xs={2}>
                                  <FormControl fullWidth sx={{ mt: 1 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <TimePicker
                                        ampm={false}
                                        slotProps={{ textField: { size: 'small' } }}
                                        value={time3}
                                        onChange={(newValue) => setTime3(newValue)}
                                      />
                                    </LocalizationProvider>
                                  </FormControl>
                                </Grid> */}
              <Grid item xs={2}>
                <TextField
                  label="Date"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={date3}
                  onChange={(e) => setDate3(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                // InputLabelProps={{ style: { marginLeft: '14px' } }}
                />
              </Grid>

              <Grid item xs="auto">
                <IconButton
                  onClick={handleModalOpen2}
                  sx={{
                    color: '#1E74B3',
                    padding: '10px',
                    borderRadius: '15%',
                    width: '90px',
                    height: '35px',
                    marginTop: '7%',
                    // backgroundColor: '#1E74B3',
                    backgroundColor: '#E6F3FD',
                    // '&:hover': { backgroundColor: '#E6F3FD' }
                  }}
                >
                  <Icon icon="uil:calender" />
                </IconButton>
              </Grid>

              <Modal
                open={openModal2}
                onClose={handleModalClose2}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Box sx={{
                  width: '24%',
                  height: '53%',
                  overflowY: 'auto',
                  backgroundColor: 'white',
                  borderRadius: '10px',
                  border: '2px solid #1E74B3',

                }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar
                      disablePast
                      date={dayjs(date3)}
                      onChange={handleDateSelect3}
                    />
                  </LocalizationProvider>
                </Box>
              </Modal>

            </Grid>
            {/* for Email 3 */}

            {hideEmail ? (
              <Stack spacing={1} sx={{ ml: 7 }}>
                <Stack direction="row">

                  <Stack direction="row" spacing={1} sx={{ ml: "60%", mb: 1 }}>
                    <Typography sx={{ cursor: "pointer", color: '#1E74B3' }}
                      onClick={() => handleOpenEmailModal(sub3, greet3, body3, emailBody, body1, body2, '', '')}
                    >Preview</Typography>
                    <Typography sx={{ cursor: "pointer", color: '#1E74B3' }}
                      onClick={() => handleOpenEmailModal(sub3, greet3, body3, emailBody, body1, body2, edit, "editClickEmail3")}
                    >Edit</Typography>
                  </Stack>
                </Stack>
                {/* <Typography>Subject- {sub3}</Typography> */}
              </Stack>
            ) : (
              null
            )}

            {/* </> 
                  ):(
                    null 
                  )} */}
            <Stack flexDirection={'row'} gap={1} mt={1} sx={{ justifyContent: 'center' }}>
              <Button
                color="custom"
                variant="contained"
                onClick={SendEmail}
                disabled={recipientEmail === '' || subject === '' || loadingSend}
              >
                {/* Send */}
                {loadingSend ? "Sending" : 'Send'}
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>









      <Modal open={emailModalOpen} onClose={handleCloseEmailModal}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '95%', sm: '60%', md: '60%' },
            border: '3px solid #3C6BA5',
            // maxHeight: '80vh',   
            // overflowY: 'auto',  
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
            bgcolor: 'background.paper',
          }}
        >
          <Typography variant="h6" color="#3C6BA5" textAlign="center">
            Email
          </Typography>
          <Divider sx={{ mb: 1 }} />

          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>

            <Typography variant="h6" sx={{ mt: 2.2, mb: 1 }}>
              {emailData.sub}
            </Typography>
            <p style={{ textTransform: 'capitalize' }}>
              {emailData.greet ? `${emailData.greet} ${row?.fullName?.split(" ")[0]},` : row?.fullName?.split(" ")[0]}
            </p>


            {editBody === false ? (
              <Grid item xs={11.8}>
                <CKEditor
                  data={emailData.body}
                  config={{
                    licenseKey: process.env.REACT_APP_TLK,
                    extraPlugins: [MyCustomUploadAdapterPlugin],
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    // setBody1(data);
                    setCommonBody(data)
                  }}
                  editor={ClassicEditor}
                />
              </Grid>
            ) : (
              <>
                <div dangerouslySetInnerHTML={{ __html: emailData.body }} />

                {editBody !== false ? (
                  <Stack sx={{ mt: 1.5 }}>

                    <div dangerouslySetInnerHTML={{ __html: localStorage.getItem('sign') }} />
                  </Stack>
                ) : (
                  null
                )
                }

                {emailData.followUp2Rep && (
                  <>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ width: '98%', mt: 2 }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ color: '#1E74B3', fontSize: '0.8rem' }}
                      >
                        {/* {"Mon, Sep 8, 11:59 AM"} */}
                        {/* {"On 09/03/2025 3:07 AM IST Naveen Kumar <info@foxconsultings.com> wrote:"} */}

                        {/* {`On ${date3
                          ? dayjs(date3).format("MM/DD/YYYY")
                          : dayjs().format("MM/DD/YYYY")
                          } ${time3
                            ? time3.format("hh:mm A")
                            : dayjs().format("hh:mm A")
                          } IST `} */}

                        {`On ${date3
                          ? dayjs(date3).format("MM/DD/YYYY")
                          : dayjs().format("MM/DD/YYYY")
                          } ${"10:00 AM"
                          } ${localStorage.getItem("timeZone")} `}


                        {row?.fullName
                          ?.split(" ")
                          ?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())
                          .join(" ")} {`<${row?.email}>`} wrote:

                        {/* {`On ${new Date().toLocaleDateString('en-US',
                          { year: 'numeric', month: '2-digit', day: '2-digit' })}
   ${new Date().toLocaleString('en-US',
                            { hour: 'numeric', minute: '2-digit', hour12: true })} IST `}
                        {row?.fullName
                          ?.split(" ")
                          ?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())
                          .join(" ")} {`<${row?.email}>`} wrote: */}

                      </Typography>
                      {/* <Iconify
                        icon="material-symbols:reply-rounded"
                        sx={{
                          cursor: 'pointer',
                          color: 'text.secondary',
                          fontSize: '2rem',
                          fontWeight: 650,
                        }}
                      /> */}
                    </Stack>
                    {/* <Typography variant="h6" sx={{ mt: 1, mb: 1 }}>
      {emailData.sub}
    </Typography> */}
                    <p style={{ textTransform: 'capitalize' }}>
                      {emailData.greet ? `${emailData.greet} ${row?.fullName?.split(" ")[0]},` : row.fullName?.split(" ")[0]}
                    </p>
                    <div dangerouslySetInnerHTML={{ __html: emailData.followUp2Rep }} />

                    <Stack sx={{ mt: 1.5 }}>

                      <div dangerouslySetInnerHTML={{ __html: localStorage.getItem('sign') }} />
                    </Stack>
                  </>
                )}

                {/* {editBody !== false ? (
              <Stack sx={{ mt: 1.5 }}>

                <div dangerouslySetInnerHTML={{ __html: localStorage.getItem('sign') }} />
              </Stack>
            ) : (
              null
            )
            } */}

                {emailData.followUp1Rep && (
                  <>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ width: '98%', mt: 2 }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ color: '#1E74B3', fontSize: '0.8rem' }}
                      >

                        {/* {"On 09/03/2025 3:07 AM IST Naveen Kumar <info@foxconsultings.com> wrote:"} */}

                        {/* {`On ${date2
                          ? dayjs(date2).format("MM/DD/YYYY")
                          : dayjs().format("MM/DD/YYYY")
                          } ${time2
                            ? time2.format("hh:mm A")
                            : dayjs().format("hh:mm A")
                          } IST `} */}

                        {`On ${date2 ? dayjs(date2).format("MM/DD/YYYY") : dayjs().format("MM/DD/YYYY")
                          } ${"10:00 AM"
                          } ${localStorage.getItem("timeZone")} `}

                        {row?.fullName
                          ?.split(" ")
                          ?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())
                          .join(" ")} {`<${row?.email}>`} wrote:

                      </Typography>

                      {/* <Iconify
                        icon="material-symbols:reply-rounded"
                        sx={{
                          cursor: 'pointer',
                          color: 'text.secondary',
                          fontSize: '2rem',
                          fontWeight: 650,
                        }}
                      /> */}
                    </Stack>
                    {/* <Typography variant="h6" sx={{ mt: 1, mb: 1 }}>
      {emailData.sub}
    </Typography> */}
                    <p style={{ textTransform: 'capitalize' }}>
                      {emailData.greet ? `${emailData.greet} ${row.fullName?.split(" ")[0]},` : row.fullName?.split(" ")[0]}
                    </p>
                    <div dangerouslySetInnerHTML={{ __html: emailData.followUp1Rep }} />
                    <Stack sx={{ mt: 1.5 }}>

                      <div dangerouslySetInnerHTML={{ __html: localStorage.getItem('sign') }} />
                    </Stack>
                  </>
                )}

                {/* {editBody !== false ? (
              <Stack sx={{ mt: 1.5 }}>

                <div dangerouslySetInnerHTML={{ __html: localStorage.getItem('sign') }} />
              </Stack>
            ) : (
              null
            )
            } */}
                {emailData.emailRep && (
                  <>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{ width: '98%', mt: 2 }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ color: '#1E74B3', fontSize: '0.8rem' }}
                      >
                        {/* {"Mon, Sep 10, 02:30 PM"} */}
                        {/* {"On 09/03/2025 3:07 AM IST Naveen Kumar <info@foxconsultings.com> wrote:"} */}
                        {/* {`On ${date1
                          ? dayjs(date1).format("MM/DD/YYYY")
                          : dayjs().format("MM/DD/YYYY")
                          } ${
                            time1
                            ? time1.format("hh:mm A")
                            : dayjs().format("hh:mm A")
                          } IST `} */}

                        {`On ${date1
                          ? dayjs(date1).format("MM/DD/YYYY")
                          : dayjs().format("MM/DD/YYYY")
                          } ${time1
                            ? new Intl.DateTimeFormat("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                              timeZone: localStorage.getItem("timeZone"),
                            }).format(new Date(time1))
                            : new Intl.DateTimeFormat("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                              timeZone: localStorage.getItem("timeZone"),
                            }).format(new Date())
                          } ${localStorage.getItem("timeZone")} `}

                        {/* {`On ${ 
  date1
    ? dayjs(date1).format("MM/DD/YYYY")
    : dayjs().format("MM/DD/YYYY")
} ${
   "10:00 AM"
} ${localStorage.getItem("timeZone") || "IST"} `} */}

                        {row?.fullName
                          ?.split(" ")
                          ?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())
                          .join(" ")} {`<${row?.email}>`} wrote:
                      </Typography>

                      {/* <Iconify 
                        icon="material-symbols:reply-rounded"
                        sx={{
                          cursor: 'pointer',
                          color: 'text.secondary',
                          fontSize: '2rem',
                          fontWeight: 650, 
                        }}
                      /> */}
                    </Stack>
                    {/* <Typography variant="h6" sx={{ mt: 1, mb: 1 }}>
      {emailData.sub}
    </Typography> */}
                    <p style={{ textTransform: 'capitalize' }}>
                      {emailData.greet ? `${emailData.greet} ${row.fullName?.split(" ")[0]},` : row.fullName?.split(" ")[0]}
                    </p>
                    <div dangerouslySetInnerHTML={{ __html: emailData.emailRep }} />
                  </>
                )}

                {/* {editBody !== false ? (
              <Stack sx={{ mt: 1.5 }}>

                <div dangerouslySetInnerHTML={{ __html: localStorage.getItem('sign') }} />
              </Stack>
            ) : (
              null
            )
            } */}
              </>
            )}

            {editBody !== false ? (
              <Stack sx={{ mt: 1.5 }}>

                <div dangerouslySetInnerHTML={{ __html: localStorage.getItem('sign') }} />
              </Stack>
            ) : (
              null
            )
            }

            <Stack
              flexDirection={{ xs: 'column', md: 'row' }}
              gap={2}
              mt={2}
              alignItems="center"
              justifyContent="center"
            >
              {editBody === false && (
                <Button color="custom" variant="contained" onClick={() => saveLocallyBody()}>
                  Save
                </Button>
              )}
              <Button
                color="custom"
                variant="contained"
                onClick={handleCloseEmailModal}
              >
                Close
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>























      {/* 
      <Modal open={emailModalOpen2} onClose={handleEmailModalClose2}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 700,
             height: "60vh",   
            bgcolor: "white",
            borderRadius: 3,
            p: 3,
            boxShadow: 24,
            border: "2px solid #3C6BA5",
          }}
        >
        
          <Box
            sx={{
              display: "flex",
              justifyContent: "center", 
        
              alignItems: "center",
              position: "relative",
              mb: 2,
            }}
          >
        
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                color: "#3C6BA5",
                textAlign: "center",
              }}
            >
              Scheduled Emails
            </Typography>

          
           




            <Button sx={{
              position: "absolute",
              right: 0
            }} color="custom" variant="contained" onClick={emailDeleteAllOpenModal} >
              Delete All
            </Button>

          </Box>

          <hr />

        

                   <Scrollbar>


                       {emails2.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 3,
                mb: 1,
                gap: 2,
                width: "100%",
              }}
            >
           
              <Box
                sx={{
                  border: "2px solid #3C6BA5",
                  borderRadius: 1,
                  padding: "6px 12px",
                  width: 150,
                  height:34,
                  fontWeight: 600,
                  textAlign: "center",
                }}
              >
                {moment(item.date).format("MMM D, YYYY")}
              
              </Box>

          
              <Box sx={{ position: "relative", width: "100%" }}>
                <TextField
             

                  value={`sub:re: ${item.subject}`}
                  size="small"
                  fullWidth
                  sx={{ borderRadius: "8px" }}
                />

                <Box
                  sx={{
                    position: "absolute",
                    right: 10,
                    bottom: -28,
                    display: "flex",
                    gap: 3,
                  }}
                >
                 

                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#3C6BA5",
                      cursor: "pointer",
                    }}
                    onClick={() => openAndLoad(item)}
                  >
                    Edit
                  </Typography>
                </Box>
              </Box>

          
              <Box
                sx={{
                  backgroundColor: "white",
                  p: "6px",
                  borderRadius: "1px",
                  //   boxShadow: "1px 8px 18px rgba(0, 200, 0, 0.18), -1px 8px 18px rgba(0, 200, 0, 0.18)",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked
                      onChange={() =>
                        handleSwitchChange({
                          scheduleId: item.scheduleId,
                          emailOrder: item.emailOrder,
                        })
                      }
                      inputProps={{ "aria-label": "automailer-switch" }}
                    />
                  }
                  labelPlacement="start"
                  sx={{ m: 0, cursor: "pointer" }}
                />
              </Box>
            </Box>
          ))}

                   </Scrollbar>
       
        </Box>
      </Modal> */}



      <Modal open={emailModalOpen2} onClose={handleEmailModalClose2}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",

            // RESPONSIVE WIDTH
            width: {
              xs: "95%",    // mobile
              sm: "90%",
              md: 700,      // desktop
            },

            //  FIXED HEIGHT (no overflow outside screen)
            height: {
              xs: "90vh",   // mobile
              sm: "70vh",
            },

            bgcolor: "white",
            borderRadius: 3,
            p: 2,
            boxShadow: 24,
            border: "2px solid #3C6BA5",

            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* ================= HEADER (STATIC) ================= */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              mb: 1,
              flexShrink: 0, //  never shrink
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: "#3C6BA5",
                textAlign: "center",
              }}
            >
              Scheduled Emails
            </Typography>

            <Button
              sx={{ position: "absolute", right: 0 }}
              color="custom"
              variant="contained"
              onClick={emailDeleteAllOpenModal}
              size="small"
            >
              Delete All
            </Button>
          </Box>

          <hr />

          {/* ================= SCROLLABLE CONTENT ================= */}
          <Box
            sx={{
              flex: 1,                 // takes remaining height
              overflowY: "auto",       //  FIX bottom overflow
              mt: 1,
              pr: 1,
            }}
          >
            {emails2.map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  mb: 3,
                  width: "100%",
                  flexWrap: "wrap",
                }}
              >
                {/* DATE */}
                <Box
                  sx={{
                    border: "2px solid #3C6BA5",
                    borderRadius: 1,
                    width: 140,
                    height: 40,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                >
                  {moment(item.date).format("MMM D, YYYY")}
                </Box>

                {/* SUBJECT */}
                <Box

                  sx={{
                    position: "relative",
                    flex: 1,
                    minWidth: 200,

                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#3C6BA5",   // normal
                      },
                      "&:hover fieldset": {
                        borderColor: "#3C6BA5",   // hover
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#3C6BA5",   // focus
                      },
                    },
                  }}



                >
                  <TextField
                    value={`sub:re: ${item.subject}`}
                    size="small"
                    sx={{ color: "#3C6BA5", borderRadius: '2px solid #3C6BA5' }}
                    fullWidth



                  />

                  <Typography
                    sx={{
                      position: "absolute",
                      right: 10,
                      bottom: -22,
                      fontSize: "14px",
                      color: "#3C6BA5",
                      cursor: "pointer",
                    }}
                    onClick={() => openAndLoad(item)}
                  >
                    Edit
                  </Typography>
                </Box>

                {/* SWITCH */}
                <FormControlLabel
                  control={
                    <Switch
                      checked
                      onChange={() =>
                        handleSwitchChange({
                          scheduleId: item.scheduleId,
                          emailOrder: item.emailOrder,
                        })
                      }
                    />
                  }
                  sx={{ m: 0 }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Modal>




































      <Modal open={openy} onClose={() => setOpeny(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95%", sm: "60%" },
            bgcolor: "white",
            borderRadius: 3,
            border: "3px solid #2977ff",
            boxShadow: 24,
            p: 3,
          }}
        >
          <Typography variant="h6" color="#3C6BA5" textAlign="center">
            Email
          </Typography>

          <Divider sx={{ my: 2 }} />

          {/* SUBJECT */}
          <Typography variant="h6">
            {emaily?.subject}
          </Typography>

          {/* BODY (Always editable) */}
          <CKEditor
            editor={ClassicEditor}
            data={body}
            onChange={(event, editor) => setBody(editor.getData())}
          />

          {/* BUTTONS */}
          <Stack
            flexDirection="row"
            gap={2}
            mt={3}
            alignItems="center"
            justifyContent="center"
          >
            {/* <Button variant="contained" color="success" onClick={handleSave}>
        Save
      </Button>

      <Button variant="contained" color="error" onClick={() => setOpeny(false)}>
        Close
      </Button> */}

            <Button
              variant="contained"
              onClick={handleSave}
              sx={{
                backgroundColor: "#3C6BA5",
              }}
            >
              Save
            </Button>

            <Button
              variant="contained"
              onClick={() => setOpeny(false)}
              sx={{
                backgroundColor: "#3C6BA5",
              }}
            >
              Close
            </Button>



          </Stack>
        </Box>
      </Modal>











      {/* <Modal
        open={confirmOpen}
        onClose={handleConfirmNo}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
          }}
        >
          <Typography variant="h6" sx={{ mb: 2, color: "#3C6BA5", }}>
            Delete Email?
          </Typography>

          <Typography sx={{ mb: 3, color: "#3C6BA5", }}>
            Do you want to delete this email?”
          </Typography>

          <Box sx={{ textAlign: "right" }}>
            <Button onClick={handleConfirmNo} sx={{ mr: 1 }}>
              No
            </Button>

            <Button color="error" onClick={handleConfirmYes}>
              Yes, Delete
            </Button>
          </Box>
        </Box>
      </Modal> */}






    </>
  );
}





//                      <Modal open={openy} onClose={() => setOpeny(false)}>
// <Box
//   sx={{
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: { xs: "95%", sm: "60%" },
//     bgcolor: "white",
//     borderRadius: 3,
//     border: "3px solid #3C6BA5",
//     boxShadow: 24,
//     p: 3,
//   }}
// >
//   <Typography variant="h6" color="#3C6BA5" textAlign="center">
//     Email
//   </Typography>

//   <Divider sx={{ my: 2 }} />

//   {/* SUBJECT */}
//   <Typography variant="h6">
//     {email?.subject}
//   </Typography>

//   {/* BODY */}
//   {!editMode ? (
//     <div
//       style={{ marginTop: 15 }}
//       dangerouslySetInnerHTML={{ __html: body }}
//     />
//   ) : (
//     <CKEditor
//       editor={ClassicEditor}
//       data={body}
//       onChange={(event, editor) => setBody(editor.getData())}
//     />
//   )}

//   {/* BUTTONS */}
//   <Stack
//     flexDirection="row"
//     gap={2}
//     mt={3}
//     alignItems="center"
//     justifyContent="center"
//   >
//     {!editMode ? (
//       <Button variant="contained" color="primary" onClick={() => setEditMode(true)}>
//         Edit
//       </Button>
//     ) : (
//       <Button variant="contained" color="success" onClick={handleSave}>
//         Save
//       </Button>
//     )}

//     <Button variant="contained" color="error" onClick={() => setOpen(false)}>
//       Close
//     </Button>
//   </Stack>
// </Box>
//                       </Modal>













//                      <Modal open={openy} onClose={() => setOpeny(false)}>
// <Box
//   sx={{
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: { xs: "95%", sm: "60%" },
//     bgcolor: "white",
//     borderRadius: 3,
//     border: "3px solid #3C6BA5",
//     boxShadow: 24,
//     p: 3,
//   }}
// >
//   <Typography variant="h6" color="#3C6BA5" textAlign="center">
//     Email
//   </Typography>

//   <Divider sx={{ my: 2 }} />

//   {/* SUBJECT */}
//   <Typography variant="h6">
//     {email?.subject}
//   </Typography>

//   {/* BODY */}
//   {!editMode ? (
//     <div
//       style={{ marginTop: 15 }}
//       dangerouslySetInnerHTML={{ __html: body }}
//     />
//   ) : (
//     <CKEditor
//       editor={ClassicEditor}
//       data={body}
//       onChange={(event, editor) => setBody(editor.getData())}
//     />
//   )}

//   {/* BUTTONS */}
//   <Stack
//     flexDirection="row"
//     gap={2}
//     mt={3}
//     alignItems="center"
//     justifyContent="center"
//   >
//     {!editMode ? (
//       <Button variant="contained" color="primary" onClick={() => setEditMode(true)}>
//         Edit
//       </Button>
//     ) : (
//       <Button variant="contained" color="success" onClick={handleSave}>
//         Save
//       </Button>
//     )}

//     <Button variant="contained" color="error" onClick={() => setOpen(false)}>
//       Close
//     </Button>
//   </Stack>
// </Box>
//                       </Modal>






















//        <Modal open={emailModalOpen2} onClose={handleEmailModalClose2}>
// <Box
//   sx={{
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: 700,
//     bgcolor: "white",
//     borderRadius: 3,
//     p: 3,
//     boxShadow: 24,
//     border: "2px solid #3C6BA5",
//   }}
// >
//   {/* HEADER */}
//   <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
//     <Typography
//       variant="h5"
//       sx={{
//         fontWeight: 600,
//         color: "#3C6BA5",
//         textAlign: "center",
//         flex: 1,
//       }}
//     >
//       Scheduled Emails
//     </Typography>

//     <Button
//       variant="contained"
//       sx={{
//         background: "#3C6BA5",
//         borderRadius: "8px",
//         height: 38,
//         textTransform: "none",
//         ":hover": { background: "#3C6BA5" },
//       }}
//       onClick={emailDeleteAllOpenModal}
//     >
//       Delete All
//     </Button>
//   </Box>

//   <hr />

//   {/* EMAIL LIST */}





//   {emails2.map((item, index) => (
//     <Box
//       key={index}
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         mt: 3,
//         mb: 4, // ⭐ Extra space added under each row
//         gap: 2,
//         position: "relative",
//         width: "100%",
//       }}
//     >
//       {/* DATE */}
//       <Box
//         sx={{
//           border: "2px solid #3C6BA5",
//           borderRadius: 2,
//           padding: "6px 12px",
//           width: 130,
//           fontWeight: 600,
//           textAlign: "center",
//         }}
//       >
//         {item.date}
//       </Box>

//       {/* SUBJECT FIELD */}
//       <Box sx={{ position: "relative", width: "100%" }}>
//         <TextField
//           value={item.subject}
//           size="small"
//           fullWidth
//           sx={{
//             borderRadius: "8px",
//           }}
//         />

//         {/* PREVIEW + EDIT - FIXED SPACING */}
//         <Box
//           sx={{
//             position: "absolute",
//             right: 10,
//             bottom: -28, // ⭐ More bottom space for clean alignment
//             display: "flex",
//             gap: 3, // little more gap
//           }}
//         >
//           <Typography
//             sx={{
//               fontSize: "14px",
//               color: "#3C6BA5",
//               cursor: "pointer",
//             }}
//             onClick={() => handleOpenModal(selectedCandidateId)}
//           >
//             Preview
//           </Typography>

//           <Typography
//             sx={{
//               fontSize: "14px",
//               color: "#3C6BA5",
//               cursor: "pointer",
//             }}
//             onClick={() => handleOpenModal(selectedCandidateId)}
//           >
//             Edit
//           </Typography>
//         </Box>
//       </Box>

//       {/* SWITCH */}
//       <Switch
//         checked
//         onChange={() =>
//           handleSwitchChange({
//             scheduleId: item.scheduleId,
//             emailOrder: item.emailOrder,
//           })
//         }
//       />
//     </Box>
//   ))}







// </Box>
//        </Modal>













//        <Modal open={emailModalOpen2} onClose={handleEmailModalClose2}>
// <Box
//   sx={{
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: 700,
//     bgcolor: "white",
//     borderRadius: 3,
//     p: 3,
//     boxShadow: 24,
//     border: "2px solid #3C6BA5",
//   }}
// >
//   {/* HEADER */}
//   <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
//     <Typography
//       variant="h5"
//       sx={{
//         fontWeight: 600,
//         color: "#3C6BA5",
//         textAlign: "center",
//         flex: 1,
//       }}
//     >
//       Scheduled Emails
//     </Typography>

//     <Button
//       variant="contained"
//       sx={{
//         background: "#3C6BA5",
//         borderRadius: "8px",
//         height: 38,
//         textTransform: "none",
//         ":hover": { background: "#3C6BA5" },
//       }}
//       onClick={emailDeleteAllOpenModal}
//     >
//       Delete All
//     </Button>
//   </Box>

//   <hr />

//   {/* EMAIL LIST */}





//   {emails2.map((item, index) => (
//     <Box
//       key={index}
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         mt: 3,
//         mb: 4, // ⭐ Extra space added under each row
//         gap: 2,
//         position: "relative",
//         width: "100%",
//       }}
//     >
//       {/* DATE */}
//       <Box
//         sx={{
//           border: "2px solid #3C6BA5",
//           borderRadius: 2,
//           padding: "6px 12px",
//           width: 130,
//           fontWeight: 600,
//           textAlign: "center",
//         }}
//       >
//         {item.date}
//       </Box>

//       {/* SUBJECT FIELD */}
//       <Box sx={{ position: "relative", width: "100%" }}>
//         <TextField
//           value={item.subject}
//           size="small"
//           fullWidth
//           sx={{
//             borderRadius: "8px",
//           }}
//         />

//         {/* PREVIEW + EDIT - FIXED SPACING */}
//         <Box
//           sx={{
//             position: "absolute",
//             right: 10,
//             bottom: -28, // ⭐ More bottom space for clean alignment
//             display: "flex",
//             gap: 3, // little more gap
//           }}
//         >
//           <Typography
//             sx={{
//               fontSize: "14px",
//               color: "#3C6BA5",
//               cursor: "pointer",
//             }}
//             onClick={() => handleOpenModal(selectedCandidateId)}
//           >
//             Preview
//           </Typography>

//           <Typography
//             sx={{
//               fontSize: "14px",
//               color: "#3C6BA5",
//               cursor: "pointer",
//             }}
//             onClick={() => handleOpenModal(selectedCandidateId)}
//           >
//             Edit
//           </Typography>
//         </Box>
//       </Box>

//       {/* SWITCH */}
//       <Switch
//         checked
//         onChange={() =>
//           handleSwitchChange({
//             scheduleId: item.scheduleId,
//             emailOrder: item.emailOrder,
//           })
//         }
//       />
//     </Box>
//   ))}







// </Box>
//        </Modal>


























//              <Modal open={emailModalOpen2} onClose={handleEmailModalClose2}>
//                <Box
//     sx={{
//       position: "absolute",
//       top: "50%",
//       left: "50%",
//       transform: "translate(-50%, -50%)",
//       width: 650,
//       bgcolor: "white",
//       borderRadius: 3,
//       p: 3,
//       boxShadow: 24,
//       border: "2px solid #1A73E8",
//     }}
//   >
//     {/* HEADER */}
//     <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
//       <Typography
//         variant="h5"
//         sx={{ fontWeight: 600, color: "#1A73E8", textAlign: "center", width: "100%" }}
//       >
//         Scheduled Emails
//       </Typography>



//            <Button
//   variant="contained"
//   sx={{
//     background: "#1A73E8",
//     borderRadius: "8px",
//     height: 38,
//     textTransform: "none",
//     ":hover": { background: "#1559b2" },
//   }}
//   onClick={emailDeleteAllOpenModal}
// >
//   Delete All
//           </Button>




//     </Box>

//     <hr />

//     {/* EMAIL LIST */}
//     {emails2.map((item, index) => (
//       <Box
//         key={index}
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           mt: 2,
//           justifyContent: "space-between",
//         }}
//       >
//         {/* DATE BOX */}
//         <Box
//           sx={{
//             border: "2px solid #1A73E8",
//             borderRadius: 2,
//             padding: "6px 12px",
//             width: "130px",
//             textAlign: "center",
//             fontWeight: 600,
//           }}
//         >
//           {item.date}
//         </Box>

//         {/* SUBJECT INPUT */}
//         <TextField
//           value={item.subject}
//           size="small"
//           fullWidth
//           sx={{
//             mx: 2,
//             borderRadius: "8px",
//           }}
//         />

//         {/* Preview & Edit TEXT */}
//         <Box sx={{ display: "flex", flexDirection: "column", mr: 2 }}>
//           <Typography
//             sx={{
//               fontSize: "14px",
//               color: "#1A73E8",
//               cursor: "pointer",
//             }}
//           >
//             Preview
//           </Typography>
//           <Typography
//             sx={{
//               fontSize: "14px",
//               color: "#1A73E8",
//               cursor: "pointer",
//             }}
//           >
//             Edit
//           </Typography>
//         </Box>

//         {/* SWITCH */}
//                <Switch
//                checked
//                onChange={() => handleSwitchChange({
//                scheduleId: item.scheduleId,
//                emailOrder: item.emailOrder
//   })}
// />
//       </Box>
//     ))}

//     {/* SAVE BUTTON */}

//                   {/* <Box sx={{ textAlign: "center", mt: 3 }}>
//       <Button
//         variant="contained"
//         sx={{
//           width: 140,
//           textTransform: "none",
//           background: "#1A73E8",
//           fontWeight: 600,
//           borderRadius: 2,
//         }}
//       >
//         Save
//       </Button>
//                   </Box> */}

//                </Box>
//               </Modal>







//   <Modal open={emailModalOpen2} onClose={handleEmailModalClose2}>
//   <Box
//     sx={{
//       position: "absolute",
//       top: "50%",
//       left: "50%",
//       transform: "translate(-50%, -50%)",
//       width: 700,
//       bgcolor: "white",
//       borderRadius: 3,
//       p: 3,
//       boxShadow: 24,
//       border: "2px solid #3C6BA5",
//     }}
//   >
//     {/* HEADER */}
//     <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
//       <Typography
//         variant="h5"
//         sx={{
//           fontWeight: 600,
//           color: "#3C6BA5",
//           textAlign: "center",
//           flex: 1,
//         }}
//       >
//         Scheduled Emails
//       </Typography>

//       <Button
//         variant="contained"
//         sx={{
//           background: "#3C6BA5",
//           borderRadius: "8px",
//           height: 38,
//           textTransform: "none",
//           ":hover": { background: "#3C6BA5" },
//         }}
//         onClick={emailDeleteAllOpenModal}
//       >
//         Delete All
//       </Button>
//     </Box>

//     <hr />

//     {/* EMAIL LIST */}
//     {emails2.map((item, index) => (
//       <Box
//         key={index}
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           mt: 3,
//           gap: 2,
//           position: "relative",
//           width: "100%",
//         }}
//       >
//         {/* DATE */}
//         <Box
//           sx={{
//             border: "2px solid #3C6BA5",
//             borderRadius: 2,
//             padding: "6px 12px",
//             width: 130,
//             fontWeight: 600,
//             textAlign: "center",
//           }}
//         >
//           {item.date}
//         </Box>

//         {/* SUBJECT FIELD */}
//         <Box sx={{ position: "relative", width: "100%" }}>
//           <TextField
//             value={item.subject}
//             size="small"
//             fullWidth
//             sx={{
//               borderRadius: "8px",
//             }}
//           />

//           {/* PREVIEW + EDIT EXACT POSITION */}
//           <Box
//             sx={{
//               position: "absolute",
//               right: 10,
//               bottom: -22,
//               display: "flex",
//               gap: 2,
//             }}
//           >
//             <Typography
//               sx={{
//                 fontSize: "14px",
//                 color: "#3C6BA5",
//                 cursor: "pointer",
//               }}
//                      onClick={() => handleOpenModal(selectedCandidateId)}
//             >
//               Preview
//             </Typography>

//             <Typography
//               sx={{
//                 fontSize: "14px",
//                 color: "#3C6BA5",
//                 cursor: "pointer",
//               }}
//                  onClick={() => handleOpenModal(selectedCandidateId)}
//             >
//               Edit
//             </Typography>
//           </Box>
//         </Box>

//         {/* SWITCH */}
//         <Switch
//           checked
//           onChange={() =>
//             handleSwitchChange({
//               scheduleId: item.scheduleId,
//               emailOrder: item.emailOrder,
//             })
//           }
//         />
//       </Box>
//     ))}
//   </Box>
//                </Modal>



























































const HEADER_MOBILE = 64;
const HEADER_DESKTOP = 92;

const HEADER_MOBILE1 = 150;
const HEADER_DESKTOP1 = 300;

const StyledSearchbar = styled('div')(({ theme }) => ({
  top: 0,
  left: 0,
  zIndex: 99,
  width: '100%',
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  height: HEADER_MOBILE,
  padding: theme.spacing(0, 3),
  // boxShadow: theme.customShadows.z8,
  [theme.breakpoints.up('md')]: {
    height: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

const ModalContent = styled('div')(({ theme }) => ({
  marginTop: '220px',
  width: '100%',
  display: 'flex',
  marginRight: '50px',

  height: HEADER_MOBILE1,
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.customShadows.z8,
  [theme.breakpoints.up('md')]: {
    height: HEADER_DESKTOP1,
    padding: theme.spacing(0, 5),
  },
}));

const StyledIconButtonWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 'bold',
});

function Search({ searchData, func, funcc, funnc, onData, resetSearch,
  onData1, onData2, setCheckBtnDis }) {
  const visalist = [
    { label: 'USC' },
    { label: 'GC' },
    { label: 'GCEAD' },
    { label: 'TN' },
    { label: 'H1B' },
    { label: 'H1b I 140 ' },
    { label: 'H4 EAD' },
    { label: 'OPT EAD' },
    { label: 'CPT EAD' },
    { label: 'E2 Visa' },
    { label: 'B 1 Visa' },
    { label: 'Canadian citizen' },
    { label: 'Open work permit' },
    { label: 'Permanent Resident' },
  ];

  const [open, setOpen] = useState(false);

  // const [formValues, setFormValues] = useState({
  //   // fullName: "",
  //   // email: "",
  //   // phone: "",
  //   commonSearch: "",
  //   jobId: '',
  //   jobTitle: [],
  //   skills: [],
  //   relocate: "",
  //   visaType: "",
  //   // location: "",
  //   // city: "",
  //   // state: "",
  //   // updatedAt: {
  //   //   from: "",
  //   //   till: ""
  //   // }
  //   // updated:"",
  //   duration: "",
  //   // distance: "",
  //   resource: ""
  // });
  // const [formValues1, setFormValues1] = useState({ commonSearch: "" });

  // const [formValues, setFormValues] = useState({
  //   commonSearch: "",
  //   jobTitle: [],
  //   skills: [],
  //   relocate: "",
  //   visaType: "",
  //   duration: "",
  //   resource: ""
  // });


  const [formValues, setFormValues] = useState(() => {
  const savedData = localStorage.getItem("advancedSearchData");

  return savedData
    ? JSON.parse(savedData)
    : {
        commonSearch: "",
        jobId: '',
        jobTitle: [],
        skills: [],
        relocate: "",
        visaType: "",
        duration: "",
        resource: "",
      };
});

  const [formValues1, setFormValues1] = useState(localStorage.getItem("searchData")?{ commonSearch: localStorage.getItem("searchData")}:{ commonSearch: "" });


  const [userdata, setUserdata] = useState([])

  // console.log("userdata ====>>>>>>", userdata)
  // useEffect(() => {
  //   allUsers()
  // }, []);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  // const emails2 = [
  //   { date: "Nov 23, 2025", subject: "Sub: Re: Need Seasoned Recruiters ?" },
  //   { date: "Nov 26, 2025", subject: "Sub: Re: Need Seasoned Recruiters ?" },
  //   { date: "Nov 25, 2025", subject: "Sub: Re: Need Seasoned Recruiters ?" },
  //   { date: "Nov 27, 2025", subject: "Sub: Re: Need Seasoned Recruiters ?" },
  // ];
  // const handleSkillsChange = (e) => {

  //   const skillsArray = e.target.value.split(',').map((skill) => skill.trim());
  //   setFormValues({ ...formValues, skills: skillsArray });
  // };

  const toggleVisibility = () => {
    setValue(localStorage.getItem("country"))
    resetSearch()
    // setIsVisible(!isVisible); 
    func()
    setFormValues1({ ...formValues1, commonSearch: '' });
    setFormValues({
      ...formValues,
      commonSearch: '',
      jobTitle: [],
      jobId: '',
      skills: [],
      relocate: '',
      visaType: '',
      // city: '',
      // state: '',
      // duration: { unit: "", amount: "1" },
      duration: "",
      // distance: '',
      unit: '',
      amount: '',
      resource: ''
    });
    setCityQuery('')
    setStateQuery('')
    // setFormValues({ ...formValues, commonSearch: '' });
    // setFormValues({ ...formValues, commonSearch: '' });
    // setFormValues({ ...formValues, commonSearch: '' });
    // setFormValues({ ...formValues, commonSearch: '' });
    // setFormValues({ ...formValues, commonSearch: '' });
    // setFormValues({ ...formValues, commonSearch: '' });
    // setFormValues({ ...formValues, commonSearch: '' });
    // setFormValues({ ...formValues, commonSearch: '' });
    // setFormValues({ ...formValues, commonSearch: '' });
  };

  // console.log("unit", formValues.unit);
  // console.log("amount", formValues.count)

  const [loadingData, setLoadingData] = useState('')
  const fn = (page = 1) => {
    searchData('')
    // console.log("fn click")
    setLoading(true);
    setLoadingData('Loading...')
    // searchData('', '', '')
    const token = localStorage.getItem('token');
    const body = {
      "commonSearch": formValues.commonSearch,
      "jobTitle": formValues?.jobTitle,
      "jobId": formValues?.jobId ,
      "skills": formValues.skills,
      "relocate": formValues.relocate,
      "visaType": formValues.visaType,
      // "location": formValues.location,
      // "city": formValues.city,
      // "state": formValues.state,
      "city": cityQuery,
      // "state": stateQuery,
      ...(stateQuery && !cityQuery ? { "state": stateQuery } : {}),
      // "updatedAt": {
      //   // "from":fromDate,
      //   // "till": tillDate 
      //   "from": fromDate,
      //   "till": tillDate,
      // } 
      // "updated":formValues.updated,
      "stateCode": stateCode || stateId,
      "duration": {
        "unit": formValues.unit,
        "amount": formValues.amount,
        // "unit": formValues.duration,
        // "amount": "1",
      },

      // "distance": formValues.distance,
      "resource": formValues.resource,
      "page": page,
      "limit": "35",
      "country": valuee
    }
    Api('common/search/cv', 'POST', body, token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setLoading(false);
            const totalPage = Math.ceil(response.data?.count / 35)
            searchData(response.data.data, response.data.count, totalPage)
            setLoadingData('');
            // console.log("response.data.data", response.data.data)
          } else {
            // console.log('Error:', response.data.message);
          }
          // handleClose()
          // func()
          handleSearchClose()
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  // console.log("loadingData", loadingData)
  const handleUnitChange = (e) => {
    const selectedUnit = e.target.value;
    setFormValues({
      ...formValues,
      duration: {
        ...formValues.duration,
        unit: selectedUnit
      }
    });
  };

  const [skillLst, setSkillLst] = useState([]);
  // const [finallst, setFinallst] = useState([]);

  useEffect(() => {
    getSkills();
  }, []);

  const getSkills = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await Api(`resume/get_skills/${"other"}`, 'GET', '', token);

      if (response.data.code === 200) {
        const skillsData = response.data.result;
        const updatedSkills = skillsData.map((item) => ({ title: item.skillName }));
        setSkillLst(updatedSkills);
        // console.log('Updated Skills:', updatedSkills);
      } else {
        setSkillLst([{ title: '' }]);
        toast.warn(response.data.message);
      }
    } catch (error) {
      // console.error('Error fetching skills:', error);
      toast.error('Failed to fetch skills!');
    }
  };

  // console.log("skillLst", skillLst)
  const searchfn = (page = 1) => {
    searchData('')
    // searchData([''])
    // setLoading(true);
    setLoading1(true)
    const body = {
      "commonSearch": formValues1.commonSearch,
      "page": page,
      "limit": "50",

    }
    const token = localStorage.getItem('token');
    Api('common/search/cv', 'POST', body, token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            const totalPage = Math.ceil(response.data.count / 50)
            searchData(response.data.data, response.data.count, totalPage)
            setLoading1(false);

          } else {
            // console.log('Error:', response.data.message);
          }
          handleClose()
          // func()
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };


  const allUsers = () => {
    const token = localStorage.getItem('token');
    const endpoint = localStorage.getItem("resource") === "resource" ? "IDP" : "RC";

    Api(`common/users/${endpoint}`, 'GET', '', token)
      // Api('common/users/RC', 'GET', '', token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setUserdata(response.data.data);
          } else {
            // console.log('Error:', response.data.message);
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  // const defaultRelocateValue ='yes'
  const handleJobTitleChange = (event, newValue) => {
    let updatedJobTitles = [];

    if (newValue && newValue.length > 0) {
      const lastItem = newValue[newValue.length - 1];
      if (typeof lastItem === 'string') {
        updatedJobTitles = [...newValue.slice(0, -1), lastItem];
      } else {
        updatedJobTitles = newValue;
      }
    }

    setFormValues({ ...formValues, jobTitle: updatedJobTitles });
  };

  const isAnyFieldFilled = (
    // formValues1.commonSearch || 
    formValues.commonSearch ||
    formValues.jobTitle ||
    formValues.skills ||
    formValues.relocate ||
    formValues.visaType ||
    // formValues.city ||
    // formValues.state ||
    // formValues.duration || 
    // formValues.distance ||
    formValues.resource
  );

  // const isDisabled = 
  //   !formValues.commonSearch ||
  //   !formValues1.commonSearch ||
  //   !formValues.jobTitle ||
  //   !formValues.skills ||
  //   !formValues.relocate ||
  //   !formValues.visaType ||
  //   !formValues.city ||
  //   !formValues.state ||
  //   !formValues.duration ||
  //   !formValues.distance ||
  //   !formValues.resource;


  const [searchOpen, setSearchOpen] = useState(false);

  const handleSearchOpen = () => {
    setSearchOpen(true);
  };

  const handleSearchClose = () => {
    setSearchOpen(false);
  };

  const [dist, setDistance] = useState('')
  const [latt, setLatt] = useState('')
  const [long, setLong] = useState('')
  const [valuee, setValue] = useState(localStorage.getItem("country"));
  const [cityData, setCityData] = useState([]);
  const [cityQuery, setCityQuery] = useState("");
  const [cityAndState, setCityAndState] = useState(null);
  const [stateCode, setStateCode] = useState('')

  // console.log("cityData", cityData)
  // console.log("cityQuery===>>>", cityQuery)
  // console.log("cityAndState", cityAndState)

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  // const handleCityChange = async (val) => {
  //   setCityData([])
  //   console.log("val==", val)
  //   setCityQuery(val);
  //   // await getCity(val);
  //   if (val.length >= 3) { getCity(val);
  //   }
  // }; 

  const [err, setErr] = useState(false);
  const [helperText, setHelperText] = useState('');
  const getCity = async (val) => {
    setHelperText('')
    setErr(false)
    const token = localStorage.getItem('token');
    const body = {
      country: valuee || localStorage.getItem("country"),
      query: val,
    };
    try {
      const response = await Api('resume/get_city_states', 'POST', body, token);
      if (response.status === 200 && response.data.code === 200) {
        setCityData(response.data.data || []);
        // console.log("response.data.data", response.data.data)
        // const Newdata = response.data.data
        // if (Newdata.length > 0) {
        //   const selectedCity = Newdata[0];
        //   // setLatt(selectedCity.lat);
        //   // setLong(selectedCity.lng);
        //   // setStateQuery(selectedCity.state);
        //   // setStateCode(selectedCity.stateCode)
        // } else {
        //   console.log('No city data found');
        //   setCityAndState(null);
        //   setLatt('');
        //   setLong('');
        // }
      } else {
        console.error(response.data.message);
        // toast.error(response.data.message)
        setHelperText("No cities found for the given city name.")
        setErr(true)
        setCityData([]);
      }
    } catch (err) {
      console.error(err);
      setCityData([]);
    }

  };
  // const [cityy, setCityy]= useState()

  const childFuc = (val) => {
    setCityData([])
    // console.log("vall===", val)
    if (typeof (val) === "string") {
      // console.log("val", val)
      // alert("USA")
      if (val.length >= 3) {
        getCity(val);
      }

      setCityQuery(val);
      // handleCityChange(val);
    }
    else {
      // alert("CAN") 
      if (val.city.length >= 3) {
        getCity(val.city);
      }
      setStateQuery(val?.state)
      setCityQuery(val?.city);
      // handleCityChange(val.city);
      setLatt(val?.lat);
      setLong(val?.lng);
      setStateCode(val?.stateCode || val?.postal)
    }
    // setStateQuery(val.state)
    // setCityy(val)
    // const selectedCity = cityData.find(city => city && city.name === val);
    // console.log("selectedCity===>>>", selectedCity)
    // if (selectedCity) {
    //   setCityAndState(selectedCity);
    // } else {
    //   setCityAndState(null);
    // }
  };

  const [stateData, setStateData] = useState([]);
  const [stateQuery, setStateQuery] = useState("");
  const [stateId, setStateId] = useState("");
  const [selectedState, setSelectedState] = useState(null);


  const handleStateChange = async (val) => {

    setStateQuery(val?.state_name || val?.province_or_StateName);
    setStateId(val?.state_id || val?.province_id)
  
    if (val.length >= 3) {
      await getState(val);
    }
  };

  const getState = async (val) => {
    const token = localStorage.getItem('token');
    const body = {
      country: valuee,
      stateName: val,
    };
    try {
      const response = await Api('resume/get_states', 'POST', body, token);
      if (response.status === 200 && response.data.code === 200) {
        setStateData(response.data.data || []);

      } else {
        console.error(response.data.message);
        setStateData([]);
      }
    } catch (err) {
      console.error(err);
      setStateData([]);
    }
  };

  const childFucState = async (val) => {
    // console.log("stateval", val)
    setStateQuery(val?.state_name || val?.province_or_StateName);
    handleStateChange(val);

    //   if (stateData.includes(val)) {
    //     setSelectedState(val);
    //   } else {
    //     setSelectedState(null);
    //   } 
  };

  // console.log("latt==>>", latt)
  // console.log("long==>>", long)
  // console.log("dist==>>", dist)

  const searchDis = async (page = 1) => {
    const token = localStorage.getItem('token');
    searchData('')
    const body = {
      "center": [long, latt],
      "radiusInMiles": dist,
      "page": page,
      "limit": "50",
      "country": valuee
    };
    try {
      const response = await Api('common/search/cv', 'POST', body, token);
      if (response.status === 200 && response.data.code === 200) {
        // setStateData(response.data.data || []); 
        const totalPage = Math.ceil(response.data.count / 50)
        searchData(response.data.data, response.data.count, totalPage)
        handleSearchClose()
      } else {
        console.error(response.data.message);
        // setStateData([]);       
      }
    } catch (err) {
      console.error(err);
      // setStateData([]); 
    }
  };

  const handleSearch = () => {
    if (dist) {
      searchDis();
      setDistance('')
      // setStateQuery('')
      // setCityQuery('')
      // setValue('')
      setStateCode('')

    } else {
      setStateCode('')
      fn();
      setDistance('')
      // setStateQuery('')
      // setCityQuery('')
      // setValue('')
    }
  };

  const clearInputField = () => {


      localStorage.removeItem("advancedSearchData");

    setFormValues({
      ...formValues,
      commonSearch: '',
      jobTitle: [],
      skills: [],
      relocate: '',
      visaType: '',
      // city: '',
      // state: '',
      // duration: { unit: "", amount: "1" },
      duration: "",

      // distance: '',
      resource: '',
      unit: "",
      amount: "",
    });
    setCityQuery('')
    setStateQuery('')
    setDistance('')
    setStateCode('')
    setValue(localStorage.getItem("country"))
  }

  const [cityStateStyling, setCityStateStyling] = useState(false)

  const sendDataToParent = () => {
    onData(clearInputField);
  };

  // const funn = (page) =>{
  //   fn(page)
  // }
  const sendDataToParent1 = () => {
    onData1(fn, loadingData);
  };

  const [pageNumber, setPageNumber] = useState(1)
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);

  const sendDataToParent2 = () => {
    onData2(pageNumber);
  };
   const savedSearch = localStorage.getItem('worksheetSearchState');

   useEffect(() => {
  localStorage.setItem(
    "advancedSearchData",
    JSON.stringify(formValues)
  );
}, [formValues]);


  const [joblst, setJoblst] = useState([]);
   const GetJobId = () => {
    const id = localStorage.getItem('userid');
    const token = localStorage.getItem('token');
    Api(`company/active_jobs`, 'GET', '', token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === 200) {
            setJoblst(response.data.data);
          }
        }
      })
      .catch((err) => { });
  };

  useEffect(() => {

    GetJobId();
  }, [])

  return (
    <>
      {/* <ResumeRow pinned={pinned}/> */}
      {/* <ClickAwayListener onClickAway={handleClose}> */}
      <>

        {/* {!open && (
          <IconButton onClick={handleOpen}>
            <Iconify icon="eva:search-fill" sx={{ color: 'text.primary', width: 30, height: 30 }} />
          </IconButton>
        )} */}

        <div className='mob_search'>
          <Paper
            component="form"
            sx={{
              // p: '2px 4px',
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              border: '1px solid #1E74B3',
              borderRadius: '10px',
              marginTop: -18,
            }}
          >
            {/* <IconButton sx={{ p: '0.1px', ml: "7px", mr: "4px" }}>
              <Iconify icon="eva:search-outline"
              />
            </IconButton> */}
            <InputBase
              sx={{ flex: 1, color: 'text.primary', border: 'none', outline: 'none', pl: 1 }}
              placeholder="Name | Email | Phone Number"
              inputProps={{ 'aria-label': 'search' }}
              value={formValues1.commonSearch}
              onChange={(e) => {
                setFormValues1({ ...formValues1, commonSearch: e.target.value });
                // if (formValues1.commonSearch.length >= 3) {
                //   searchfn(); 
                //   funcc(); 
                // }
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                   localStorage.setItem("searchData", formValues1.commonSearch);
                  e.preventDefault();
                  searchfn();
                  funcc();
                  sendDataToParent1()
                }
              }}
            />
          </Paper>
          {/* <Button style={{ marginLeft: '16px', color: 'white', backgroundColor: '#1E74B3', borderRadius: '10px', marginTop: '4px', height: '41px', width: '130px' }} onClick={fn}>Search</Button> */}
          <Button color="custom" variant="contained" size="small" sx={{ ml: 1.6, mt: -18 }}
            // disabled={formValues1.commonSearch === ''}
            disabled={loading1}
            onClick={() => {     
              searchfn(); funcc(); setCheckBtnDis(true) 
              localStorage.setItem("searchData", formValues1.commonSearch); }}>
            {/* Search */}
            {loading1 ? <CircularProgress size={24} /> : 'Search'}
          </Button>
          {(
            savedSearch ||
            formValues?.commonSearch ||
            formValues1?.commonSearch ||
            formValues?.jobTitle.length > 0 ||
            formValues?.skills.length > 0 ||
            formValues?.relocate ||
            formValues?.visaType ||
            // formValues?.city ||
            // formValues?.state ||
            // (formValues.duration && (formValues.duration.unit || formValues.duration.amount)) ||
            formValues?.duration ||
            // formValues?.distance ||
            formValues?.unit ||
            formValues?.amount ||
            formValues?.resource ||
            // valuee?.country
            cityQuery || stateQuery
          ) && (
              <Button color="custom" variant="contained" size="small" sx={{ ml: 1.6, mt: -18 }}
                onClick={() => { 
                        localStorage.removeItem("searchData");
                  toggleVisibility(); funnc(); sendDataToParent2(); setCheckBtnDis(false) }}>
                Close
              </Button>
            )}

        </div>

        {/* <StyledIconButtonWrapper onClick={handleSearchOpen}> */}
        <StyledIconButtonWrapper onClick={() => {
          handleSearchOpen(); setCityStateStyling(true);
          sendDataToParent()
        }}>

          <IconButton className='morFiltr'>
            <Iconify
              icon="bxs:down-arrow"
              color="#1E74B3"
            />
          </IconButton>
        </StyledIconButtonWrapper>

        <Modal open={searchOpen} onClose={handleSearchClose}>

          <Box className="morFltr_pop" sx={{
            position: 'absolute',
            top: '36%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '95%', sm: '70%' },
            // width: { xs: '85%', sm: '60%' },
            bgcolor: 'background.paper',
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 2,
            borderRadius: 3,
          }}
          >

            {/* <ClickAwayListener> */}
            {/* <Slide direction="down" in={open} mountOnEnter unmountOnExit > */}

            {/* <StyledSearchbar > */}
            {/* <StyledInput
              autoFocus
              fullWidth
              disableUnderline
              placeholder="Search…"
              startAdornment={
                <InputAdornment position="start">
                  <Iconify icon="eva:search-fill" sx={{ color: 'text.primary', width: 30, height: 30 }} />
                </InputAdornment>
              }
              sx={{ mr: 1, fontWeight: 'fontWeightBold' }}
            /> */}
            {/* <ModalContent

                sx={{
                  marginTop: '28%',
                  border: '1px solid #1E74B3',
                  // padding: '15px',
                  // maxWidth: 'auto',
                  maxWidth: '60%',
                  // maxHeight: 'auto',
                  marginLeft: '76px',
                  maxHeight: '300%',
                  marginRight: '66px'
                  // margin: 'auto', 
                }}> */}

            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={6}>
                <TextField
                  label="Name | Email | Phone Number"
                  variant="outlined"
                  fullWidth
                  margin="dense"
                  size="small"
                  value={formValues.commonSearch}
                  onChange={(e) => setFormValues({ ...formValues, commonSearch: e.target.value })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleSearch();
                      funcc();
                      // alert("hi")
                    }

                  }}
                />
              </Grid>
           
               <Grid item xs={6} sx={{ mt: '8px' }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Job Id</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    // variant="outlined"
                    fullWidth
                      margin="dense"
                  size="small"
                    value={formValues.jobId}
                    label="Job Id"
                    // onChange={(e) => setValue({ ...value, jobid: e.target.value })}
                    // onOpen={GetJobId}
                    onChange={(e) => {
                      // const selectedJob = joblst?.find(item => item?.jobId === e.target.value);
                      // setEndClientName(selectedJob?.endClientOrImpPartner);
                      // console.log("selectedJob", selectedJob?.endClientOrImpPartner)
                      setFormValues({ ...formValues, jobId: e.target.value })
                    }}
                  >
                    <MenuItem value={'NA'}>NA</MenuItem>
                    {joblst?.map((item, index) => {
                      return <MenuItem key={index} value={item.jobId}>{item.jobId}</MenuItem>;
                    })}
                  </Select>
                  </FormControl>
                </Grid>

              <Grid item xs={4}>
                <Autocomplete
                  multiple
                  size="small"
                  id="job-title-autocomplete"
                  options={formValues.jobTitle}
                  value={formValues.jobTitle}
                  onChange={(e, newValue) => setFormValues({ ...formValues, jobTitle: newValue })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleSearch();
                      funcc();
                      // alert("hi")
                    }

                  }}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const inputValue = params.inputValue.trim().toLowerCase();

                    if (inputValue !== '' && !options.some((option) => option.toLowerCase() === inputValue)) {
                      options.push(inputValue);
                    }

                    return options.filter((option) =>
                      option.toLowerCase().includes(inputValue)
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Job Titles"
                      variant="outlined"
                      fullWidth
                      size="small"
                      placeholder="Search or enter job titles"
                    />
                  )}
                />
              </Grid>
              {/* <Grid item xs={6}>
                  <TextField
                    label="Skills"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    size="small"
                    value={formValues.skills.join(',')} 
                    onChange={handleSkillsChange} 

                    // InputProps={{
                    //   placeholder: 'Skills', // Placeholder text
                     
                    //   style: {
                    //     height: '31px',
                    //     borderRadius: '4px',
                    //     paddingLeft: '5px',
                    //     // color: '#1E74B3'
                    //   },
                    // }}
                  />
                </Grid> */}

              <Grid item xs={4} sx={{ marginTop: "1px" }}>
                <Autocomplete
                  multiple
                  id="tags-outlined"
                  size="small"
                  options={skillLst}
                  getOptionLabel={(option) => option.title}
                  onChange={(event, newValue) => {
                    const skillsOnly = newValue.map((item) => item.title);
                    setFormValues({ ...formValues, skills: skillsOnly });

                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleSearch();
                      funcc();
                      // alert("hi")
                    }

                  }}
                  value={formValues.skills.map((skill) => ({ title: skill }))}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = options.filter((option) =>
                      option.title.toLowerCase().includes(params.inputValue.toLowerCase())
                    );

                    const { inputValue } = params;
                    if (inputValue !== '' && !options.some((option) => option.title === inputValue)) {
                      filtered.push({ title: inputValue });
                    }

                    return filtered;
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Skills" placeholder="Select or type to add skills" />
                  )}
                />
              </Grid>

              <Grid item xs={4}>
                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel >Relocation</InputLabel>
                  <Select
                    // labelId="relocation-label"
                    label="Relocation"
                    value={formValues.relocate}
                    // onChange={(e) => setFormValues({ ...formValues, "Yes": "No" })}
                    onChange={(e) => setFormValues({ ...formValues, relocate: e.target.value })}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSearch();
                        funcc();
                        // alert("hi")
                      }

                    }}
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={4}>
                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel >Duration</InputLabel>
                  {/* <Select
                   
                    label="Duration"
                    value={formValues.duration}
                    onChange={(e) => setFormValues({ ...formValues, duration: e.target.value })}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSearch();
                        funcc();
                       
                      }

                    }}
                  >
                   <MenuItem value="days">1 Day</MenuItem>
                                       <MenuItem value="weeks">1 Week</MenuItem>
                                       <MenuItem value="1months">1 Month</MenuItem>
                                       <MenuItem value="3months">3 Month</MenuItem>
                                       <MenuItem value="6months">6 Month</MenuItem>
                                       <MenuItem value="years">1 Year</MenuItem>
                                       
                  </Select> */}

                  <Select
                    label="Duration"
                    value={formValues?.unit ? { unit: formValues?.unit, amount: formValues?.amount } : {}}
                    onChange={(e) => setFormValues({ ...formValues, ...e.target.value })}
                    renderValue={(selected) => {
                      if (selected && selected?.unit && selected?.amount !== undefined) {
                        const { unit, amount } = selected;
                        if (unit === 'days') return `${amount} Day${amount > 1 ? 's' : ''}`;
                        if (unit === 'weeks') return `${amount} Week${amount > 1 ? 's' : ''}`;
                        if (unit === 'months') return `${amount} Month${amount > 1 ? 's' : ''}`;
                        if (unit === 'years') return `${amount} Year${amount > 1 ? 's' : ''}`;
                      }
                      return '';
                    }}
                  >
                    <MenuItem value={{ unit: 'days', amount: 1 }}>1 Day</MenuItem>
                    <MenuItem value={{ unit: 'weeks', amount: 1 }}>1 Week</MenuItem>
                    <MenuItem value={{ unit: 'months', amount: 1 }}>1 Month</MenuItem>
                    <MenuItem value={{ unit: 'months', amount: 3 }}>3 Months</MenuItem>
                    <MenuItem value={{ unit: 'months', amount: 6 }}>6 Months</MenuItem>
                    <MenuItem value={{ unit: 'years', amount: 1 }}>1 Year</MenuItem>
                  </Select>

                </FormControl>
              </Grid>

              <Grid item xs={4}>
                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel >Visa</InputLabel>
                  <Select
                    label="Visa"
                    // options={visalist}
                    // label="Visa"
                    value={formValues.visaType}
                    onChange={(e) => setFormValues({ ...formValues, visaType: e.target.value })}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSearch();
                        funcc();
                        // alert("hi")
                      }

                    }}
                  >
                    {visalist.map((item, index) => (
                      <MenuItem key={index} value={item.label}>
                        {item.label}
                      </MenuItem>
                    ))}

                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel >Resource</InputLabel>
                  <Select
                    // labelId="resource-label"
                    label="Resource"
                    value={formValues.resource}
                    onChange={(e) => setFormValues({ ...formValues, resource: e.target.value })}
                    onOpen={allUsers}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSearch();
                        funcc();
                        // alert("hi")
                      }

                    }}
                  >
                    {userdata.map((item, index) => (
                      <MenuItem key={index} value={item._id} style={{ color: item.status !== "active" ? "red" : "" }}>
                        {item.contactPersonName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={3}>
                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel>Select Country</InputLabel>
                  <Select
                    value={valuee}
                    // value={valuee.country}
                    onChange={handleChange}
                    label="Select Country"

                  >
                    {/* <MenuItem value="USA">USA</MenuItem>
                    <MenuItem value="CANADA">CANADA</MenuItem>
                     <MenuItem value={'INDIA'}>INDIA</MenuItem>; */}
                    {countries?.map((item) => (
                      <MenuItem key={item.id} value={item.country}>
                        {item.country}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={3} >
                <CustomCompleteWorksheet
                  // <CustomComplete
                  placeholder={'City'}
                  size="small"
                  option={cityData}
                  propVal={cityQuery}
                  childFuc={childFuc}
                  fetch={'state'}
                  cityStateStyling1={cityStateStyling}
                  err={err}
                  helperText={helperText}
                />

                {/* <FormControl fullWidth size="small">

                  {cityAndState && cityAndState.city && cityAndState.state ? (
                    <Stack sx={{ ml: 1, mb: 2, mt: -1, flexDirection: 'row' }}>
                      <Typography color="text.secondary" variant="body1">
                        {cityAndState.city},
                        {cityAndState.state}
                      </Typography>
                    </Stack>
                  ) : null}
                </FormControl> */}
              </Grid>

              {/* <Grid item xs={3}>
                <TextField
                  label="State"
                  variant="outlined"
                  fullWidth
                  // margin="dense"
                  size="small"
                  value={formValues.state}
                  onChange={(e) => setFormValues({ ...formValues, state: e.target.value })}
                />
              </Grid> */}


              <Grid item xs={3} size="small">
                <CustomComplete
                  placeholder={'State'}
                  size="small"
                  option={stateData}
                  propVal={stateQuery}
                  childFuc={childFucState}
                  cityStateStyling1={cityStateStyling}

                />

                <FormControl fullWidth size="small">
                  {selectedState ? (
                    <Stack sx={{ ml: 1, mb: 2, mt: -1, flexDirection: 'row' }}>
                      <Typography color="text.secondary" variant="body1">
                        {/* {selectedState.state_name} */}
                      </Typography>
                    </Stack>
                  ) : null}
                </FormControl>
              </Grid>


              <Grid item xs={3}>
                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel >Distance</InputLabel>
                  <Select
                    label="Distance"
                    // value={formValues.distance}
                    // onChange={(e) => setFormValues({ ...formValues, distance: e.target.value })}
                    value={dist}
                    onChange={(e) => setDistance(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSearch();
                        funcc();
                        // alert("hi")
                      }

                    }}
                  >
                    <MenuItem value="10">10 Miles</MenuItem>
                    <MenuItem value="20">20 Miles</MenuItem>
                    <MenuItem value="40">40 Miles</MenuItem>
                    <MenuItem value="50">50 Miles</MenuItem>
                    <MenuItem value="100">100 Miles</MenuItem>
                    <MenuItem value="500">500 Miles</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* <Grid item xs={3}>
                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel >Relocation</InputLabel>
                  <Select
                    // labelId="relocation-label"
                    label="Relocation"
                    value={formValues.relocate}
                    // onChange={(e) => setFormValues({ ...formValues, "Yes": "No" })}
                    onChange={(e) => setFormValues({ ...formValues, relocate: e.target.value })}
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </Select>
                </FormControl>
              </Grid> */}
              {/* <Grid item xs={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer sx={{mt:0.9 }} components={['DatePicker', 'DatePicker']}>
                      <DatePicker
                        label="From Date"
                        value={fromDate}
                        onChange={(newValue) => setFromDate(newValue)}
                       
                      // console.log("uncontrol date",newValue)}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer sx={{ }} components={['DatePicker', 'DatePicker']}>
                      <DatePicker
                        label="Till Date"
                        value={tillDate}
                        onChange={(newValue) => setTillDate(newValue)}
                        
                      // console.log("uncontrol date",newValue)}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Grid> */}

              <Grid item xs={6} textAlign="center" sx={{ marginTop: "-10px" }}>
                {/* <Button color="custom" variant="contained" onClick={handleClose} sx={{ marginRight: 7, borderRadius: '10px',marginBottom:'12px' }}>
                    Close
                  </Button> */}
                <Button color="custom" variant="contained" size="small" disabled={loading}
                  onClick={() => { handleSearch(); funcc(); sendDataToParent1(); setCheckBtnDis(true) }}
                // onKeyDown={(e) => {
                //   if (e.key === 'Enter') {
                //     e.preventDefault(); 
                //     handleSearch();
                //     funcc(); 
                //     alert("hi")
                //   }

                // }}
                >
                  {/* Search */}
                  {loading ? <CircularProgress size={24} /> : 'Search'}
                </Button>

                <Button color="custom" variant="contained" size="small"
                  sx={{ marginLeft: '12px' }}
                  onClick={clearInputField}>
                  Clear All
                </Button>

                {/* <Button color="custom" variant="contained" size="small" style={{ marginLeft: '22px' }} onClick={handleClose}>
                      Close
                    </Button> */}

              </Grid>
            </Grid>
          </Box>
        </Modal>

        {/* </ModalContent> */}
        {/* </StyledSearchbar> */}
        {/* </Slide> */}
        {/* </ClickAwayListener> */}
      </>
      {/* </ClickAwayListener> */}
    </>
  );
}





